webpackJsonp([1],{

/***/ "+qU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-group",on:{"click":_vm.onPagerClick}},[(_vm.pageCount > 0)?_c('div',{staticClass:"box box-page",class:{ 'box-active': _vm.currentPage === 1 }},[_vm._v("1")]):_vm._e(),_vm._v(" "),(_vm.showPrevMore)?_c('div',{staticClass:"box-ellipsis el-icon more btn-quickprev",class:[_vm.quickprevIconClass],on:{"mouseenter":function($event){_vm.quickprevIconClass = 'el-icon-d-arrow-left'},"mouseleave":function($event){_vm.quickprevIconClass = 'el-icon-more'}}}):_vm._e(),_vm._v(" "),_vm._l((_vm.pagers),function(pager){return _c('div',{staticClass:"box box-page",class:{ 'box-active': _vm.currentPage === pager }},[_vm._v(_vm._s(pager))])}),_vm._v(" "),(_vm.showNextMore)?_c('div',{staticClass:"box-ellipsis el-icon more btn-quicknext",class:[_vm.quicknextIconClass],on:{"mouseenter":function($event){_vm.quicknextIconClass = 'el-icon-d-arrow-right'},"mouseleave":function($event){_vm.quicknextIconClass = 'el-icon-more'}}}):_vm._e(),_vm._v(" "),(_vm.pageCount > 1)?_c('div',{staticClass:"box box-page",class:{ 'box-active': _vm.currentPage === _vm.pageCount }},[_vm._v(_vm._s(_vm.pageCount))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/VZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"confirm-fade"}},[(_vm.visible)?_c('div',{staticClass:"modal-mask confirm-main"},[_c('div',{staticClass:"mask-backdrop"}),_vm._v(" "),_c('div',{staticClass:"confirm-content"},[_c('p',{staticClass:"confirm-title"},[_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"small-title"},[_vm._v(_vm._s(_vm.smallTitle))]),_vm._v(" "),_c('div',{staticClass:"confirm-btn-group"},[(_vm.okBtn)?_c('button',{staticClass:"confirm-btn-ok",on:{"click":_vm.okEvent}},[_vm._v(_vm._s(_vm.okBtnTitle))]):_vm._e(),_vm._v(" "),(_vm.cancelBtn)?_c('button',{staticClass:"confirm-btn-cancle",on:{"click":_vm.cancelEvent}},[_vm._v(_vm._s(_vm.cancelBtnTitle))]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/ZLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scoreChart_vue__ = __webpack_require__("5AFk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b4b918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scoreChart_vue__ = __webpack_require__("RjME");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scoreChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b4b918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scoreChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0JoO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history_detail",staticStyle:{"margin-bottom":"45px"}},[_c('div',{staticClass:"history_detail_title"},[_c('p',[_vm._v("历史明细查询")]),_vm._v(" "),_c('a',{staticStyle:{"margin-left":"10px"},attrs:{"title":"低版本IE需手动加上.csv后缀"},on:{"click":_vm.exportHistory}},[_c('vue-button',{attrs:{"loading":_vm.exportLoading,"type":"blue","size":"small"}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"history_day_select"},[_c('p',[_vm._v("持股周期 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentday),expression:"currentday"}],staticClass:"day_select",on:{"click":_vm.charySelect,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentday=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.daySelect),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 天")])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactiontype === '2'),expression:"transactiontype === '2'"}],staticClass:"history_day_select"},[_c('p',[_vm._v("择时选项 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSignal),expression:"selectedSignal"}],staticClass:"day_select",on:{"click":_vm.charySelectTow,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSignal=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.marketSignals),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(_vm.signalData[item]))])}),0)]),_vm._v(" "),_c('div',{staticClass:"sd-toolbar_1"},[_c('div',{staticClass:"sd-toolbar_operabox_1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeStartDate),expression:"tradeStartDate"}],staticClass:"trade_detail_startDate_1",attrs:{"id":"history_detail_startDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeStartDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, '#F{$dp.$D(\'history_detail_endDate\')}', _vm.minDate)},"blur":_vm.startDatePoint,"input":function($event){if($event.target.composing){ return; }_vm.tradeStartDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"time-split"},[_vm._v(" 至 ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeEndDate),expression:"tradeEndDate"}],staticClass:"trade_detail_endDate_1",attrs:{"id":"history_detail_endDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeEndDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, _vm.maxDate, '#F{$dp.$D(\'history_detail_startDate\')}')},"blur":_vm.endDatePoint,"input":function($event){if($event.target.composing){ return; }_vm.tradeEndDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"history_detail_main"},[_vm._m(0),_vm._v(" "),_c('EasyScrollbar',{attrs:{"barOption":_vm.myBarOption}},[_c('div',{staticClass:"rolltable"},[_c('table',{attrs:{"cellspacing":"0"}},[_c('tbody',_vm._l((_vm.historyList),function(hist,index){return _c('tr',{class:(index + 1) % 2 === 0 ? 'gray' : ''},[_c('td',{attrs:{"width":"159"}},[_vm._v(_vm._s(hist.stock_code))]),_vm._v(" "),_c('td',{staticClass:"td-highlight",attrs:{"width":"159"},on:{"click":function($event){return _vm.codeLink(hist.stock_code)},"mouseenter":function($event){return _vm.debounceShowQuoteChart($event, hist)},"mouseleave":function($event){return _vm.hideQuoteChart(hist)}}},[_vm._v(_vm._s(hist.stock_name))]),_vm._v(" "),_c('td',{attrs:{"width":"160"}},[_vm._v(_vm._s(hist.start_date))]),_vm._v(" "),_c('td',{attrs:{"width":"160"}},[_vm._v(_vm._s(hist.status === 3 ? '持仓' : hist.end_date))]),_vm._v(" "),_c('td',{attrs:{"width":"120"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(hist.start_price)))]),_vm._v(" "),_c('td',{attrs:{"width":"120"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(hist.end_price)))]),_vm._v(" "),_c('td',{class:_vm._f("riseAndFallClass")(hist.profit),attrs:{"width":"200"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(hist.profit)))])])}),0)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"cellspacing":"0"}},[_c('thead',[_c('th',[_vm._v("股票代码")]),_vm._v(" "),_c('th',[_vm._v("股票简称")]),_vm._v(" "),_c('th',[_vm._v("买入时间")]),_vm._v(" "),_c('th',[_vm._v("卖出时间")]),_vm._v(" "),_c('th',[_vm._v("买入价")]),_vm._v(" "),_c('th',[_vm._v("卖出价")]),_vm._v(" "),_c('th',[_vm._v("单次收益率")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1EXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cumulativeIncomeChart__ = __webpack_require__("iZrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scoreChart__ = __webpack_require__("/ZLV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'cumulative-income': __WEBPACK_IMPORTED_MODULE_0__cumulativeIncomeChart__["a" /* default */],
        'score': __WEBPACK_IMPORTED_MODULE_1__scoreChart__["a" /* default */]
    },
    data: function data() {
        return {
            selectedSignal: '',
            detailContent: '',
            backtestContent: '',
            noticeList: ['盈利能力：策略的盈亏比越大，该项分值越高；', '选股能力：策略的成功率越大，该项分值越高；', '抗风险能力：策略的回撤越小，该项分值越高；', '稳定性：策略的波动越小，该项分值越高；', '绝对收益：策略的年化收益率越大，该项分值越高。']
        };
    },

    props: {
        strategyId: String,
        // 回测id
        backtestId: {
            type: String,
            required: true
        },
        daySelect: {
            type: Array,
            required: true
        },
        profitData: [Array, Object],
        transactiontype: String,
        maxWinrate: Array,
        maxAnnualyield: Array,
        signalData: Object,
        refresh: Boolean,
        marketSignals: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        hsData: {
            type: Array,
            required: true
        },
        scoreData: {
            type: Object,
            required: true
        }
    },
    computed: {
        currentProfitData: function currentProfitData() {
            return this.transactiontype === '2' ? this.profitData[this.selectedSignal] : this.profitData;
        },
        posileft: function posileft() {
            return (this.scoreData.count - this.scoreData.rank) / Math.max(1, this.scoreData.count - 1);
        },
        detailContentPoint: function detailContentPoint() {
            return this.$buriedPoint.strategyDetails.profitChart;
        },
        backtestContentPoint: function backtestContentPoint() {
            return this.$buriedPoint.strategyBacktest.profitChart;
        },
        defaultSelectedDay: function defaultSelectedDay() {
            var arr = [];
            if (this.transactiontype === '2') {
                if (this.selectedSignal === this.maxWinrate[1]) {
                    arr.push(this.maxWinrate[2]);
                }
                if (this.selectedSignal === this.maxAnnualyield[1] && arr.indexOf(this.maxAnnualyield[2]) < 0) {
                    arr.push(this.maxAnnualyield[2]);
                }
            } else {
                arr.push(this.maxWinrate[1]);
                if (this.maxWinrate[1] !== this.maxAnnualyield[1]) {
                    arr.push(this.maxAnnualyield[1]);
                }
            }
            return arr;
        }
    },
    created: function created() {
        this.init();
    },

    watch: {
        refresh: function refresh() {
            this.init();
        },
        backtestId: function backtestId() {
            this.init();
        }
    },
    methods: {
        charySelect: function charySelect() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.timingOption.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.timingOption);
            }
        },
        init: function init() {
            if (this.transactiontype === '2') {
                this.selectedSignal = this.marketSignals[0];
            }
        }
    },
    mounted: function mounted() {
        this.detailContent = document.getElementsByClassName('strategydetailmain')[0];
        this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0];
    }
});

/***/ }),

/***/ "1QJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-main"},[_c('span',{staticClass:"notice-icon",on:{"mouseenter":function($event){_vm.visible = true},"mouseleave":function($event){_vm.visible = false}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"notice-tip",style:({top: _vm.top + 'px'})},[_vm._l((_vm.list),function(item,index){return _c('p',[_vm._v(_vm._s(item))])}),_vm._v(" "),_c('span')],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "29jA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lib_pagination__ = __webpack_require__("yxDY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_lib_loading__ = __webpack_require__("TAD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_lib_button__ = __webpack_require__("LqjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_lib_notice_tip__ = __webpack_require__("LrGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tipVue__ = __webpack_require__("eKWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__confirmVue__ = __webpack_require__("TSZI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clickOutside__ = __webpack_require__("E3iP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dataValidation__ = __webpack_require__("sCmD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__axiosConfig__ = __webpack_require__("AujI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filter__ = __webpack_require__("pFGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__staticText__ = __webpack_require__("JCAA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buriedPoint__ = __webpack_require__("JRkc");
// @charset "utf-8";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import dialog from '@/components/lib/dialog'

// import select from '@/components/lib/select'
// import multibox from '@/components/lib/multibox'
// import selectinput from '@/components/lib/selectinput'




// import empty from '@/components/lib/empty'





// import './HighchartsConfig'




// Vue.config.productionTip = false
// Vue.component('vue-dialog', dialog)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-pagination', __WEBPACK_IMPORTED_MODULE_1__components_lib_pagination__["a" /* default */]);
// Vue.component('vue-select', select)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-loading', __WEBPACK_IMPORTED_MODULE_2__components_lib_loading__["a" /* default */]);
// Vue.component('vue-empty', empty)
// Vue.component('vue-multibox', multibox)
// Vue.component('vue-selectinput', selectinput)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-button', __WEBPACK_IMPORTED_MODULE_3__components_lib_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-notice-tip', __WEBPACK_IMPORTED_MODULE_4__components_lib_notice_tip__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$tip = __WEBPACK_IMPORTED_MODULE_5__tipVue__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$staticText = __WEBPACK_IMPORTED_MODULE_11__staticText__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$buriedPoint = __WEBPACK_IMPORTED_MODULE_12__buriedPoint__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_6__confirmVue__["a" /* default */];

// 中央事件总线
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$Bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
// /* eslint-disable no-unused-vars */
// Vue.prototype.goCode = (code) => {
//     try {
//         // 验证是否有客户端
//         var gHexinApiQuote = external.createObject('Quote')

//         let stock = code.slice(0, 6)
//         let url = "hxa://hexin.exe 'opt=13&param=" + stock + "'"
//         location.href = url
//     } catch (exp) {
//         Vue.prototype.$tip({message: '该功能需要客户端支持', type: 'warning'})
//     }
// }

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.codeLink = function (stockCode) {
    var stock = stockCode.slice(0, 6);
    try {
        /* eslint-disable no-unused-vars */
        var hexinApi = external.createObject('Quote');
        location.href = "hxa://hexin.exe 'opt=13&param=" + stock + "'";
    } catch (exp) {
        window.open('//x.10jqka.com.cn/stockpick/search?tid=stockpick&qs=stockpick_diag&ts=1&w=' + stock);
    }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('click-outside', __WEBPACK_IMPORTED_MODULE_7__clickOutside__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('validate', __WEBPACK_IMPORTED_MODULE_8__dataValidation__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$mousemoveEvent = null;
document.body.addEventListener('mousemove', function (event) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$mousemoveEvent = event;
}, false);

/***/ }),

/***/ "2Eis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// @charset "utf-8"
function _IEVersion() {
    var iev = 0;
    var ieold = /MSIE (\d+\.\d+);/.test(navigator.userAgent);
    var trident = !!navigator.userAgent.match(/Trident\/7.0/);
    var rv = navigator.userAgent.indexOf('rv:11.0');

    if (ieold) {
        iev = Number(RegExp.$1);
    }
    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
        iev = 10;
    }
    if (trident && rv !== -1) {
        iev = 11;
    }

    return iev;
}

function _isEdge() {
    return (/Edge\/12/.test(navigator.userAgent)
    );
}

function exportCSV(tableStr, filename) {
    var ieVersion = _IEVersion();
    if (ieVersion && ieVersion < 10) {
        // ie < 10
        var win = window.top.open('about:blank', '_blank');
        win.document.write(tableStr);
        win.document.close();
        win.document.execCommand('SaveAs', true, filename);
        win.close();
    } else if (ieVersion || _isEdge()) {
        // ie >= 10 edge
        var csvData = new Blob(['\uFEFF' + tableStr], { type: 'text/csv' });
        navigator.msSaveBlob(csvData, filename + '.csv');
    } else {
        // chrome firefox ...
        var aDom = document.createElement('a');
        document.body.appendChild(aDom);
        var csvContent = 'data:attachment/csv;charset=utf-8,\uFEFF' + encodeURIComponent(tableStr);
        aDom.href = csvContent;
        aDom.download = filename + '.csv';
        aDom.click();
        document.body.removeChild(aDom);
    }
}

/* harmony default export */ __webpack_exports__["a"] = (exportCSV);

/***/ }),

/***/ "3dFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quote_chart_vue__ = __webpack_require__("IpBl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d7f963_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quote_chart_vue__ = __webpack_require__("x5JV");
function injectStyle (ssrContext) {
  __webpack_require__("Yg3b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64d7f963"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quote_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d7f963_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quote_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4iDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'footer',
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ "531N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("dy74");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bc94ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SXK4");
function injectStyle (ssrContext) {
  __webpack_require__("wy+K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08bc94ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08bc94ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "53yQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'feedback',
    data: function data() {
        return {
            isTextShow: false,
            isFormShow: false,
            formContent: '',
            formTel: '',
            isContentNotice: false,
            contentLength: '',
            isSendSpit: false,
            spitBadList: ['内容不详细', '数据有问题', '规则不合理', '功能不好用', '界面不好看']
        };
    },
    created: function created() {},

    filters: {
        limitlength: function limitlength(num) {
            if (Number(num) <= 150) {
                return Number(num);
            } else {
                return 150;
            }
        }
    },
    methods: {
        isShowForm: function isShowForm() {
            this.isFormShow = !this.isFormShow;
            this.formContent = '';
            this.formTel = '';
            this.isSendSpit = false;
        },
        isNoShowForm: function isNoShowForm() {
            this.isFormShow = false;
        },
        addContent: function addContent(val) {
            var reg = new RegExp(val);
            if (!reg.test(this.formContent)) {
                this.formContent += val + ',';
            }
            if (this.formContent.length > 150) {
                this.formContent = this.formContent.substr(0, 150);
            }
            this.$refs.form_content.focus();
        },
        formCheck: function formCheck() {
            if (this.formContent.length > 0) {
                this.isContentNotice = false;
            }
        },
        submitSpit: function submitSpit() {
            var _this = this;

            var self = this;
            if (this.formContent.length === 0) {
                this.isContentNotice = true;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/feedback', {
                    message: this.formContent,
                    contact: this.formTel
                }).then(function (res) {
                    if (!res.data.errorcode) {
                        _this.isSendSpit = true;
                    }
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            }
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "556f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5AFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        scoreData: {
            type: Object,
            required: true
        },
        refresh: Boolean
    },
    computed: {
        seriesData: function seriesData() {
            return {
                indicators: [{ name: '选股能力', max: 20 }, { name: '绝对收益', max: 20 }, { name: '盈利能力', max: 20 }, { name: '抗风险能力', max: 20 }, { name: '稳定性', max: 20 }],
                data: [this.scoreData.winRate, this.scoreData.annualYield, this.scoreData.averageLossRatio, this.scoreData.maxDrawDown, this.scoreData.profitVolatility]
            };
        }
    },
    methods: {
        renderChart: function renderChart() {
            var chartDom = this.$refs.chart;
            if (!chartDom) return;

            var myChart = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(chartDom);

            var option = {
                backgroundColor: 'transparent',
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(48, 63, 159, 0.9)',
                    borderColor: '#303f9f',
                    borderWidth: 1,
                    textStyle: {
                        color: '#fff',
                        fontSize: 12
                    },
                    padding: [6, 10],
                    formatter: function formatter(params) {
                        var value = params.value;

                        var indicatorNames = ['选股能力', '绝对收益', '盈利能力', '抗风险能力', '稳定性'];
                        var ret = '';
                        for (var idx in value) {
                            ret += indicatorNames[idx] + ': ' + params.value[idx];
                        }
                        return ret;
                    }
                },
                radar: {
                    indicator: this.seriesData.indicators,
                    shape: 'polygon',
                    splitNumber: 5,
                    radius: '60%'
                },
                series: [{
                    type: 'radar',
                    data: [{
                        value: this.seriesData.data,
                        name: '得分',
                        symbol: 'circle',
                        symbolSize: 4,
                        lineStyle: {
                            color: '#303f9f',
                            width: 1
                        },
                        areaStyle: {
                            color: 'rgba(48, 63, 159, 0.1)'
                        },
                        itemStyle: {
                            color: '#303f9f'
                        }
                    }]
                }]
            };

            myChart.setOption(option);
        },
        _renderError: function _renderError() {}
    },
    mounted: function mounted() {
        this.renderChart();
    },

    watch: {
        refresh: function refresh() {
            this.renderChart();
        }
    }
});

/***/ }),

/***/ "6M7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__strategy_row_item__ = __webpack_require__("qkPd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'strategy-backtest',
    components: {
        strategyRowItem: __WEBPACK_IMPORTED_MODULE_0__strategy_row_item__["a" /* default */]
    },
    created: function created() {
        this.updateList();
    },
    data: function data() {
        return {
            strategyKeyWord: '',
            isSearchResult: false,
            isFromSearch: true,
            isshowloading: false,
            pageSize: 10,
            currentPage: 1,
            sortSelect: ''
        };
    },

    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.myStrategy.createdStrategy;
        },
        tradeBacktestData: function tradeBacktestData() {
            return this.$store.getters['myStrategy/tradeBacktestData'];
        },
        strategyDataList: function strategyDataList() {
            return this.tradeBacktestData.list;
        },
        total: function total() {
            return this.tradeBacktestData.num;
        }
    },
    methods: {
        updateSearchStrategy: function updateSearchStrategy() {
            window.TA.log(this.buriedPoint.search);
            this.updateList();
        },
        deleteStrategy: function deleteStrategy() {
            this.updateList();
        },
        subscribe: function subscribe() {
            this.updateList();
        },
        cancelSubscribe: function cancelSubscribe() {
            this.updateList();
        },
        goPage: function goPage(page) {
            window.TA.log(this.buriedPoint.strategyBacktestPage);
            this.currentPage = page;
        },
        updateList: function updateList() {
            var _this = this;

            var self = this;
            this.isSearchResult = false;
            this.isshowloading = true;
            this.$store.dispatch('myStrategy/requestTradeBacktest', {
                page: this.currentPage,
                pageNum: this.pageSize,
                sortType: this.sortSelect,
                keyword: this.strategyKeyWord
            }).then(function (result) {
                if (self.strategyDataList.length === 0) {
                    _this.isFromSearch = Boolean(_this.strategyKeyWord);
                    _this.isSearchResult = true;
                }
                _this.isshowloading = false;
            }).catch(function (error) {
                self.isshowloading = false;
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        }
    },
    watch: {
        currentPage: function currentPage() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "7WqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'receive-discuss',
    mounted: function mounted() {
        this.updateList();
    },

    computed: {
        receiveDiscussData: function receiveDiscussData() {
            return this.$store.getters['myStrategy/receiveDiscussData'];
        },
        discussDataList: function discussDataList() {
            return this.receiveDiscussData.list;
        },
        total: function total() {
            return this.receiveDiscussData.total;
        }
    },
    data: function data() {
        return {
            isSearchResult: false,
            currentPage: 1,
            pageSize: 10,
            inputDiscuss: '',
            isdiscusscontent: false,
            isshowloading: false,
            isshowinputdiscuss: false,
            clickIndex: -1
        };
    },

    methods: {
        commentLikes: function commentLikes(pid, cid, item) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/commentlikes', { params: {
                    pid: pid,
                    cid: cid
                } }).then(function (res) {
                if (res.data.errorcode) {
                    self.$tip({
                        message: res.data.errormsg ? res.data.errormsg.toString() : '网络异常',
                        duration: 2000,
                        type: 'danger'
                    });
                } else {
                    self.$tip({
                        message: '点赞成功',
                        duration: 2000,
                        type: 'success'
                    });
                    item.likes += 1;
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        commentReport: function commentReport(pid, cid, userid) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/commentreport', { params: {
                    pid: pid,
                    userid: userid,
                    cid: cid
                } }).then(function (res) {
                if (!res.data.errorcode) {
                    self.$tip({
                        message: res.data.errormsg ? res.data.errormsg.toString() : '举报成功，后台审核中',
                        duration: 2000,
                        type: 'success'
                    });
                } else {
                    self.$tip({
                        message: '举报失败，请稍后再试',
                        duration: 2000,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        changeInput: function changeInput() {
            if (!this.inputDiscuss) {
                this.isdiscusscontent = false;
            } else {
                this.isdiscusscontent = true;
            }
        },
        isShowInputDiscuss: function isShowInputDiscuss(index) {
            if (this.clickIndex === index) {
                this.clickIndex = -1;
            } else {
                this.clickIndex = index;
                this.inputDiscuss = '';
                this.isshowinputdiscuss = true;
            }
        },
        goPage: function goPage(page) {
            this.currentPage = page;
        },
        submitDiscuss: function submitDiscuss(pid, userid, cid, item) {
            var self = this;
            if (!this.inputDiscuss) {
                self.$tip({
                    message: '回复内容不能为空',
                    duration: 2000,
                    type: 'danger'
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/sns/addcomment', {
                    pid: pid,
                    receiver_id: userid,
                    rid: cid,
                    content: this.inputDiscuss
                }).then(function (res) {
                    if (res.data.errorcode) {
                        self.$tip({
                            message: '回复失败，请稍后再试',
                            duration: 2000,
                            type: 'error'
                        });
                    } else {
                        self.$tip({
                            message: '回复内容正在后台审核中',
                            duration: 2000,
                            type: 'success'
                        });
                        self.isshowinputdiscuss = false;
                        self.$store.dispatch('myStrategy/requestSendDiscuss');
                    }
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            }
        },
        updateList: function updateList() {
            var self = this;
            this.isshowloading = true;
            this.$store.dispatch('myStrategy/requestReceiveDiscuss', {
                page: this.currentPage,
                pagesize: this.pageSize
            }).then(function (result) {
                self.isshowloading = false;
                if (self.discussDataList.length === 0) {
                    self.isSearchResult = true;
                } else {
                    self.isSearchResult = false;
                }
            }).catch(function (error) {
                self.isshowloading = false;
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        }
    },
    watch: {
        currentPage: function currentPage() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "7eQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'header',
    computed: {
        // buriedPoint () {
        //     return this.$buriedPoint.navigationBar
        // }
    },
    components: {},
    data: function data() {
        return {};
    },

    methods: {
        // home () {
        //     window.TA.log(this.buriedPoint.home)
        // },
        // backtestOnce () {
        //     window.TA.log(this.buriedPoint.backtestOnce)
        // },
        // strategyBacktest () {
        //     window.TA.log(this.buriedPoint.strategyBacktest)
        // },
        // strategySquare () {
        //     window.TA.log(this.buriedPoint.strategySquare)
        // },
        // eventEvaluation () {
        //     window.TA.log(this.buriedPoint.eventEvaluation)
        // },
        // myStrategy () {
        //     window.TA.log(this.buriedPoint.myStrategy)
        // }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "7j7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history_detail"},[_c('div',{staticClass:"history_detail_title"},[_c('p',[_vm._v("历史明细查询 ")]),_vm._v(" "),_c('a',{staticStyle:{"margin-left":"10px"},attrs:{"title":"低版本IE需手动加上.csv后缀"},on:{"click":_vm.exportHistory}},[_c('vue-button',{attrs:{"type":"blue","size":"small"}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"history_day_select"},[_c('p',[_vm._v("持股周期 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentday),expression:"currentday"}],staticClass:"day_select",on:{"click":_vm.daySelects,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentday=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dayselect),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 天")])}),0)]),_vm._v(" "),_c('div',{staticClass:"sd-toolbar_1"},[_c('div',{staticClass:"sd-toolbar_operabox_1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeStartDate),expression:"tradeStartDate"}],staticClass:"trade_detail_startDate_1",attrs:{"id":"history_detail_startDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeStartDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, '#F{$dp.$D(\'history_detail_endDate\')}', _vm.minDate)},"blur":_vm.startDatePoint,"input":function($event){if($event.target.composing){ return; }_vm.tradeStartDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"time-split"},[_vm._v(" 至 ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeEndDate),expression:"tradeEndDate"}],staticClass:"trade_detail_endDate_1",attrs:{"id":"history_detail_endDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeEndDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, _vm.maxDate, '#F{$dp.$D(\'history_detail_startDate\')}')},"blur":_vm.endDatePoint,"input":function($event){if($event.target.composing){ return; }_vm.tradeEndDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"history_detail_main"},[_vm._m(0),_vm._v(" "),_c('EasyScrollbar',{attrs:{"barOption":_vm.myBarOption}},[_c('div',{staticClass:"rolltable"},[_c('table',{attrs:{"cellspacing":"0"}},[_c('tbody',_vm._l((_vm.historyList),function(hist,index){return _c('tr',{class:(index + 1) % 2 === 0 ? 'gray' : ''},[_c('td',{attrs:{"width":"144"}},[_vm._v(_vm._s(hist.stock_code))]),_vm._v(" "),_c('td',{staticClass:"td-highlight",attrs:{"width":"144"},on:{"click":function($event){return _vm.codeLink(hist.stock_code)},"mouseenter":function($event){return _vm.debounceShowQuoteChart($event, hist)},"mouseleave":function($event){return _vm.hideQuoteChart(hist)}}},[_vm._v(_vm._s(hist.stock_name))]),_vm._v(" "),_c('td',{attrs:{"width":"144"}},[_vm._v(_vm._s(hist.start_date))]),_vm._v(" "),_c('td',{attrs:{"width":"144"}},[_vm._v(_vm._s(hist.end_date))]),_vm._v(" "),_c('td',{attrs:{"width":"108"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(hist.start_price)))]),_vm._v(" "),_c('td',{attrs:{"width":"109"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(hist.end_price)))]),_vm._v(" "),_c('td',{class:_vm._f("riseAndFallClass")(hist.change_rate),attrs:{"width":"180"}},[_vm._v(_vm._s(_vm._f("safeFloatPerFixedTwo")(hist.change_rate)))])])}),0)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"cellspacing":"0"}},[_c('thead',[_c('th',[_vm._v("股票代码")]),_vm._v(" "),_c('th',[_vm._v("股票简称")]),_vm._v(" "),_c('th',[_vm._v("起始时间")]),_vm._v(" "),_c('th',[_vm._v("终止时间")]),_vm._v(" "),_c('th',[_vm._v("起始价")]),_vm._v(" "),_c('th',[_vm._v("终止价")]),_vm._v(" "),_c('th',[_vm._v("区间涨跌幅")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Nok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backtest_analysis"},[_c('div',{staticClass:"backtest_analysis_title"},[_c('p',[_vm._v("回测分析\n            "),_c('vue-notice-tip',{attrs:{"list":_vm.noticeList}})],1)]),_vm._v(" "),_c('div',{staticClass:"backtest_analysis_main"},[_c('div',{staticClass:"rolltable"},[_c('table',{attrs:{"cellspacing":"0"}},[_c('thead',[(_vm.transactiontype === '2')?_c('th',[_vm._v("择时条件")]):_vm._e(),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("持有期")]),_vm._v(" "),_c('th',[_vm._v("单次收益平均值")]),_vm._v(" "),_c('th',[_vm._v("预期年化收益率")]),_vm._v(" "),_c('th',[_vm._v("盈亏比")]),_vm._v(" "),_c('th',[_vm._v("成功率")]),_vm._v(" "),_c('th',[_vm._v("最大回撤")]),_vm._v(" "),_c('th',[_vm._v("夏普比率")]),_vm._v(" "),_c('th',[_vm._v("单次最大收益值")]),_vm._v(" "),_c('th',[_vm._v("单次收益最小值")]),_vm._v(" "),_c('th',[_vm._v("周战胜率")]),_vm._v(" "),_c('th',[_vm._v("交易次数")])]),_vm._v(" "),(_vm.transactiontype === '1')?_c('tbody',_vm._l((_vm.backtestData),function(back,index){return _c('tr',{class:[(index + 1) % 2 === 0 ? 'gray' : '', back.daySaleStrategy === _vm.maxWinrateDay ? 'blue' : back.daySaleStrategy === _vm.maxAnnualyieldDay ? 'blue' : '']},[_c('td',{class:back.daySaleStrategy === _vm.maxWinrateDay ? 'recommend' : back.daySaleStrategy === _vm.maxAnnualyieldDay ? 'recommend' : 'transparent'},[_vm._v("荐")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(back.daySaleStrategy)+"天")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.averageIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.annualYield)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(back.averageLossRatio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.winRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.maxDrawDown)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(back.sharpeRatio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.maxIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.minIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.weekWinRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeNumber")(back.totalTradeTimes)))])])}),0):_c('tbody',[_vm._l((_vm.backtestData),function(item,index){return (item && item.length !== 0)?[_c('tr',{class:[_vm.trBorderClass(index, item[0].daySaleStrategy, 0 === item.length - 1)]},[_c('td',{staticClass:"menv-border",attrs:{"rowspan":item.length}},[_vm._v(_vm._s(_vm.signalData[index]))]),_vm._v(" "),_c('td',{class:_vm.tdBorderClass(index, item[0].daySaleStrategy)},[_vm._v("荐")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item[0].daySaleStrategy)+"天")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].averageIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].annualYield)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(item[0].averageLossRatio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].winRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].maxDrawDown)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(item[0].sharpeRatio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].maxIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].minIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item[0].weekWinRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeNumber")(item[0].totalTradeTimes)))])]),_vm._v(" "),_vm._l((item),function(back,itemIndex){return (itemIndex > 0)?_c('tr',{class:[(itemIndex + 1) % 2 === 0 ? 'gray' : '', _vm.trBorderClass(index, back.daySaleStrategy, itemIndex === item.length - 1)]},[_c('td',{class:_vm.tdBorderClass(index, back.daySaleStrategy)},[_vm._v("荐")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(back.daySaleStrategy)+"天")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.averageIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.annualYield)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(back.averageLossRatio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.winRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.maxDrawDown)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(back.sharpeRatio)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.maxIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.minIncome)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.weekWinRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("safeNumber")(back.totalTradeTimes)))])]):_vm._e()})]:_vm._e()})],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8TXV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.internalPageCount && _vm.internalPageCount > 1)?_c('div',{staticClass:"paginationbox"},[_c('div',{staticClass:"box box-prev",class:{ disabled: _vm.internalCurrentPage <= 1 },attrs:{"type":"button"},on:{"click":_vm.prev}},[_vm._v("\n       上页\n   ")]),_vm._v(" "),_c('pager',{attrs:{"current-page":_vm.internalCurrentPage,"page-count":_vm.internalPageCount},on:{"change":_vm.handleCurrentChange}}),_vm._v(" "),_c('div',{staticClass:"box box-next",class:{ disabled: _vm.internalCurrentPage === _vm.internalPageCount || _vm.internalPageCount === 0 },attrs:{"type":"button"},on:{"click":_vm.next}},[_vm._v("\n        下页\n    ")]),_vm._v(" "),_c('div',{staticClass:"box",staticStyle:{"cursor":"auto"},attrs:{"type":"button"}},[_vm._v("\n        共"+_vm._s(_vm.internalPageCount)+"页\n    ")]),_vm._v(" "),(_vm.goVisible)?[_c('span',{staticClass:"page-goto-title"},[_vm._v("GO")]),_vm._v(" "),_c('div',{staticClass:"box-input"},[_c('input',{staticClass:"goto_page",attrs:{"type":"text"},domProps:{"value":_vm.internalCurrentPage},on:{"change":function($event){return _vm.gotoPage($event)}}})])]:_vm._e(),_vm._v(" "),_vm._t("myslot"),_vm._v(" "),(_vm.totalVisible)?_c('div',{staticClass:"box-total"},[_vm._v("共 "+_vm._s(_vm.total)+" 条")]):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9PKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var chart = null;
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            selectedDay: '',
            chartKeyMap: {
                'lt-7.5': {
                    name: '涨跌幅：小于-7.5%',
                    color: '#259b24'
                },
                'egt-7.5&lt-3.5': {
                    name: '涨跌幅：-3.5%到-7.5%',
                    color: '#42bd41'
                },
                'egt-3.5&lt0': {
                    name: '涨跌幅：-3.5%到0%',
                    color: '#72d572'
                },
                'egt0&lt3.5': {
                    name: '涨跌幅：0%到3.5%',
                    color: '#f36c60'
                },
                'egt3.5&lt7.5': {
                    name: '涨跌幅：3.5%到7.5%',
                    color: '#e93f43'
                },
                'egt7.5': {
                    name: '涨跌幅：大于7.5%',
                    color: '#d01716'
                }
            }
        };
    },

    props: {
        dayselect: {
            type: Array,
            required: true
        },
        chartday: {
            type: String,
            required: true
        },
        backtestData: {
            type: Array,
            required: true
        },
        refresh: Boolean
    },
    computed: {
        chartSeriesData: function chartSeriesData() {
            var self = this;
            var singleBacktestdata = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.backtestData, function (item) {
                return item.daySaleStrategy === Number(self.selectedDay);
            });
            var ordinaryRateGroup = {
                'egt-3.5&lt0': 0,
                'egt-7.5&lt-3.5': 0,
                'egt0&lt3.5': 0,
                'egt3.5&lt7.5': 0,
                'egt7.5': 0,
                'lt-7.5': 0
            };
            if (singleBacktestdata !== undefined) {
                ordinaryRateGroup = singleBacktestdata.changeRateGroup;
            }
            var result = [];
            for (var key in ordinaryRateGroup) {
                result.push({
                    name: this.chartKeyMap[key].name,
                    value: ordinaryRateGroup[key],
                    itemStyle: {
                        color: this.chartKeyMap[key].color
                    }
                });
            }
            return result;
        },
        chartOptions: function chartOptions() {
            return {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                series: [{
                    name: '占比次数',
                    type: 'pie',
                    radius: ['0', '60%'],
                    center: ['50%', '50%'],
                    avoidLabelOverlap: true,
                    itemStyle: {
                        borderWidth: 0
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    data: this.chartSeriesData
                }]
            };
        },
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.backtestOnce.upsDownsChart;
        }
    },
    methods: {
        charySelect: function charySelect() {
            window.TA.log(this.buriedPoint.cycleOption);
        },
        renderChart: function renderChart() {
            if (chart) {
                chart.dispose();
                chart = null;
            }

            chart = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(this.$refs.chartRef);
            chart.setOption(this.chartOptions);
        }
    },
    mounted: function mounted() {
        this.renderChart();
    },
    created: function created() {
        this.selectedDay = this.chartday;
    },

    watch: {
        selectedDay: function selectedDay() {
            chart.setOption({
                series: [{
                    data: this.chartSeriesData
                }]
            });
        },
        chartOptions: function chartOptions() {
            this.renderChart();
        },
        chartday: function chartday(val) {
            this.selectedDay = val;
        },
        refresh: function refresh() {
            this.selectedDay = this.chartday;
        }
    }
});

/***/ }),

/***/ "9n7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategydetailmain"},[(_vm.detailCompleted)?_c('div',{staticClass:"strategydetail"},[_c('h3',[_vm._v(_vm._s(_vm.strategydetail.title))]),_vm._v(" "),_c('div',{staticClass:"item-label"},_vm._l((_vm.strategydetail.tags),function(item,index){return (item)?_c('span',{key:index},[_vm._v(_vm._s(item))]):_vm._e()}),0),_vm._v(" "),_c('p',[_vm._v("投资逻辑：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.strategydetail.logic))]),_vm._v(" "),_c('div',{staticClass:"item-user"},[_c('div',{staticClass:"item-user-img right"},[_c('img',{attrs:{"src":_vm.strategydetail.avatarUrl}})]),_vm._v(" "),_c('p',{staticClass:"right user"},[_vm._v(_vm._s(_vm.strategydetail.userName))])]),_vm._v(" "),_c('div',{staticClass:"strip"}),_vm._v(" "),_c('p',[_vm._v("策略问句：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.strategydetail.query))]),_vm._v(" "),_c('p',[_vm._v("回测参数：")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentBacktestType === '1'),expression:"currentBacktestType === '1'"}],staticClass:"question_model_normal"},[_c('div',{staticClass:"buy_layer"},[_c('span',{staticClass:"car"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cycle"},[_c('span',[_vm._v("持股周期 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.daysForSaleStrategy))]),_vm._v(" "),_c('span',[_vm._v(" 天")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("持股上限 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.stockHoldCount))]),_vm._v(" "),_c('span',[_vm._v("只")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("单日买入数 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.queryString.dayBuyStockNum ? _vm.strategydetail.queryString.dayBuyStockNum : _vm.strategydetail.stockHoldCount))]),_vm._v(" "),_c('span',[_vm._v("只")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("资金量 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.queryString.capital ? _vm.strategydetail.queryString.capital : _vm.strategydetail.capital))])])]),_vm._v(" "),_c('div',{staticClass:"sell_layer_up"},[_c('span',{staticClass:"car"}),_vm._v(" "),_c('div',{staticClass:"target_profit"},[_c('span',[_vm._v("止盈 : ")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("收益率 ≥ "+_vm._s(_vm.strategydetail.upperIncome)+" % 时坚定持有;直到最高收益回落 "+_vm._s(_vm.strategydetail.fallIncome)+" % ")])]),_vm._v(" "),_c('div',{staticClass:"stop_loss"},[_c('span',[_vm._v("止损 : ")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("收益率 ≤ - "+_vm._s(_vm.strategydetail.lowerIncome)+" % ")])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentBacktestType === '2'),expression:"currentBacktestType === '2'"}],staticClass:"question_model_market",staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"buy_layer"},[_c('span',{staticClass:"car"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"cycle"},[_c('span',[_vm._v("持股周期 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.daysForSaleStrategy))]),_vm._v(" "),_c('span',[_vm._v(" 天")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("持股上限 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.stockHoldCount))]),_vm._v(" "),_c('span',[_vm._v("只")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("单日买入数 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.queryString.dayBuyStockNum ? _vm.strategydetail.queryString.dayBuyStockNum : _vm.strategydetail.stockHoldCount))]),_vm._v(" "),_c('span',[_vm._v("只")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("资金量 :  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strategydetail.queryString.capital ? _vm.strategydetail.queryString.capital : _vm.strategydetail.capital))])])]),_vm._v(" "),_c('div',{staticClass:"market_title"},[_c('p',{class:_vm.currentBacktestType === '2' ? 'fwb' : ''},[_vm._v("强势市场: ")])]),_vm._v(" "),_c('div',{staticClass:"sell_layer_up",class:_vm.currentBacktestType === '2' ? 'mb0' : ''},[_c('span',{staticClass:"car"}),_vm._v(" "),_c('div',{staticClass:"target_profit"},[_c('span',[_vm._v("止盈 : ")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("收益率 ≥ "+_vm._s(_vm.strategydetail.upperIncome)+" % 时坚定持有;直到最高收益回落 "+_vm._s(_vm.strategydetail.fallIncome)+" % ")])]),_vm._v(" "),_c('div',{staticClass:"stop_loss"},[_c('span',[_vm._v("止损 : ")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("收益率 ≤ - "+_vm._s(_vm.strategydetail.lowerIncome)+" % ")])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"sell_layer_down",class:_vm.currentBacktestType === '2' ? 'mb0' : ''},[_c('span',{staticClass:"car"}),_vm._v(" "),_c('div',{staticClass:"target_profit"},[_c('span',[_vm._v("止盈 : ")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("收益率 ≥ "+_vm._s(_vm.strategydetail.queryString.bearMarketUpperIncome)+" % 时坚定持有;直到最高收益回落 "+_vm._s(_vm.strategydetail.queryString.bearMarketFallIncome)+" % ")])]),_vm._v(" "),_c('div',{staticClass:"stop_loss"},[_c('span',[_vm._v("止损 : ")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0"}},[_vm._v("收益率 ≤ - "+_vm._s(_vm.strategydetail.queryString.bearMarketLowerIncome)+" % ")])]),_vm._v(" "),_c('div',{staticClass:"position_control"},[_c('span',[_vm._v("仓位控制 : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.positionTitle(_vm.strategydetail.buyPosition)))])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"signalbox"},_vm._l((_vm.marketsignals),function(item){return _c('div',{staticClass:"market_signal"},[_c('p',[_vm._v(_vm._s(_vm.signalData[item]))])])}),0)]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'strategybacktest', query: _vm.strategydetail.queryString}}},[_c('div',{staticClass:"modify",on:{"click":_vm.buriedPoints}},[_vm._v("修改参数")])]),_vm._v(" "),(_vm.isOwn)?[(_vm.isPublish === 2)?_c('div',{staticClass:"collect",on:{"click":function($event){return _vm.releaseBacktest(_vm.strategyId)}}},[_vm._v("发布")]):_c('div',{staticClass:"alcollect"},[_vm._v("收藏数（"+_vm._s(_vm.collectedNum)+"）")])]:[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollected),expression:"!isCollected"}],staticClass:"collect",on:{"click":function($event){return _vm.addCollection(_vm.strategyId)}}},[_vm._v("收藏策略")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCollected),expression:"isCollected"}],staticClass:"alcollect",class:_vm.iscancel ? 'cancel' : '',on:{"click":function($event){return _vm.removeCollection(_vm.strategyId)},"mouseenter":function($event){_vm.iscancel = !_vm.iscancel},"mouseleave":function($event){_vm.iscancel = !_vm.iscancel}}},[_vm._v(_vm._s(_vm.iscancel ? '取消收藏' : '已收藏'))])]],2):_vm._e(),_vm._v(" "),(_vm.detailCompleted)?[_c('report-grade',{attrs:{"strategy-id":_vm.strategyId,"transactiontype":_vm.currentBacktestType,"signal-data":_vm.signalData,"report-data":_vm.reportdata,"query":_vm.strategydetail.query}}),_vm._v(" "),_c('backtest-analysis',{attrs:{"transactiontype":_vm.currentBacktestType,"signal-data":_vm.signalData,"backtest-data":_vm.backtestAnalysisData,"max-winrate":_vm.reportdata.maxWinRate,"max-annualyield":_vm.reportdata.maxAnnualYield}}),_vm._v(" "),_c('strategy-select',{attrs:{"show-pick":true,"strategy-id":_vm.strategyId,"transactiontype":_vm.currentBacktestType,"buy-position":parseInt(_vm.strategydetail.buyPosition),"select-data":_vm.selectData,"query":_vm.strategydetail.query,"hold":'' + _vm.strategydetail.queryString.dayBuyStockNum ? _vm.strategydetail.queryString.dayBuyStockNum : _vm.strategydetail.stockHoldCount}}),_vm._v(" "),(_vm.profitgraphCompleted)?_c('profit-chart',{attrs:{"backtest-id":_vm.id,"strategy-id":_vm.strategyId,"profit-data":_vm.cumulative,"transactiontype":_vm.currentBacktestType,"max-winrate":_vm.reportdata.maxWinRate,"max-annualyield":_vm.reportdata.maxAnnualYield,"day-select":_vm.dayselect,"market-signals":_vm.bestMarketsignals,"signal-data":_vm.signalData,"hs-data":_vm.Hsdata,"score-data":_vm.scoreData}}):_vm._e(),_vm._v(" "),(_vm.profitgraphCompleted)?_c('change-rate-group',{attrs:{"backtest-id":_vm.id,"strategy-id":_vm.strategyId,"profit-group-data":_vm.change,"transactiontype":_vm.currentBacktestType,"max-winrate":_vm.reportdata.maxWinRate,"day-select":_vm.dayselect,"market-signals":_vm.bestMarketsignals,"signal-data":_vm.signalData}}):_vm._e(),_vm._v(" "),_c('history-detail',{attrs:{"backtest-id":_vm.id,"strategy-id":_vm.strategyId,"transactiontype":_vm.currentBacktestType,"max-winrate":_vm.reportdata.maxWinRate,"day-select":_vm.dayselect,"market-signals":_vm.bestMarketsignals,"signal-data":_vm.signalData,"min-date":_vm.tradeStartDate,"max-date":_vm.tradeEndDate,"my-bar-option":_vm.myBarOption}})]:_vm._e(),_vm._v(" "),(_vm.detailCompleted && _vm.isPublish === 1)?_c('div',{staticClass:"comment"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"comment_main"},[_c('div',{staticClass:"comment_content"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"},{name:"show",rawName:"v-show",value:(!_vm.isOwn),expression:"!isOwn"}],attrs:{"placeholder":"你认为这策略如何..."},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.iscommentshow),expression:"iscommentshow"}]},[_vm._v("评论内容不能为空")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOwn),expression:"!isOwn"}],staticClass:"publish_comment",on:{"click":_vm.commentClick}},[_vm._v(_vm._s(_vm.commentUploading ? '发布中…' : '发表评论'))]),_vm._v(" "),_c('div',{staticClass:"own-discuss-list"},[_c('receive-discuss',{attrs:{"pid":_vm.pid,"sid":parseInt(_vm.strategyId)}})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowtestloading),expression:"isshowtestloading"}],staticClass:"testmain"},[_c('div',{staticClass:"testshadow"}),_vm._v(" "),_vm._m(7)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moment"},[_c('span',[_vm._v("时机 : ")]),_vm._v(" "),_c('span',[_vm._v("开盘买入")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position_control"},[_c('span',[_vm._v("仓位控制 : ")]),_vm._v(" "),_c('span',[_vm._v("满仓")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moment"},[_c('span',[_vm._v("时机 : ")]),_vm._v(" "),_c('span',[_vm._v("开盘买入")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position_control"},[_c('span',[_vm._v("仓位控制 : ")]),_vm._v(" "),_c('span',[_vm._v("满仓")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market_title"},[_c('p',[_vm._v("弱势市场: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market_title"},[_c('p',{staticClass:"fl"},[_vm._v("市场信号: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment_title"},[_c('p',[_vm._v("策略评论")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testparallel"},[_c('div',{staticClass:"test-loading"},[_c('span',{staticClass:"testing-icon"}),_vm._v(" "),_c('span',[_vm._v("正在加载，请耐心等待……")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A7Ym":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AHni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategybacktestmain"},[_c('div',{staticClass:"strategyquestion"},[_c('div',{staticClass:"question_title"},[_c('p',{staticClass:"fl"},[_vm._v("请输入您想要回测的问句：  ")]),_vm._v(" "),_c('p',{ref:"sentenceNotice",staticClass:"fl",staticStyle:{"display":"none"}},[_vm._v("策略问句不能为空!")])]),_vm._v(" "),_c('div',{staticClass:"question_main",class:_vm.transactiontype === '2' ? 'minh' : ''},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideSearchList),expression:"hideSearchList"}],staticClass:"question_sentence"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sentence),expression:"sentence"},{name:"validate",rawName:"v-validate",value:({ type: 'string', max: 200, min: 1, errClass: 'question_sentence_input focus', errRef: 'sentenceNotice'}),expression:"{ type: 'string', max: 200, min: 1, errClass: 'question_sentence_input focus', errRef: 'sentenceNotice'}"}],ref:"question_sentence_input",staticClass:"question_sentence_input",attrs:{"type":"text","id":"question_sentence_input","placeholder":"请输入问句","autocomplete":"off"},domProps:{"value":(_vm.sentence)},on:{"keyup":[function($event){return _vm.debounceQuestion($event, 1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"blur":function($event){return _vm.questionDataValidation($event, 0)},"input":function($event){if($event.target.composing){ return; }_vm.sentence=$event.target.value}}}),_vm._v(" "),_c('span',{on:{"click":_vm.empty}}),_vm._v(" "),(_vm.searchVis)?_c('key-list',{attrs:{"list-visible":_vm.searchVis,"list-data":_vm.searchList,"max-num":7},on:{"update:listVisible":function($event){_vm.searchVis=$event},"update:list-visible":function($event){_vm.searchVis=$event},"click-item":_vm.updateInput,"select-item":_vm.updateInput,"no-checked":_vm.nochecked}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"question_section"},[_c('p',{staticClass:"fl"},[_vm._v("选择您想回测的时间区间：  ")]),_vm._v(" "),_c('p',{ref:"numberNotice",staticClass:"fl",staticStyle:{"display":"none"}},[_vm._v("请正确输入大于1的正整数，可用英文状态下 \",\" 分隔天数!")]),_vm._v(" "),_c('p',{ref:"profitlossNotice",staticClass:"fl",staticStyle:{"display":"none"}},[_vm._v("请输入正数!")])]),_vm._v(" "),_c('div',{staticClass:"sd-toolbar"},[_c('div',{staticClass:"sd-toolbar_operabox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeStartDate),expression:"tradeStartDate"}],staticClass:"trade_detail_startDate",attrs:{"id":"trade_detail_startDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeStartDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, '#F{$dp.$D(\'trade_detail_endDate\')}', '2014-1-1')},"blur":_vm.startDatePoint,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeStartDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"time-split"},[_vm._v(" 至 ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeEndDate),expression:"tradeEndDate"}],staticClass:"trade_detail_endDate",attrs:{"id":"trade_detail_endDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeEndDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, _vm.yesterdayDate, '#F{$dp.$D(\'trade_detail_startDate\')}')},"blur":_vm.endDatePoint,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeEndDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"question_model"},[_c('p',{staticClass:"fl"},[_vm._v("填写您想使用的交易模型：  ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactiontype),expression:"transactiontype"}],staticClass:"icon_checkbox",attrs:{"type":"radio","name":"transaction","value":"1"},domProps:{"checked":_vm._q(_vm.transactiontype,"1")},on:{"click":_vm.commonModel,"change":function($event){_vm.transactiontype="1"}}}),_vm._v(" "),_c('div',{staticClass:"checkbox_img"}),_vm._v(" "),_c('span',[_vm._v("普通规则交易")])]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactiontype),expression:"transactiontype"}],staticClass:"icon_checkbox",attrs:{"type":"radio","name":"transaction","value":"2"},domProps:{"checked":_vm._q(_vm.transactiontype,"2")},on:{"click":_vm.marketModel,"change":function($event){_vm.transactiontype="2"}}}),_vm._v(" "),_c('div',{staticClass:"checkbox_img"}),_vm._v(" "),_c('span',[_vm._v("市场择时交易")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactiontype === '1'),expression:"transactiontype === '1'"}],staticClass:"question_model_normal"},[_c('div',{staticClass:"buy_layer"},[_c('span',{staticClass:"car"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cycle"},[_c('span',[_vm._v("持股周期 : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"},{name:"validate",rawName:"v-validate",value:({ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice', isGt1: 1}),expression:"{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice', isGt1: 1}"}],ref:"question_cycle_input",staticClass:"question_cycle_input",attrs:{"type":"text"},domProps:{"value":(_vm.number)},on:{"blur":_vm.qusetionCycle,"keyup":[_vm.validateInput,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("  天")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("持股上限 : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.stockHold),expression:"stockHold"}],staticClass:"shares_select",on:{"click":_vm.sharesSelect,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.stockHold=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sharesselect),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 只")])}),0)]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("单日买入数 : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dayBuyStockNum),expression:"dayBuyStockNum"}],staticClass:"shares_select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dayBuyStockNum=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sharesselect),function(item,index){return (parseInt(item) <= parseInt(_vm.stockHold))?_c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 只")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"capital"},[_c('span',[_vm._v("资金量 : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.capital),expression:"capital"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: 'capital_input focus', errRef: 'profitlossNotice' }),expression:"{ type: 'number', errClass: 'capital_input focus', errRef: 'profitlossNotice' }"}],ref:"capital_input",staticClass:"capital_input",attrs:{"type":"text"},domProps:{"value":(_vm.capital)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.capital=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("  元")])])]),_vm._v(" "),_c('div',{staticClass:"sell_layer"},[_c('span',{staticClass:"car"}),_vm._v(" "),_c('div',{staticClass:"target_profit"},[_c('span',[_vm._v("止盈 : ")]),_vm._v(" "),_c('p',[_vm._v("收益率 ≥\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.upperIncome),expression:"upperIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"upper_income",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.upperIncome)},on:{"blur":_vm.commonTargetProfitRiseRapidly,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.upperIncome=$event.target.value}}}),_vm._v(" % 时坚定持有;直到最高收益回落\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fallIncome),expression:"fallIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"fall_income",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.fallIncome)},on:{"blur":_vm.commonTargetProfitFall,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.fallIncome=$event.target.value}}}),_vm._v(" %\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"stop_loss"},[_c('span',[_vm._v("止损 : ")]),_vm._v(" "),_c('p',[_vm._v("收益率 ≤ -\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lowerIncome),expression:"lowerIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"lower_income",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.lowerIncome)},on:{"blur":_vm.commonStopProfit,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.lowerIncome=$event.target.value}}}),_vm._v(" %\n                        ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isfinishshow),expression:"isfinishshow"}],staticClass:"finish"},[_c('p',[_vm._v("回测运行完成 !")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isfinishshow),expression:"isfinishshow"}],staticClass:"savebacktest",on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.isPublish === 1 ? '已发布' : '保存发布'))]),_vm._v(" "),(!_vm.defaultqueryLoading)?_c('div',{staticClass:"beginbacktest",on:{"click":_vm.startBacktest}},[_vm._v(_vm._s(_vm.isfinishshow ? '再次回测' : '开始回测'))]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactiontype === '2'),expression:"transactiontype === '2'"}],staticClass:"question_model_market"},[_c('div',{staticClass:"buy_layer"},[_c('span',{staticClass:"car"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"cycle"},[_c('span',[_vm._v("持股周期 : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"},{name:"validate",rawName:"v-validate",value:({ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice', isGt1: 1}),expression:"{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice', isGt1: 1}"}],ref:"question_cycle_input_1",staticClass:"question_cycle_input",attrs:{"type":"text"},domProps:{"value":(_vm.number)},on:{"blur":_vm.qusetionCycle,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("  天")])]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("持股上限 : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.stockHold),expression:"stockHold"}],staticClass:"shares_select",on:{"click":_vm.sharesSelect,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.stockHold=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sharesselect),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 只")])}),0)]),_vm._v(" "),_c('div',{staticClass:"shares"},[_c('span',[_vm._v("单日买入数 : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dayBuyStockNum),expression:"dayBuyStockNum"}],staticClass:"shares_select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dayBuyStockNum=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sharesselect),function(item,index){return (parseInt(item) <= parseInt(_vm.stockHold))?_c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 只")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"capital"},[_c('span',[_vm._v("资金量 : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.capital),expression:"capital"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: 'capital_input focus', errRef: 'profitlossNotice' }),expression:"{ type: 'number', errClass: 'capital_input focus', errRef: 'profitlossNotice' }"}],ref:"capital_input_1",staticClass:"capital_input",attrs:{"type":"text"},domProps:{"value":(_vm.capital)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.capital=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("  元")])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"sell_layer_up"},[_c('span',{staticClass:"car"}),_vm._v(" "),_c('div',{staticClass:"target_profit"},[_c('span',[_vm._v("止盈 : ")]),_vm._v(" "),_c('p',[_vm._v("收益率 ≥\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.upperIncome),expression:"upperIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"upper_income_1",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.upperIncome)},on:{"blur":_vm.marketStrongTargetProfitRiseRapidly,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.upperIncome=$event.target.value}}}),_vm._v(" % 时坚定持有;直到最高收益回落\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fallIncome),expression:"fallIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"fall_income_1",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.fallIncome)},on:{"blur":_vm.marketStrongTargetProfitFall,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.fallIncome=$event.target.value}}}),_vm._v(" %\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"stop_loss"},[_c('span',[_vm._v("止损 : ")]),_vm._v(" "),_c('p',[_vm._v("收益率 ≤ -\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lowerIncome),expression:"lowerIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"lower_income_1",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.lowerIncome)},on:{"blur":_vm.marketStrongStopProfit,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.lowerIncome=$event.target.value}}}),_vm._v(" %\n                        ")])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"sell_layer_down"},[_c('span',{staticClass:"car"}),_vm._v(" "),_c('div',{staticClass:"target_profit"},[_c('span',[_vm._v("止盈 : ")]),_vm._v(" "),_c('p',[_vm._v("收益率 ≥\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bearMarketUpperIncome),expression:"bearMarketUpperIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"bear_market_upper_income",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.bearMarketUpperIncome)},on:{"blur":_vm.marketWeakTargetProfitRiseRapidly,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.bearMarketUpperIncome=$event.target.value}}}),_vm._v(" % 时坚定持有;直到最高收益回落\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bearMarketFallIncome),expression:"bearMarketFallIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"bear_market_fall_income",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.bearMarketFallIncome)},on:{"blur":_vm.marketWeakTargetProfitFall,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.bearMarketFallIncome=$event.target.value}}}),_vm._v(" %\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"stop_loss"},[_c('span',[_vm._v("止损 : ")]),_vm._v(" "),_c('p',[_vm._v("收益率 ≤ -\n                            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bearMarketLowerIncome),expression:"bearMarketLowerIncome"},{name:"validate",rawName:"v-validate",value:({ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}),expression:"{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"}],ref:"bear_market_lower_income",attrs:{"type":"text","value":"10"},domProps:{"value":(_vm.bearMarketLowerIncome)},on:{"blur":_vm.marketWeakStopProfit,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.bearMarketLowerIncome=$event.target.value}}}),_vm._v(" %\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"position_control"},[_c('span',[_vm._v("仓位控制 : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.buyPosition),expression:"buyPosition"}],staticClass:"position_select",on:{"click":_vm.marketWeakPositionControl,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.buyPosition=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.buyPositionSelect),function(item,key,index){return _c('option',{key:key,domProps:{"value":key * 10}},[_vm._v(_vm._s(item))])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closemoresignal),expression:"closemoresignal"}]},[_c('div',{staticClass:"market_title",staticStyle:{"width":"215px"}},[_c('p',{staticClass:"fl"},[_vm._v("市场信号: ")]),_vm._v(" "),_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.moresignal.apply(null, arguments)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.ismarketshow),expression:"ismarketshow"}],staticClass:"fl"},[_vm._v("请添加市场信号")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshadowshow),expression:"isshadowshow"}],staticClass:"signalshadow"},[_c('ul',{staticClass:"firstul"},[_vm._l((_vm.signalType),function(signals,index){return _c('li',{class:{'active' : _vm.currenttab === index},on:{"click":function($event){$event.stopPropagation();_vm.currenttab = index}}},[_vm._v(_vm._s(signals[0]))])}),_vm._v(" "),_c('li',{staticClass:"allchecked"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],staticClass:"allchecked_checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"click":function($event){$event.stopPropagation();return _vm.checkall.apply(null, arguments)},"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('div',{staticClass:"allchecked_img"}),_vm._v(" "),_c('span',[_vm._v("全选")])])])],2),_vm._v(" "),_vm._l((_vm.signalType),function(signals,index){return [_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.currenttab === index),expression:"currenttab === index"}]},_vm._l((signals[1]),function(item,index){return _c('li',{class:_vm.marketsignals.indexOf(item) > -1 ? 'active' : '',on:{"click":function($event){$event.stopPropagation();return _vm.selectSignalItem(item)}}},[_vm._v(_vm._s(_vm.signalData[item]))])}),0)]})],2)]),_vm._v(" "),_c('div',{staticClass:"signalbox"},_vm._l((_vm.marketsignals),function(item){return _c('div',{staticClass:"market_signal"},[_c('p',[_vm._v(_vm._s(_vm.signalData[item]))]),_vm._v(" "),_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.cancelSignalItem(item)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"buttonbox"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isfinishshow),expression:"isfinishshow"}],staticClass:"finish"},[_c('p',[_vm._v("回测运行完成 !")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isfinishshow),expression:"isfinishshow"}],staticClass:"savebacktest",on:{"click":function($event){$event.stopPropagation();return _vm.save.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.isPublish === 1 ? '已发布' : '保存发布'))]),_vm._v(" "),(!_vm.defaultqueryLoading)?_c('div',{staticClass:"beginbacktest",on:{"click":function($event){$event.stopPropagation();return _vm.startBacktest.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.isfinishshow ? '再次回测' : '开始回测'))]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backtestCompleted),expression:"backtestCompleted"}],staticClass:"question_analysis"},[_c('p',{staticClass:"fl"},[_vm._v("系统对您语句解析后，以下列条件进行回测")]),_vm._v(" "),_vm._l((_vm.conditionData),function(condi){return _c('div',{staticClass:"condition",attrs:{"title":condi}},[_vm._v(_vm._s(condi))])})],2)])]),_vm._v(" "),(_vm.backtestCompleted)?[_c('report-grade',{attrs:{"transactiontype":_vm.currentBacktestType,"signal-data":_vm.signalData,"report-data":_vm.reportData,"query":_vm.sentence}}),_vm._v(" "),_c('backtest-analysis',{attrs:{"transactiontype":_vm.currentBacktestType,"signal-data":_vm.signalData,"backtest-data":_vm.backtestAnalysisData,"max-winrate":_vm.reportData.maxWinRate,"max-annualyield":_vm.reportData.maxAnnualYield}}),_vm._v(" "),_c('strategy-select',{attrs:{"show-pick":true,"transactiontype":_vm.currentBacktestType,"buy-position":parseInt(_vm.buyPosition),"select-data":_vm.pickData,"query":_vm.sentence,"hold":_vm.dayBuyStockNum}}),_vm._v(" "),_c('profit-chart',{attrs:{"backtest-id":_vm.id,"profit-data":_vm.profitData,"transactiontype":_vm.currentBacktestType,"max-winrate":_vm.reportData.maxWinRate,"max-annualyield":_vm.reportData.maxAnnualYield,"day-select":_vm.dayselect,"market-signals":_vm.bestMarketsignals,"signal-data":_vm.signalData,"hs-data":_vm.Hq300Data,"score-data":_vm.scoreData,"refresh":_vm.refresh}}),_vm._v(" "),_c('change-rate-group',{attrs:{"backtest-id":_vm.id,"profit-group-data":_vm.profitGroupData,"transactiontype":_vm.currentBacktestType,"max-winrate":_vm.reportData.maxWinRate,"day-select":_vm.dayselect,"market-signals":_vm.bestMarketsignals,"signal-data":_vm.signalData,"refresh":_vm.refresh}}),_vm._v(" "),_c('history-detail',{attrs:{"backtest-id":_vm.id,"transactiontype":_vm.currentBacktestType,"max-winrate":_vm.reportData.maxWinRate,"day-select":_vm.dayselect,"market-signals":_vm.bestMarketsignals,"signal-data":_vm.signalData,"min-date":_vm.tradeStartDate,"max-date":_vm.tradeEndDate,"my-bar-option":_vm.myBarOption,"refresh":_vm.refresh}})]:_vm._e(),_vm._v(" "),_c('release-dialog',{attrs:{"visible":_vm.isreleaseshow,"is-publish":_vm.isPublish,"backtest-id":_vm.id},on:{"update:visible":function($event){_vm.isreleaseshow=$event},"update:isPublish":function($event){_vm.isPublish=$event},"update:is-publish":function($event){_vm.isPublish=$event}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowtestloading),expression:"isshowtestloading"}],staticClass:"testmain"},[_c('div',{staticClass:"testshadow"}),_vm._v(" "),_vm._m(6)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moment"},[_c('span',[_vm._v("时机 : ")]),_vm._v(" "),_c('span',[_vm._v("开盘买入")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position_control"},[_c('span',[_vm._v("仓位控制 : ")]),_vm._v(" "),_c('span',[_vm._v("满仓")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moment"},[_c('span',[_vm._v("时机 : ")]),_vm._v(" "),_c('span',[_vm._v("开盘买入")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market_title"},[_c('p',[_vm._v("强势市场: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position_control"},[_c('span',[_vm._v("仓位控制 : ")]),_vm._v(" "),_c('span',[_vm._v("满仓")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market_title"},[_c('p',[_vm._v("弱势市场: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testparallel"},[_c('div',{staticClass:"test-loading"},[_c('span',{staticClass:"testing-icon"}),_vm._v(" "),_c('span',[_vm._v("正在为您计算，请耐心等待……")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AdV3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = questionVal;
/* harmony export (immutable) */ __webpack_exports__["b"] = numberDays;
/* unused harmony export commentVal */
/* harmony export (immutable) */ __webpack_exports__["a"] = labelVal;
/* harmony export (immutable) */ __webpack_exports__["c"] = profitLossVal;
// @charset "utf-8"
// 验证问句长度大于0小于200
function questionVal(val, max, min) {
    if (max !== undefined && val.length > max) {
        return false;
    }

    if (min !== undefined && val.length < min) {
        return false;
    }

    return true;
}
// 验证持股周期大于0的整数集合
function numberDays(val, num) {
    if (num) {
        if (!/(^(([1-9]\d+)|[2-9])(,(([1-9]\d+)|[2-9]))*$)/.test(val)) {
            return false;
        } else {
            return true;
        }
    } else {
        if (!/(^[1-9]\d*(,[1-9]\d*)*$)/.test(val)) {
            return false;
        } else {
            return true;
        }
    }
}
// 验证评论长度大于0小于等于400
function commentVal(val) {
    if (val.length > 400 || val.length <= 0) {
        return false;
    } else {
        return true;
    }
}
// 验证单个标签16字，标签上限10个
function labelVal(val) {
    var arr = val.split(' ');
    // let arry = []
    // if (val.length === 0) {
    //     return 0
    // } else {
    var arry = arr.filter(function (x) {
        return x !== '';
    });
    if (arry.length > 10) {
        return 1;
    } else {
        for (var i = 0; i < arry.length; i++) {
            if (arry[i].length > 16) {
                return 2;
            } else {
                return arry.join(' ');
            }
        }
    }
    // }
}
// 验证数字为正数（包含小数）
function profitLossVal(val) {
    if (!/((^[1-9]\d*$)|(^[0-9]\d*\.\d+$))/.test(val)) {
        return false;
    } else {
        return true;
    }
}

/***/ }),

/***/ "AfG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZMMG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2a2c3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("kerX");
function injectStyle (ssrContext) {
  __webpack_require__("aif2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c2a2c3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2a2c3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ApJG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AujI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

// @charset "utf-8";

// import qs from 'qs'

// 拦截器 请求
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    // 用于服务端判断是否是ajax
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// 拦截器 响应
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (res) {
    // 维护中
    if (res.data.errorcode === 5001 && res.data.errormsg === 'maintenence') {
        window.location.href = '/maintenance.html';
        throw new Error('平台维护中');
    }
    // 没权限
    if (res.data.errorcode === -401 && res.data.errormsg === 'noauth') {
        // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
        window.LoginInstance.show();
        throw new Error('用户未登录');
    }
    return res;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

/***/ }),

/***/ "B4ZY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C1Bi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__ = __webpack_require__("RarY");
//
//
//
//
//
//

/* eslint-disable no-new */
/* global WdatePicker */


var chart = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            detailContent: '',
            backtestContent: '',
            // 日期选择相关
            minDate: '',
            maxDate: '',
            // 范围选择按钮
            rangeButtons: [{ text: '全部', type: 'all', days: 0 }, { text: '一周', type: 'week', days: 7 }, { text: '一月', type: 'month', days: 30 }, { text: '一季', type: 'quarter', days: 90 }, { text: '半年', type: 'halfYear', days: 180 }, { text: '一年', type: 'year', days: 365 }],
            currentRange: 'all'
        };
    },

    props: {
        profitdata: {
            type: [Array, Object],
            required: true
        },
        dayselect: {
            type: Array,
            required: true
        },
        HSData: {
            type: Array,
            required: true
        },
        defaultSelectedDay: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    computed: {
        detailContentPoint: function detailContentPoint() {
            return this.$buriedPoint.strategyDetails.profitChart.zoomSwitch;
        },
        backtestContentPoint: function backtestContentPoint() {
            return this.$buriedPoint.strategyBacktest.profitChart.zoomSwitch;
        }
    },
    methods: {
        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        _requestChartData: function _requestChartData() {
            this.updateChartData();
        },
        _debouce: function _debouce(func, wait, immediate) {
            var timeout;
            var f = function f() {
                var context = this;
                var args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
            return f;
        },

        changeDateVal: function changeDateVal(date) {
            return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6);
        },
        getTime: function getTime(date) {
            var dateStr = this.changeDateVal(date);
            return new Date(dateStr).getTime();
        },
        getChartOptions: function getChartOptions(seriesData) {
            var allDates = [];
            seriesData.forEach(function (series) {
                series.data.forEach(function (item) {
                    if (allDates.indexOf(item[0]) === -1) {
                        allDates.push(item[0]);
                    }
                });
            });
            allDates.sort(function (a, b) {
                return a - b;
            });

            if (allDates.length > 0) {
                this.minDate = this.changeDateVal(String(allDates[0]).substring(0, 8));
                this.maxDate = this.changeDateVal(String(allDates[allDates.length - 1]).substring(0, 8));
            }

            // 将数据转换为百分比变化（compare: 'percent' 效果）
            // 同时保存原始数值用于 tooltip 显示
            seriesData.forEach(function (series) {
                var firstValue = series.data.length > 0 ? series.data[0][1] : 0;
                series.originalData = series.data.map(function (item) {
                    return [item[0], item[1]];
                });
                series.data = series.data.map(function (item) {
                    // 计算相对于第一个点的百分比变化
                    var percentChange = 0;
                    if (firstValue !== 0 && firstValue !== null && firstValue !== undefined) {
                        percentChange = (item[1] - firstValue) / Math.abs(firstValue) * 100;
                    }
                    return [item[0], percentChange];
                });
            });

            return {
                legend: {
                    show: true,
                    align: 'left',
                    top: 0,
                    left: 0,
                    data: seriesData.map(function (s) {
                        return s.name;
                    }),
                    icon: 'roundRect',
                    itemWidth: 20,
                    itemHeight: 3
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderColor: '#ddd',
                    borderWidth: 1,
                    padding: [10, 15],
                    textStyle: {
                        color: '#333',
                        fontSize: 13
                    },
                    formatter: function formatter(params) {
                        if (!params || params.length === 0) return '';

                        var dateObj = new Date(params[0].axisValue);
                        var date = dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate();
                        var html = '<div style="font-size:13px;line-height:18px;margin-bottom:5px;">' + date + '</div>';
                        params.forEach(function (item) {
                            var color = item.color;
                            var percentValue = item.value[1]; // 百分比变化值
                            var seriesName = item.seriesName;

                            // 百分比变化颜色
                            var changeColor = percentValue >= 0 ? 'red' : 'green';

                            html += '<div style="line-height:18px;">';
                            html += '<span style="display:inline-block;width:10px;height:10px;background:' + color + ';margin-right:5px;border-radius:2px;"></span>';
                            html += seriesName + '：';
                            html += '(<span style="color:' + changeColor + '">' + (percentValue !== null ? percentValue.toFixed(2) : '--') + '%</span>)';
                            html += '</div>';
                        });

                        return html;
                    }
                },
                grid: {
                    left: 60,
                    right: 60,
                    top: 50,
                    bottom: 80
                },
                xAxis: {
                    type: 'time',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#e0e0e0'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#666',
                        fontSize: 11,
                        formatter: function formatter(value) {
                            var date = new Date(value);
                            var month = (date.getMonth() + 1).toString().padStart(2, '0');
                            var day = date.getDate().toString().padStart(2, '0');
                            return month + '-' + day;
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#f0f0f0',
                            type: 'dashed'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    position: 'right',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#e0e0e0'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#666',
                        fontSize: 11,
                        formatter: function formatter(value) {
                            return value.toFixed(2) + '%';
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#f0f0f0',
                            type: 'dashed'
                        }
                    },
                    scale: true
                },
                dataZoom: [{
                    type: 'slider',
                    show: true,
                    xAxisIndex: 0,
                    start: 0,
                    end: 100,
                    height: 20,
                    bottom: 10,
                    left: 60,
                    right: 60,
                    borderColor: 'transparent',
                    backgroundColor: '#f9f9f9',
                    fillerColor: 'rgba(63, 82, 180, 0.2)',
                    handleSize: '100%',
                    handleStyle: {
                        color: '#3f52b4',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.3)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2
                    },
                    textStyle: {
                        color: '#8a8b8c'
                    },
                    dataBackground: {
                        lineStyle: {
                            color: '#ddd'
                        },
                        areaStyle: {
                            color: '#eee'
                        }
                    }
                }, {
                    type: 'inside',
                    xAxisIndex: 0,
                    start: 0,
                    end: 100
                }],
                series: seriesData
            };
        },
        updateChartData: function updateChartData() {
            var key;
            var index;
            var num;
            var dateData = [];
            var visibled = false;
            var series = [];

            // 添加沪深300数据
            var hsdata = [];
            for (num in this.HSData) {
                var time = this.HSData[num]['timestamp'];
                var timeInt = this.getTime(time);
                var data = this.HSData[num]['value'];
                hsdata.push([timeInt, data]);
                dateData.push(this.changeDateVal(time));
            }
            series.push({
                data: hsdata,
                name: '沪深300',
                type: 'line',
                symbol: 'none',
                lineStyle: {
                    width: 1.5,
                    color: '#999'
                }
            });

            // 添加策略数据
            for (key in this.profitdata) {
                var strategyData = [];
                var ItemDaySaleStrategy = Number(this.profitdata[key]['daySaleStrategy']);
                if (this.defaultSelectedDay.indexOf(ItemDaySaleStrategy) >= 0) {
                    visibled = true;
                } else {
                    visibled = false;
                }
                var backtestData = this.profitdata[key].everydayIncome;
                for (index in backtestData) {
                    var date = backtestData[index][0];
                    var dateInt = this.getTime(date);
                    var algoProfit = backtestData[index][1];
                    strategyData.push([dateInt, algoProfit]);
                    if (dateData.indexOf(this.changeDateVal(date)) === -1) {
                        dateData.push(this.changeDateVal(date));
                    }
                }
                series.push({
                    data: strategyData,
                    name: this.dayselect[key] + '天',
                    type: 'line',
                    symbol: 'none',
                    lineStyle: {
                        width: 1.5
                    },
                    visible: visibled
                });
            }

            if (chart !== null) {
                this.hasChart = true;
                chart.dispose();
                chart = null;
            }

            chart = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(this.$refs.chartRef);
            chart.setOption(this.getChartOptions(series));

            var self = this;
            // 绑定日期选择器事件
            this.$nextTick(function () {
                self.bindDatePickerEvents();
            });

            chart.on('datazoom', function () {
                function a() {
                    window.TA.log(self.detailContentPoint);
                }
                function b() {
                    window.TA.log(self.backtestContentPoint);
                }
                if (self.detailContent) {
                    self._debouce(a, 500, true)();
                } else {
                    self._debouce(b, 500, true)();
                }
            });

            window.addEventListener('resize', function () {
                if (chart) {
                    chart.resize();
                }
            });
        },
        bindDatePickerEvents: function bindDatePickerEvents() {
            var self = this;
            var chartDom = this.$refs.chartRef;
            if (!chartDom) return;

            // 查找所有dataZoom的输入框
            var inputs = chartDom.querySelectorAll('.ec-dataZoom-input');
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].addEventListener('focus', function () {
                    new WdatePicker({
                        el: this,
                        maxDate: self.maxDate,
                        minDate: self.minDate,
                        isShowClear: false,
                        readOnly: true,
                        onpicked: function onpicked() {
                            this.onchange();
                            this.onblur();
                            this.blur();
                        }
                    });
                });
            }
        },
        handleRangeClick: function handleRangeClick(type, days) {
            this.currentRange = type;
            if (!chart) return;

            var allDates = [];
            chart.getOption().series[0].data.forEach(function (item) {
                allDates.push(item[0]);
            });

            if (days === 0 || allDates.length <= 1) {
                // 全部
                chart.dispatchAction({
                    type: 'dataZoom',
                    start: 0,
                    end: 100
                });
            } else {
                // 计算开始和结束位置
                var endTime = allDates[allDates.length - 1];
                var startTime = endTime - days * 24 * 3600 * 1000;

                // 找到最近的开始索引
                var startIndex = 0;
                for (var i = 0; i < allDates.length; i++) {
                    if (allDates[i] >= startTime) {
                        startIndex = i;
                        break;
                    }
                }

                var startPercent = startIndex / allDates.length * 100;
                chart.dispatchAction({
                    type: 'dataZoom',
                    start: startPercent,
                    end: 100
                });
            }
        }
    },
    mounted: function mounted() {
        this._requestChartData();
        this.detailContent = document.getElementsByClassName('strategydetailmain')[0];
        this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0];
    },

    watch: {
        profitdata: function profitdata() {
            this.updateChartData();
        }
    }
});

/***/ }),

/***/ "C33N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CeXA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"item-left"},[_c('div',{staticClass:"item-logo"},[_c('router-link',{key:_vm.strategyId,attrs:{"to":'/strategysquare/' + _vm.strategyId}},[_c('img',{attrs:{"src":'/svg/' + _vm.strategyId + '.svg'}})])],1)]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"item-right-t"},[_c('div',{staticClass:"item-details"},[_c('router-link',{key:_vm.strategyId,attrs:{"to":'/strategysquare/' + _vm.strategyId}},[_c('h3',{on:{"click":_vm.buriedPoints}},[_vm._v(_vm._s(_vm.strategyName))])]),_vm._v(" "),_c('div',{staticClass:"item-label"},_vm._l((_vm.strategyTags),function(item,index){return (item)?_c('span',{key:index},[_vm._v(_vm._s(item))]):_vm._e()}),0),_vm._v(" "),_c('p',[_c('b',[_vm._v("投资逻辑：")]),_vm._v(_vm._s(_vm.strategyLogic))])],1),_vm._v(" "),_c('div',{staticClass:"item-annual-income"},[_c('p',{class:_vm._f("riseAndFallClass")(_vm.strategyAnnualYield)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.strategyAnnualYield)))]),_vm._v(" "),_c('span',[_vm._v("年化收益")])]),_vm._v(" "),_c('div',{staticClass:"item-success-rate"},[_c('p',{class:_vm._f("riseAndFallClass")(_vm.strategyWinRate)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.strategyWinRate)))]),_vm._v(" "),_c('span',[_vm._v("成功率")])]),_vm._v(" "),_c('div',{staticClass:"item-user"},[_c('div',{staticClass:"item-user-img right"},[_c('img',{attrs:{"src":_vm.strategyAvatar}})]),_vm._v(" "),_c('p',{staticClass:"right"},[_vm._v(_vm._s(_vm.strategyUser))])])]),_vm._v(" "),_c('div',{staticClass:"item-right-b"},[_c('div',{staticClass:"item-comment"},[_c('span',[_vm._v("评论("+_vm._s(_vm.strategyCommentNum)+")")])]),_vm._v(" "),_c('div',{staticClass:"item-collect",class:_vm.isCollected ? 'active' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.isCollected ? _vm.removeCollection(_vm.strategyId) : _vm.addCollection(_vm.strategyId)}}},[_c('div',{staticClass:"item-collect"},[_c('span',[_vm._v(_vm._s(_vm.isCollected ? '已收藏' : '收藏(' + _vm.strategyCollectNum + ')'))])])]),_vm._v(" "),(_vm.isshowitemstock)?_c('div',{staticClass:"item-stock",class:_vm.isshoworder ? 'active': '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.isshoworder ? _vm.closeTodayStock(_vm.strategyId) : _vm.showTodayStock(_vm.strategyId)}}},[_c('span',[_vm._v("今日选股")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-set-date"},[_c('span',[_vm._v("创建时间："+_vm._s(_vm.strategyCtime))])])]),_vm._v(" "),_c('pickstock',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshoworder),expression:"isshoworder"}],attrs:{"transactiontype":'' + _vm.strategyType,"select-data":_vm.pickData,"classname":'item-stock-list',"buy-position":_vm.buyPosition}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CjS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
// @charset "utf-8"



var state = {
    // 回测一下
    backtestOnceData: {},
    backtestOnceParams: {},

    // 策略回测
    tradeBacktestData: {},
    tradeBacktestParams: {},

    // 收藏回测
    collectBacktestData: {},
    collectBacktestParams: {},

    // 收到的评论
    receiveDiscussData: {},
    receiveDiscussParams: {},

    // 发出的评论
    sendDiscussData: {},
    sendDiscussParams: {}
};
var mutations = {
    updateBacktestOnceData: function updateBacktestOnceData(state, data) {
        state.backtestOnceData = data;
    },
    updateBacktestOnceParams: function updateBacktestOnceParams(state, data) {
        state.backtestOnceParams = data;
    },
    updateTradeBacktestData: function updateTradeBacktestData(state, data) {
        state.tradeBacktestData = data;
    },
    updateTradeBacktestParams: function updateTradeBacktestParams(state, data) {
        state.tradeBacktestParams = data;
    },
    updateCollectBacktestData: function updateCollectBacktestData(state, data) {
        state.collectBacktestData = data;
    },
    updateCollectBacktestParams: function updateCollectBacktestParams(state, data) {
        state.collectBacktestParams = data;
    },
    updateReceiveDiscussData: function updateReceiveDiscussData(state, data) {
        state.receiveDiscussData = data;
    },
    updateReceiveDiscussParams: function updateReceiveDiscussParams(state, data) {
        state.receiveDiscussParams = data;
    },
    updateSendDiscussData: function updateSendDiscussData(state, data) {
        state.sendDiscussData = data;
    },
    updateSendDiscussParams: function updateSendDiscussParams(state, data) {
        state.sendDiscussParams = data;
    }
};
var actions = {
    requestBacktestOnce: function requestBacktestOnce(context, params) {
        if (params === undefined) {
            params = context.state.backtestOnceParams;
        } else {
            context.commit('updateBacktestOnceParams', params);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/mybacktest/backtestonce', { params: params }).then(function (response) {
            var data = response.data;
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error');
            }
            return data.result;
        }).then(function (result) {
            context.commit('updateBacktestOnceData', result);
        });
    },
    requestTradeBacktest: function requestTradeBacktest(context, params) {
        if (params === undefined) {
            params = context.state.tradeBacktestParams;
        } else {
            context.commit('updateTradeBacktestParams', params);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/mybacktest/tradebacktest?order=desc&showmine=1', { params: params }).then(function (response) {
            var data = response.data;
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error');
            }
            return data.result;
        }).then(function (result) {
            context.commit('updateTradeBacktestData', result);
        });
    },
    requestCollectBacktest: function requestCollectBacktest(context, params) {
        if (params === undefined) {
            params = context.state.collectBacktestParams;
        } else {
            context.commit('updateCollectBacktestParams', params);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/mybacktest/tradebacktest?order=desc&showminecollect=1', { params: params }).then(function (response) {
            var data = response.data;
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error');
            }
            return data.result;
        }).then(function (result) {
            context.commit('updateCollectBacktestData', result);
        });
    },
    requestReceiveDiscuss: function requestReceiveDiscuss(context, params) {
        if (params === undefined) {
            params = context.state.collectBacktestParams;
        } else {
            context.commit('updateReceiveDiscussParams', params);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/querycomment?type=in', { params: params }).then(function (response) {
            var data = response.data;
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error');
            }
            return data.result;
        }).then(function (result) {
            context.commit('updateReceiveDiscussData', result);
        });
    },
    requestSendDiscuss: function requestSendDiscuss(context, params) {
        if (params === undefined) {
            params = context.state.collectBacktestParams;
        } else {
            context.commit('updateSendDiscussParams', params);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/querycomment?type=out', { params: params }).then(function (response) {
            var data = response.data;
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error');
            }
            return data.result;
        }).then(function (result) {
            context.commit('updateSendDiscussData', result);
        });
    }
};

var getters = {
    backtestOnceData: function backtestOnceData(state) {
        return state.backtestOnceData;
    },
    tradeBacktestData: function tradeBacktestData(state) {
        return state.tradeBacktestData;
    },
    collectBacktestData: function collectBacktestData(state) {
        return state.collectBacktestData;
    },
    receiveDiscussData: function receiveDiscussData(state) {
        return state.receiveDiscussData;
    },
    sendDiscussData: function sendDiscussData(state) {
        return state.sendDiscussData;
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "CnZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receive-discuss"},[_c('div',{staticClass:"discuss-list"},_vm._l((_vm.discussDataList),function(item,index){return _c('div',{key:index,staticClass:"list-item"},[_c('div',{staticClass:"item-left"},[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(item.nickname)),(item.bereply)?[_c('span',[_vm._v("回复")]),_vm._v(_vm._s(item.tonickname))]:_vm._e()],2),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(item.content)}}),_vm._v(" "),_c('div',{staticClass:"item-mix"},[_c('div',{staticClass:"mix-left"},[_c('span',{staticStyle:{}},[_vm._v(_vm._s(item.ctime))]),_vm._v(" "),_c('span',{staticClass:"item-report",on:{"click":function($event){return _vm.commentReport(item.pid, item.cid, item.userid)}}},[_vm._v("举报")])]),_vm._v(" "),_c('div',{staticClass:"mix-right"},[_c('span',{staticClass:"item-like",on:{"click":function($event){return _vm.commentLikes(item.pid, item.cid, item)}}},[_vm._v("赞同("+_vm._s(item.likes)+")")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.isShowInputDiscuss(index)}}},[_vm._v(_vm._s(_vm.clickIndex !== index ? '回复' : '收起回复'))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.clickIndex),expression:"index === clickIndex"}],staticClass:"input-discuss"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputDiscuss),expression:"inputDiscuss"}],domProps:{"value":(_vm.inputDiscuss)},on:{"keyup":_vm.changeInput,"input":function($event){if($event.target.composing){ return; }_vm.inputDiscuss=$event.target.value}}}),_vm._v(" "),_c('button',{class:_vm.isdiscusscontent ? 'active' : '',on:{"click":function($event){return _vm.submitDiscuss(item.pid, item.userid, item.cid, item)}}},[_vm._v("回复")])])])}),0),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DwA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            visible: false,
            message: '',
            duration: 2000,
            type: 'info',
            // iconClass: '',
            customClass: '',
            onClose: null,
            // showClose: false,
            closed: false,
            timer: null,
            // top: '30%'
            top: '8%',
            right: '3%'
        };
    },

    computed: {
        iconSrc: function iconSrc() {
            //  eslint-disable template-curly-spacing
            // return require(`@img/tip-${ this.type }.png`)
            return this.type;
        },
        style: function style() {
            // return {'top': this.top}
            return { 'top': this.top, 'right': this.right };
        }
    },

    watch: {
        closed: function closed(newVal) {
            if (newVal) {
                this.visible = false;
                this.$el.addEventListener('transitionend', this.destroyElement);
            }
        }
    },

    methods: {
        destroyElement: function destroyElement() {
            this.$el.removeEventListener('transitionend', this.destroyElement);
            this.$destroy(true);
            this.$el.parentNode.removeChild(this.$el);
        },

        close: function close() {
            this.closed = true;
            if (typeof this.onClose === 'function') {
                this.onClose(this);
            }
        },

        clearTimer: function clearTimer() {
            clearTimeout(this.timer);
        },

        startTimer: function startTimer() {
            var self = this;
            if (this.duration > 0) {
                this.timer = setTimeout(function () {
                    if (!self.closed) {
                        self.close();
                    }
                }, this.duration);
            }
        }
    },

    mounted: function mounted() {
        this.startTimer();
    }
});

/***/ }),

/***/ "E3iP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// @charset "utf-8";
/* eslint-disable */
/*
 * 点击元素外面触发事件
 * e.g. <div v-click-outside="hideSourceSelect"></div>
 *
 */

var nodeList = [];
var ctx = 'thsClickoutsideContext'; // 同命名空间的意思
// var startClick = void 0; // 同 undefind 区 别：undefind 可被重写（非严格模式下），void 0不会被重写
var startClick = void 0;

// !Vue.prototype.$isServer && on(document, 'mousedown', e => (startClick = e));

document.body.addEventListener('mousedown', function (e) {
    return startClick = e;
}, false);
document.body.addEventListener('touchstart', function (e) {
    return startClick = e;
}, false);

// !Vue.prototype.$isServer && on(document, 'mouseup', e => {
//   nodeList.forEach(node => node[ctx].documentHandler(e, startClick));
// });
document.body.addEventListener('mouseup', function (e) {
    nodeList.forEach(function (node) {
        return node[ctx].documentHandler(e, startClick);
    });
}, false);
document.body.addEventListener('touchend', function (e) {
    nodeList.forEach(function (node) {
        return node[ctx].documentHandler(e, startClick);
    });
}, false);

/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function bind(el, binding, vnode) {
        var id = nodeList.push(el) - 1;
        var documentHandler = function documentHandler() {
            // 获取参数 鼠标事件
            var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // dom包含 鼠标按下（or松开）的区域 则return，即不执行绑定的事件
            if (!vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
            if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
                vnode.context[el[ctx].methodName]();
            } else {
                el[ctx].bindingFn && el[ctx].bindingFn();
            }
        };
        el[ctx] = {
            id: id,
            documentHandler: documentHandler,
            methodName: binding.expression,
            bindingFn: binding.value
        };
    },
    update: function update(el, binding) {
        el[ctx].methodName = binding.expression;
        el[ctx].bindingFn = binding.value;
    },
    unbind: function unbind(el) {
        var len = nodeList.length;

        for (var i = 0; i < len; i++) {
            if (nodeList[i][ctx].id === el[ctx].id) {
                nodeList.splice(i, 1);
                break;
            }
        }
    }

    /*  // 这种当然也行，上面的方法考虑更全面
      bind (el, binding, vnode) {
          var id = nodeList.push(el) - 1;
          // el.event
          var documentHandler = function (event) {
              if (el !== event.target && !el.contains(event.target)) {
                  vnode.context[binding.expression](event)
              }
          }
          el[ctx] = {
              id: id,
              documentHandler: documentHandler,
              methodName: binding.expression,
              bindingFn: binding.value
          };
          // el.addEventListener('click', el.stopPropagation())
          // document.body.addEventListener('click', el.event)
      },
      unbind (el) {
          // el.removeEventListener('click', el.stopPropagation())
          // document.body.removeEventListener('click', el.event)
      }
    */

});

/***/ }),

/***/ "EGRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_release_dialog_vue__ = __webpack_require__("Sj4g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185cfc15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_release_dialog_vue__ = __webpack_require__("dXt9");
function injectStyle (ssrContext) {
  __webpack_require__("QYgY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-185cfc15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_release_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185cfc15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_release_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EGgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pager__ = __webpack_require__("xoWB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Pagination',
    data: function data() {
        return {
            internalCurrentPage: 1,
            internalPageSize: 0
        };
    },
    props: {
        pageSize: {
            type: Number,
            default: 10
        },

        small: Boolean,

        total: Number,

        pageCount: Number,

        currentPage: {
            type: Number,
            default: 1
        },

        layout: {
            default: 'prev, pager, next, jumper, ->, total'
        },

        pageSizes: {
            type: Array,
            default: function _default() {
                return [10, 20, 30, 40, 50, 100];
            }
        },

        goVisible: {
            type: Boolean,
            default: false
        },

        totalVisible: {
            type: Boolean,
            default: false
        }
    },

    components: {
        // MySlot: {
        //     template: this.$parent.$slots.default ? this.$parent.$slots.default[0] : ''
        // },
        // Prev: {
        //     render(h) {
        //         return (
        //             <button
        //             type="button"
        //             class={['btn-prev', { disabled: this.$parent.internalCurrentPage <= 1 }]}
        //             on-click={ this.$parent.prev }>
        //             <i class="el-icon el-icon-arrow-left"></i>
        //         </button>
        //         )
        //     }
        // },

        // Next: {
        //     render(h) {
        //         return (
        //             <button
        //             type="button"
        //             class={[
        //                 'btn-next',
        //                 { disabled: this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0 }
        //                 ]}
        //                 on-click={ this.$parent.next }>
        //                 <i class="el-icon el-icon-arrow-right"></i>
        //             </button>
        //             )
        //     }
        // },

        // Sizes: {
        //     mixins: [Locale],

        //     props: {
        //         pageSizes: Array
        //     },

        //     watch: {
        //         pageSizes: {
        //             immediate: true,
        //             handler(value) {
        //                 if (Array.isArray(value)) {
        //                     this.$parent.internalPageSize = value.indexOf(this.$parent.pageSize) > -1
        //                     ? this.$parent.pageSize
        //                     : this.pageSizes[0]
        //                 }
        //             }
        //         }
        //     },

        //     render(h) {
        //         return (
        //             <span class="el-pagination__sizes">
        //                 <el-select
        //                 value={ this.$parent.internalPageSize }
        //                 on-input={ this.handleChange }>
        //                 {
        //                     this.pageSizes.map(item =>
        //                         <el-option
        //                         value={ item }
        //                         label={ item + ' ' + this.t('el.pagination.pagesize') }>
        //                     </el-option>
        //                     )
        //                 }
        //             </el-select>
        //         </span>
        //         )
        //     },

        //     components: {
        //         ElSelect,
        //         ElOption
        //     },

        //     methods: {
        //         handleChange(val) {
        //             if (val !== this.$parent.internalPageSize) {
        //                 this.$parent.internalPageSize = val = parseInt(val, 10)
        //                 this.$parent.$emit('size-change', val)
        //             }
        //         }
        //     }
        // },

        // Jumper: {
        //     mixins: [Locale],

        //     data() {
        //         return {
        //             oldValue: null
        //         }
        //     },

        //     methods: {
        //         handleFocus(event) {
        //             this.oldValue = event.target.value
        //         },

        //         handleChange({ target }) {
        //             this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(target.value)
        //             this.oldValue = null
        //         }
        //     },

        //     render(h) {
        //         return (
        //         <span class="el-pagination__jump">
        //             { this.t('el.pagination.goto') }
        //             <input
        //             class="el-pagination__editor"
        //             type="number"
        //             min={ 1 }
        //             max={ this.internalPageCount }
        //             value={ this.$parent.internalCurrentPage }
        //             domProps-value={ this.$parent.internalCurrentPage }
        //             on-change={ this.handleChange }
        //             on-focus={ this.handleFocus }
        //             number/>
        //             { this.t('el.pagination.pageClassifier') }
        //         </span>
        //         )
        //     }
        // },

        // Total: {
        //     mixins: [Locale],

        //     render(h) {
        //         return (
        //         typeof this.$parent.total === 'number'
        //         ? <span class="el-pagination__total">{ this.t('el.pagination.total', { total: this.$parent.total }) }</span>
        //         : ''
        //         )
        //     }
        // },

        pager: __WEBPACK_IMPORTED_MODULE_0__pager__["a" /* default */]
    },

    methods: {
        handleCurrentChange: function handleCurrentChange(val) {
            this.internalCurrentPage = this.getValidCurrentPage(val);
        },

        prev: function prev() {
            var newVal = this.internalCurrentPage - 1;
            this.internalCurrentPage = this.getValidCurrentPage(newVal);
        },

        next: function next() {
            var newVal = this.internalCurrentPage + 1;
            this.internalCurrentPage = this.getValidCurrentPage(newVal);
        },

        getValidCurrentPage: function getValidCurrentPage(value) {
            value = parseInt(value, 10);

            var havePageCount = typeof this.internalPageCount === 'number';

            var resetValue;
            if (!havePageCount) {
                if (isNaN(value) || value < 1) resetValue = 1;
            } else {
                if (value < 1) {
                    resetValue = 1;
                } else if (value > this.internalPageCount) {
                    resetValue = this.internalPageCount;
                }
            }

            if (resetValue === undefined && isNaN(value)) {
                resetValue = 1;
            } else if (resetValue === 0) {
                resetValue = 1;
            }

            return resetValue === undefined ? value : resetValue;
        },
        gotoPage: function gotoPage(event) {
            event.target.value = this.internalCurrentPage = this.getValidCurrentPage(event.target.value);
        }
    },

    computed: {
        internalPageCount: function internalPageCount() {
            if (typeof this.total === 'number') {
                return Math.ceil(this.total / this.internalPageSize);
            } else if (typeof this.pageCount === 'number') {
                return this.pageCount;
            }
            return null;
        }
    },

    watch: {
        currentPage: {
            immediate: true,
            handler: function handler(val) {
                this.internalCurrentPage = val;
            }
        },

        pageSize: {
            immediate: true,
            handler: function handler(val) {
                this.internalPageSize = val;
            }
        },

        internalCurrentPage: function internalCurrentPage(newVal, oldVal) {
            newVal = parseInt(newVal, 10);

            /* istanbul ignore if */
            if (isNaN(newVal)) {
                newVal = oldVal || 1;
            } else {
                newVal = this.getValidCurrentPage(newVal);
            }

            if (newVal !== undefined) {
                this.$nextTick(function () {
                    this.internalCurrentPage = newVal;
                    if (oldVal !== newVal) {
                        this.$emit('update:currentPage', newVal);
                        this.$emit('current-change', this.internalCurrentPage);
                    }
                });
            } else {
                this.$emit('update:currentPage', newVal);
                this.$emit('current-change', this.internalCurrentPage);
            }
        },

        internalPageCount: function internalPageCount(newVal) {
            /* istanbul ignore if */
            var oldPage = this.internalCurrentPage;
            if (newVal > 0 && oldPage === 0) {
                this.internalCurrentPage = 1;
            } else if (oldPage > newVal) {
                this.internalCurrentPage = newVal === 0 ? 1 : newVal;
            }
        }
    }
});

/***/ }),

/***/ "EX75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution"},[_c('div',{staticClass:"distribution_title"},[_c('p',[_vm._v("涨跌分布图")]),_vm._v(" "),_c('div',{staticClass:"distribution_chart_select"},[_c('p',[_vm._v("持股周期 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDay),expression:"selectedDay"}],staticClass:"chary_select",on:{"click":_vm.charySelect,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDay=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dayselect),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 天")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"distribution_main"},[_c('div',{ref:"chartRef",staticStyle:{"width":"475px","height":"250px","margin":"10px auto 0 auto","border":"1px solid #d6d6d6"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FZS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_key_list__ = __webpack_require__("c71g");
// @charset "utf-8";
// 混合对象 mixins


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'key-list': __WEBPACK_IMPORTED_MODULE_0__lib_key_list__["a" /* default */]
    },
    data: function data() {
        return {
            defaultSentence: '',
            searchVis: false,
            searchList: [],
            filterKey: [37, 38, 39, 40, 13],
            chunkSeparator: [',', '，', ';', '；', '。', ' ']
        };
    },

    methods: {
        hideSearchList: function hideSearchList() {
            this.searchVis = false;
        },
        updateInput: function updateInput(value) {
            this.sentence = value;
        },
        nochecked: function nochecked() {
            this.sentence = this.defaultSentence;
        }
    }
});

/***/ }),

/***/ "FdYl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategy-square"},[_c('div',{staticClass:"strategy-square-head"},[_c('div',{staticClass:"head-search left"},[_c('span',[_vm._v("交易策略")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeStraKeyWord),expression:"tradeStraKeyWord"}],attrs:{"type":"text","placeholder":"搜索关键词"},domProps:{"value":(_vm.tradeStraKeyWord)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateSearch.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeStraKeyWord=$event.target.value}}}),_vm._v(" "),_c('span',{on:{"click":_vm.updateSearch}})])]),_vm._v(" "),_c('div',{staticClass:"head-sort right"},[_c('label',[_c('span',[_vm._v("排序 : ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortSelect),expression:"sortSelect"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sortSelect=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateSort]}},_vm._l((_vm.sortSelectList),function(item,index){return _c('option',{key:index,domProps:{"value":item.value}},[_vm._v("\n                        "+_vm._s(item.text)+"\n                    ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"strategy-square-body"},[_c('vue-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),(!_vm.loading && _vm.strategyDataList.length === 0)?_c('p',[_vm._v("暂无查询列表数据")]):_vm._e(),_vm._v(" "),(_vm.strategyDataList.length !== 0)?_c('div',{staticClass:"body-data-list"},_vm._l((_vm.strategyDataList),function(item,i){return _c('item-row',{key:i,attrs:{"index-serial":i,"page":_vm.currentPage,"strategy-id":item.property.id,"buy-position":parseInt(item.property.buyPosition),"strategy-name":item.property.name,"strategy-logic":item.property.logic,"strategy-ctime":item.property.ctime,"strategy-annual-yield":item.property.annualYield,"strategy-win-rate":item.property.winRate,"strategy-tags":item.property.tags,"strategy-user":item.author.userName,"strategy-avatar":item.author.avatar,"strategy-user-id":item.author.userId,"strategy-collect-num":item.interaction.collectNum,"strategy-comment-num":item.interaction.commentNum,"strategy-is-collected":item.interaction.isCollected,"reset-stock":_vm.resetStock,"strategy-type":item.property.type}})}),1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fe+q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GB74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var chart = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            selectedDay: '',
            selectedSignal: '',
            detailContent: '',
            backtestContent: '',
            chartKeyMap: {
                'lt-7.5': {
                    name: '涨跌幅：小于-7.5%',
                    color: '#259b24'
                },
                'egt-7.5&lt-3.5': {
                    name: '涨跌幅：-3.5%到-7.5%',
                    color: '#42bd41'
                },
                'egt-3.5&lt0': {
                    name: '涨跌幅：-3.5%到0%',
                    color: '#72d572'
                },
                'egt0&lt3.5': {
                    name: '涨跌幅：0%到3.5%',
                    color: '#f36c60'
                },
                'egt3.5&lt7.5': {
                    name: '涨跌幅：3.5%到7.5%',
                    color: '#e93f43'
                },
                'egt7.5': {
                    name: '涨跌幅：大于7.5%',
                    color: '#d01716'
                }
            }
        };
    },

    props: {
        strategyId: {
            type: String
        },
        // 回测id
        backtestId: {
            type: String,
            required: true
        },
        daySelect: {
            type: Array,
            required: true
        },
        profitGroupData: [Array, Object],
        maxWinrate: Array,
        transactiontype: String,
        signalData: Object,
        refresh: Boolean,
        marketSignals: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    computed: {
        chartSeriesData: function chartSeriesData() {
            var self = this;
            var profitGroupData;
            if (this.transactiontype === '2') {
                profitGroupData = this.profitGroupData[this.selectedSignal];
            } else {
                profitGroupData = this.profitGroupData;
            }
            var singleBacktestdata = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(profitGroupData, function (item) {
                return item.daySaleStrategy === Number(self.selectedDay);
            });
            var ordinaryRateGroup = {
                'egt-3.5&lt0': 0,
                'egt-7.5&lt-3.5': 0,
                'egt0&lt3.5': 0,
                'egt3.5&lt7.5': 0,
                'egt7.5': 0,
                'lt-7.5': 0
            };
            if (singleBacktestdata !== undefined) {
                ordinaryRateGroup = singleBacktestdata.profitGroup;
            }
            var result = [];
            for (var key in ordinaryRateGroup) {
                result.push({
                    name: this.chartKeyMap[key].name,
                    value: ordinaryRateGroup[key],
                    itemStyle: {
                        color: this.chartKeyMap[key].color
                    }
                });
            }
            return result;
        },
        chartOptions: function chartOptions() {
            return {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                series: [{
                    name: '占比次数',
                    type: 'pie',
                    radius: ['0', '60%'],
                    center: ['50%', '50%'],
                    avoidLabelOverlap: true,
                    itemStyle: {
                        borderWidth: 0
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    data: this.chartSeriesData
                }]
            };
        },
        detailContentPoint: function detailContentPoint() {
            return this.$buriedPoint.strategyDetails.upsDownsChart;
        },
        backtestContentPoint: function backtestContentPoint() {
            return this.$buriedPoint.strategyBacktest.upsDownsChart;
        }
    },
    methods: {
        charySelect: function charySelect() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.cycleOption.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.cycleOption);
            }
        },
        charySelectTow: function charySelectTow() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.timingOption.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.timingOption);
            }
        },
        init: function init() {
            if (this.transactiontype === '2') {
                this.selectedDay = this.maxWinrate[2];
                this.selectedSignal = this.maxWinrate[1];
            } else {
                this.selectedDay = this.maxWinrate[1];
            }
        },
        renderChart: function renderChart() {
            if (chart) {
                chart.dispose();
                chart = null;
            }

            chart = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(this.$refs.chartRef);
            chart.setOption(this.chartOptions);
        }
    },
    mounted: function mounted() {
        this.renderChart();
        this.detailContent = document.getElementsByClassName('strategydetailmain')[0];
        this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0];
    },
    created: function created() {
        this.init();
    },

    watch: {
        backtestId: function backtestId() {
            this.init();
            chart.setOption({
                series: [{
                    data: this.chartSeriesData
                }]
            });
        },
        refresh: function refresh() {
            this.init();
        },
        selectedDay: function selectedDay() {
            chart.setOption({
                series: [{
                    data: this.chartSeriesData
                }]
            });
        },
        selectedSignal: function selectedSignal() {
            chart.setOption({
                series: [{
                    data: this.chartSeriesData
                }]
            });
        },
        chartOptions: function chartOptions() {
            this.renderChart();
        }
    }
});

/***/ }),

/***/ "Gyi1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart__ = __webpack_require__("SHHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__history__ = __webpack_require__("NOyp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__release_dialog__ = __webpack_require__("EGRn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__backtest_analysis__ = __webpack_require__("Ze1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__strategy_select__ = __webpack_require__("wC/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__profit_chart__ = __webpack_require__("ac+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__report_grade__ = __webpack_require__("gG4O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_wDatePicker_js__ = __webpack_require__("RarY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__backtest_backtest_base__ = __webpack_require__("FZS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'strategybacktest',
    mixins: [__WEBPACK_IMPORTED_MODULE_12__backtest_backtest_base__["a" /* default */]],
    components: {
        'change-rate-group': __WEBPACK_IMPORTED_MODULE_4__chart__["a" /* default */],
        'history-detail': __WEBPACK_IMPORTED_MODULE_5__history__["a" /* default */],
        'release-dialog': __WEBPACK_IMPORTED_MODULE_6__release_dialog__["a" /* default */],
        'backtest-analysis': __WEBPACK_IMPORTED_MODULE_7__backtest_analysis__["a" /* default */],
        'strategy-select': __WEBPACK_IMPORTED_MODULE_8__strategy_select__["a" /* default */],
        'profit-chart': __WEBPACK_IMPORTED_MODULE_9__profit_chart__["a" /* default */],
        'report-grade': __WEBPACK_IMPORTED_MODULE_10__report_grade__["a" /* default */]
    },
    data: function data() {
        var yesDate = this._getNowDate();
        var self = this;
        var debounceQuestion = Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["debounce"])(function () {
            self.questionDataValidation(arguments[0], arguments[1]);
        }, 500);
        return {
            debounceQuestion: debounceQuestion,
            myBarOption: {
                // barColor: '#f60', // 滚动条颜色
                barWidth: 9, // 滚动条宽度
                // railColor: '#f5f5f5', // 导航颜色
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                // zIndex: 'auto', // 滚动条的z-index
                // autohidemode: true, // 自动隐藏模式
                horizrailenabled: false // 是否显示水平滚动条
            },
            id: '',
            isfinishshow: false,
            isshadowshow: false,
            isreleaseshow: false,
            backtestCompleted: false,
            isshowtestloading: false,
            checked: false,
            isPublish: 0,

            defaultQuery: {},
            defaultqueryLoading: true,
            sentence: '',
            number: '',
            capital: '100000',
            stockHold: '1',
            dayBuyStockNum: '1',
            upperIncome: '',
            lowerIncome: '',
            fallIncome: '',
            bearMarketUpperIncome: '',
            bearMarketLowerIncome: '',
            bearMarketFallIncome: '',
            transactiontype: '1',
            currentBacktestType: '1',
            buyPosition: 0,
            tradeStartDate: '',
            tradeEndDate: '',
            yesterdayDate: yesDate,
            conditionData: [],
            reportData: {},
            scoreData: {},
            backtestData: [],
            profitGroupData: null,
            profitData: null,
            Hq300Data: [],
            pickData: null,
            currenttab: 'MACD',
            ismarketshow: false,
            signalType: {},
            signalData: {},
            marketsignals: [],
            engine: 'online',
            refresh: false,
            sharesselect: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
            buyPositionSelect: ['空仓', '10%仓位', '20%仓位', '30%仓位', '40%仓位', '50%仓位', '60%仓位', '70%仓位', '80%仓位', '90%仓位', '满仓'],
            paramKeys: {
                'query': 'sentence',
                'daysForSaleStrategy': 'number',
                'endDate': 'tradeEndDate',
                'startDate': 'tradeStartDate',
                'stockHoldCount': 'stockHold',
                'upperIncome': 'upperIncome',
                'lowerIncome': 'lowerIncome',
                'fallIncome': 'fallIncome',
                'dayBuyStockNum': 'dayBuyStockNum',
                'capital': 'capital'
            }
        };
    },

    computed: {
        userId: function userId() {
            return this.$store.getters['userInfo/userId'];
        },
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.strategyBacktest;
        },
        totalPoint: function totalPoint() {
            return this.$buriedPoint.totalPlatformAccess;
        },

        dayselect: function dayselect() {
            return this.number.split(',');
        },
        // 取最优的两条
        backtestAnalysisData: function backtestAnalysisData() {
            if (this.currentBacktestType === '1') {
                return this.backtestData;
            } else {
                var maxWinRate = this.reportData.maxWinRate;
                var maxAnnualYield = this.reportData.maxAnnualYield;

                var analysisData = {};
                analysisData[maxWinRate[1]] = this.backtestData[maxWinRate[1]];
                analysisData[maxAnnualYield[1]] = this.backtestData[maxAnnualYield[1]];
                return analysisData;
            }
        },

        // 取最优的两条
        bestMarketsignals: function bestMarketsignals() {
            if (this.currentBacktestType === '1') {
                return this.marketsignals;
            } else {
                var maxWinRate = this.reportData.maxWinRate;
                var maxAnnualYield = this.reportData.maxAnnualYield;
                if (maxWinRate[1] === maxAnnualYield[1]) {
                    return [maxWinRate[1]];
                } else {
                    return [maxWinRate[1], maxAnnualYield[1]];
                }
            }
        }
    },
    methods: {
        validateInput: function validateInput() {
            this.number = this.number.replace(/，/, ',');
        },
        qusetionCycle: function qusetionCycle() {
            window.TA.log(this.buriedPoint.strategyParam.holdingCycle);
        },
        startDatePoint: function startDatePoint() {
            window.TA.log(this.buriedPoint.strategyParam.startDate);
        },
        endDatePoint: function endDatePoint() {
            window.TA.log(this.buriedPoint.strategyParam.endDate);
        },
        sharesSelect: function sharesSelect() {
            if (parseInt(this.stockHold) < parseInt(this.dayBuyStockNum)) {
                this.dayBuyStockNum = this.stockHold;
            }
            window.TA.log(this.buriedPoint.strategyParam.holdingNumber);
        },
        commonModel: function commonModel() {
            window.TA.log(this.buriedPoint.strategyParam.commonRuleTrade);
        },
        marketModel: function marketModel() {
            window.TA.log(this.buriedPoint.strategyParam.marketTimingTrade);
        },
        commonTargetProfitRiseRapidly: function commonTargetProfitRiseRapidly() {
            window.TA.log(this.buriedPoint.commonRuleTrade.targetProfit.riseRapidly);
        },
        commonTargetProfitFall: function commonTargetProfitFall() {
            window.TA.log(this.buriedPoint.commonRuleTrade.targetProfit.fall);
        },
        commonStopProfit: function commonStopProfit() {
            window.TA.log(this.buriedPoint.commonRuleTrade.stopProfit);
        },
        marketStrongTargetProfitRiseRapidly: function marketStrongTargetProfitRiseRapidly() {
            window.TA.log(this.buriedPoint.marketTimingTrade.strong.targetProfit.riseRapidly);
        },
        marketStrongTargetProfitFall: function marketStrongTargetProfitFall() {
            window.TA.log(this.buriedPoint.marketTimingTrade.strong.targetProfit.fall);
        },
        marketStrongStopProfit: function marketStrongStopProfit() {
            window.TA.log(this.buriedPoint.marketTimingTrade.strong.stopProfit);
        },
        marketWeakTargetProfitRiseRapidly: function marketWeakTargetProfitRiseRapidly() {
            window.TA.log(this.buriedPoint.marketTimingTrade.weak.targetProfit.riseRapidly);
        },
        marketWeakTargetProfitFall: function marketWeakTargetProfitFall() {
            window.TA.log(this.buriedPoint.marketTimingTrade.weak.targetProfit.fall);
        },
        marketWeakStopProfit: function marketWeakStopProfit() {
            window.TA.log(this.buriedPoint.marketTimingTrade.weak.stopProfit);
        },
        marketWeakPositionControl: function marketWeakPositionControl() {
            window.TA.log(this.buriedPoint.marketTimingTrade.weak.positionControl);
        },
        empty: function empty() {
            this.sentence = '';
            document.getElementById('question_sentence_input').focus();
        },
        questionDataValidation: function questionDataValidation(event, num) {
            var val = event.target.value;
            if (this.sentence.length > 200) {
                this.sentence = val.substr(0, 200);
            }
            if (num === 0) {
                window.TA.log(this.buriedPoint.strategyParam.modifyQuestion);
            } else {
                if (this.filterKey.indexOf(event.keyCode) > -1) {
                    return;
                }
                var self = this;
                var lastStr = this.sentence[this.sentence.length - 1];
                if (this.chunkSeparator.indexOf(lastStr) > -1) {
                    // chunk
                    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/chunk/search?query=' + this.sentence).then(function (res) {
                        if (res) {
                            if (res.data.errorcode === 0) {
                                self.searchVis = self.searchList.length !== 0;
                                var list = [];
                                res.data.result.forEach(function (item) {
                                    list.push(self.sentence + item);
                                });
                                self.searchList = list;
                                self.defaultSentence = self.sentence;
                            } else {
                                self.searchVis = false;
                            }
                        }
                    }).catch(function (error) {
                        self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/chunk/searchdataextract?query=' + this.sentence).then(function (res) {
                        if (res) {
                            if (res.data.errorcode === 0) {
                                self.searchList = res.data.result;
                                self.searchVis = self.searchList.length !== 0;
                                self.defaultSentence = self.sentence;
                            } else {
                                self.searchVis = false;
                                self.searchList = [];
                            }
                        }
                    }).catch(function (error) {
                        self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                    });
                }
            }
        },

        _getNowDate: function _getNowDate() {
            var now = new Date();
            now.setDate(now.getDate() - 1); // 获取昨天时间
            var month = now.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
            var nowDate = now.getFullYear() + '-' + month + '-' + date;
            return nowDate;
        },
        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_11__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        save: function save() {
            if (this.userId == null) {
                // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
                window.LoginInstance.show();
                return;
            }
            window.TA.log(this.buriedPoint.saveRelease);
            if (this.isPublish === 2) {
                // 已经保存
                var self = this;
                this.$confirm({
                    'smallTitle': '该策略已保存',
                    'title': '您确定要发布该策略吗？',
                    'okBtnTitle': '确定',
                    'cancelBtnCallback': function cancelBtnCallback(done) {
                        // window.TA.log(self.buriedPoint.saveAfterRelease.cancel)
                        done();
                    },
                    'okBtnCallback': function okBtnCallback(done) {
                        var requestData = { id: self.id, is_publish: 1
                            // window.TA.log(self.buriedPoint.saveAfterRelease.ok)
                        };__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/tradebacktest/save', requestData).then(function (res) {
                            var response = res.data;
                            done();
                            if (response.errorcode !== 0) {
                                if (response.errorcode === -99) {
                                    self.$tip({ message: '发布失败，您的同花顺账户暂未绑定手机号码', duration: 2000, type: 'error' });
                                    return;
                                }
                                self.$tip({ message: response.errormsg ? response.errormsg : '操作失败', duration: 2000, type: 'error' });
                            } else {
                                self.$store.dispatch('myStrategy/requestTradeBacktest');
                                self.$tip({ message: '提交成功！正在审核中', duration: 2000, type: 'success' });
                                self.isPublish = 1;
                            }
                        }).catch(function (error) {
                            done();
                            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                        });
                    }
                });
            } else if (this.isPublish !== 1) {
                // 未发布
                this.isreleaseshow = true;
            } else {}
        },
        moresignal: function moresignal() {
            window.TA.log(this.buriedPoint.timingSignal.openPanel);
            this.ismarketshow = false;
            this.isshadowshow = !this.isshadowshow;
        },
        closemoresignal: function closemoresignal() {
            this.isshadowshow = false;
        },
        cancelSignalItem: function cancelSignalItem(item) {
            window.TA.log(this.buriedPoint.timingSignal.deleteSignal);
            this.marketsignals.splice(this.marketsignals.indexOf(item), 1);
        },
        selectSignalItem: function selectSignalItem(item) {
            window.TA.log(this.buriedPoint.timingSignal.selectSignal);
            if (this.marketsignals.indexOf(item) < 0) {
                this.ismarketshow = false;
                this.marketsignals.push(item);
            }
        },
        checkall: function checkall() {
            window.TA.log(this.buriedPoint.timingSignal.selectAll);
            this.checked = !this.checked;
            this.isshadowshow = true;
            if (this.checked === true) {
                for (var key in this.signalType) {
                    for (var index in this.signalType[key][1]) {
                        if (this.marketsignals.indexOf(this.signalType[key][1][index]) < 0) {
                            this.marketsignals.push(this.signalType[key][1][index]);
                        }
                    }
                }
            } else {
                this.marketsignals = [];
            }
        },
        sortNumber: function sortNumber(a, b) {
            return a - b;
        },

        startBacktest: function startBacktest() {
            var _this = this;

            if (this.searchVis) {
                this.searchVis = false;
                return;
            }
            var self = this;
            this.$nextTick(function () {
                if (_this.transactiontype === '1') {
                    if (!_this.$refs.question_sentence_input.validate() || !_this.$refs.question_cycle_input.validate() || !_this.$refs.capital_input.validate() || !_this.$refs.upper_income.validate() || !_this.$refs.fall_income.validate() || !_this.$refs.lower_income.validate()) {
                        return;
                    }

                    window.TA.log(_this.buriedPoint.strategyParam.startUpBacktest);

                    self.isshowtestloading = true;
                    var numberArry = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(self.number.split(',').sort(_this.sortNumber)));
                    self.number = numberArry.join(',');
                    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/tradebacktest/yieldbacktest', {
                        query: self.sentence,
                        period: self.number,
                        start_date: self.tradeStartDate,
                        end_date: self.tradeEndDate,
                        stock_hold: self.stockHold,
                        upper_income: self.upperIncome,
                        lower_income: self.lowerIncome,
                        fall_income: self.fallIncome,
                        day_buy_stock_num: self.dayBuyStockNum,
                        engine: self.engine,
                        capital: self.capital
                    }).then(function (res) {
                        if (res.data.errorcode !== 0) {
                            throw new Error(res.data.errormsg);
                        }
                        self.isfinishshow = true;
                        self.isshowtestloading = false;
                        self.isPublish = res.data.result.isSaved;

                        self.id = res.data.result.id;
                        if (self.id === res.data.result.id) {
                            self.refresh = !self.refresh;
                        }
                        self.conditionData = res.data.result.conditionData;
                        self.reportData = res.data.result.reportData;
                        self.scoreData = res.data.result.scoreData;
                        self.backtestData = res.data.result.backtestData;
                        self.profitGroupData = res.data.result.profitGroupData;
                        self.profitData = res.data.result.profitData;
                        self.Hq300Data = res.data.result.Hq300Data;
                        self.pickData = res.data.result.pickData;

                        self.backtestCompleted = true;
                        self.currentBacktestType = '1';

                        location.hash = '#/strategybacktest?query=' + encodeURIComponent(self.sentence) + '&daysForSaleStrategy=' + _this.number + '&startDate=' + _this.tradeStartDate + '&endDate=' + _this.tradeEndDate + '&stockHoldCount=' + _this.stockHold + '&dayBuyStockNum=' + _this.dayBuyStockNum + '&upperIncome=' + _this.upperIncome + '&lowerIncome=' + _this.lowerIncome + '&fallIncome=' + _this.fallIncome + '&engine=' + self.engine + '&capital=' + self.capital;
                    }).then(function () {}).catch(function (error) {
                        self.isshowtestloading = false;
                        self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                    });
                } else {
                    if (!_this.$refs.question_sentence_input.validate() || !_this.$refs.question_cycle_input_1.validate() || !_this.$refs.capital_input_1.validate() || !_this.$refs.upper_income_1.validate() || !_this.$refs.fall_income_1.validate() || !_this.$refs.lower_income_1.validate() || !_this.$refs.bear_market_upper_income.validate() || !_this.$refs.bear_market_fall_income.validate() || !_this.$refs.bear_market_lower_income.validate()) {
                        return;
                    }
                    window.TA.log(_this.buriedPoint.strategyParam.startUpBacktest);
                    if (self.marketsignals.length === 0) {
                        self.ismarketshow = true;
                    } else {
                        self.isshowtestloading = true;
                        self.isshadowshow = false;
                        var _numberArry = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(self.number.split(',').sort(_this.sortNumber)));
                        self.number = _numberArry.join(',');
                        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/tradebacktest/mebacktest', {
                            query: self.sentence,
                            period: self.number,
                            start_date: self.tradeStartDate,
                            end_date: self.tradeEndDate,
                            stock_hold: self.stockHold,
                            day_buy_stock_num: self.dayBuyStockNum,
                            upper_income: self.upperIncome,
                            lower_income: self.lowerIncome,
                            fall_income: self.fallIncome,
                            bear_market_upper_income: self.bearMarketUpperIncome, // 弱势市场
                            bear_market_lower_income: self.bearMarketLowerIncome, // 弱势市场
                            bear_market_fall_income: self.bearMarketFallIncome, // 弱势市场
                            buy_position: self.buyPosition,
                            menv: self.marketsignals.join(','),
                            capital: self.capital
                        }).then(function (res) {
                            if (res.data.errorcode !== 0) {
                                throw new Error(res.data.errormsg);
                            }
                            self.isfinishshow = true;
                            self.isshowtestloading = false;
                            self.isPublish = res.data.result.isSaved;

                            self.id = res.data.result.id;
                            if (self.id === res.data.result.id) {
                                self.refresh = !self.refresh;
                            }
                            self.conditionData = res.data.result.conditionData;
                            self.reportData = res.data.result.reportData;
                            self.scoreData = res.data.result.scoreData;
                            self.backtestData = res.data.result.backtestData;
                            self.profitGroupData = res.data.result.profitGroupData;
                            self.profitData = res.data.result.profitData;
                            self.Hq300Data = res.data.result.Hq300Data;
                            self.pickData = res.data.result.pickData;

                            self.backtestCompleted = true;
                            self.currentBacktestType = '2';

                            location.hash = '#/strategybacktest?query=' + encodeURIComponent(self.sentence) + '&daysForSaleStrategy=' + _this.number + '&startDate=' + _this.tradeStartDate + '&endDate=' + _this.tradeEndDate + '&stockHoldCount=' + _this.stockHold + '&dayBuyStockNum=' + _this.dayBuyStockNum + '&upperIncome=' + _this.upperIncome + '&lowerIncome=' + _this.lowerIncome + '&fallIncome=' + _this.fallIncome + '&bearMarketUpperIncome=' + _this.bearMarketUpperIncome + '&bearMarketLowerIncome=' + _this.bearMarketLowerIncome + '&bearMarketFallIncome=' + _this.bearMarketFallIncome + '&buyPosition=' + _this.buyPosition + '&menv=' + _this.marketsignals.join(',') + '&capital=' + self.capital;
                        }).then(function () {}).catch(function (error) {
                            self.isshowtestloading = false;
                            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                        });
                    }
                }
            });
        },
        startBacktestByRoute: function startBacktestByRoute(routeParam) {
            var self = this;
            var hasChanged = false;
            for (var key in this.paramKeys) {
                if (routeParam.hasOwnProperty(key) && routeParam[key] !== '' && self[self.paramKeys[key]] !== routeParam[key]) {
                    self[self.paramKeys[key]] = routeParam[key];
                    hasChanged = true;
                }
            }

            if ('stockHoldCount' in routeParam && !('dayBuyStockNum' in routeParam)) {
                self.dayBuyStockNum = routeParam.stockHoldCount;
            }

            var bearMarketUpperIncome = routeParam.hasOwnProperty('bearMarketUpperIncome') ? routeParam.bearMarketUpperIncome : self.upperIncome;
            var bearMarketLowerIncome = routeParam.hasOwnProperty('bearMarketLowerIncome') ? routeParam.bearMarketLowerIncome : self.lowerIncome;
            var bearMarketFallIncome = routeParam.hasOwnProperty('bearMarketFallIncome') ? routeParam.bearMarketFallIncome : self.fallIncome;

            if (routeParam.hasOwnProperty('menv') && routeParam['menv'] !== '') {
                if (self.currentBacktestType === '1') {
                    hasChanged = true;
                }
                self.transactiontype = '2';
                self.marketsignals = routeParam['menv'].split(',');

                // 择时 熊市参数
                if (bearMarketUpperIncome !== self.bearMarketUpperIncome || bearMarketLowerIncome !== self.bearMarketLowerIncome || bearMarketFallIncome !== self.bearMarketFallIncome) {
                    hasChanged = true;
                }
                if (routeParam.hasOwnProperty('buyPosition') && self['buyPosition'] !== routeParam['buyPosition']) {
                    self['buyPosition'] = routeParam['buyPosition'];
                    hasChanged = true;
                }
            } else {
                if (self.currentBacktestType === '2') {
                    hasChanged = true;
                }
                self.transactiontype = '1';
            }

            if (['stable', 'online'].indexOf(routeParam.engine)) {
                self.engine = routeParam.engine;
            }

            self.bearMarketUpperIncome = bearMarketUpperIncome;
            self.bearMarketLowerIncome = bearMarketLowerIncome;
            self.bearMarketFallIncome = bearMarketFallIncome;
            if (!self.backtestCompleted || hasChanged) {
                this.startBacktest();
            }
        },
        initParams: function initParams() {
            this.capital = '100000';
            if (this.defaultQuery) {
                this.sentence = this.defaultQuery.query;
                this.tradeStartDate = this.defaultQuery.startDate;
                this.tradeEndDate = this.defaultQuery.endDate;
                this.number = this.defaultQuery.daysForSaleStrategy;
                this.stockHold = this.defaultQuery.stockHoldCount;
                this.dayBuyStockNum = !('dayBuyStockNum' in this.defaultQuery) ? this.stockHold : this.defaultQuery.dayBuyStockNum;
                this.upperIncome = this.defaultQuery.upperIncome;
                this.lowerIncome = this.defaultQuery.lowerIncome;
                this.fallIncome = this.defaultQuery.fallIncome;

                this.bearMarketUpperIncome = this.defaultQuery.upperIncome;
                this.bearMarketLowerIncome = this.defaultQuery.lowerIncome;
                this.bearMarketFallIncome = this.defaultQuery.fallIncome;
            } else {
                this.sentence = '';
                this.tradeStartDate = '';
                this.tradeEndDate = '';
                this.number = '';
                this.stockHold = '1';
                this.dayBuyStockNum = '1';
                this.upperIncome = '';
                this.lowerIncome = '';
                this.fallIncome = '';
                this.bearMarketUpperIncome = '';
                this.bearMarketLowerIncome = '';
                this.bearMarketFallIncome = '';
            }
            // },
            // __scrollBar__ () {
            //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
            //         window.TA.log(this.buriedPoint.scrollBar)
            //     }
        }
    },
    watch: {
        marketsignals: function marketsignals() {
            if (this.marketsignals.length !== 20) {
                this.checked = false;
            } else {
                this.checked = true;
            }
        },
        '$route': function $route(newRoute, oldRoute) {
            if (this.defaultqueryLoading) {
                return;
            }

            if (newRoute.name === 'strategybacktest') {
                var params = newRoute.query;
                if (newRoute.name === oldRoute.name) {
                    this.startBacktestByRoute(params);
                } else {
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params) !== '{}') {
                        this.startBacktestByRoute(params);
                    }
                }
            }
        }
    },
    // beforeDestroy () {
    //     window.removeEventListener('scroll', this.__scrollBar__)
    // },
    activated: function activated() {
        var self = this;
        // window.addEventListener('scroll', self.__scrollBar__)
        window.TA.log({ id: self.buriedPoint.pageAccess, _sid: '__ths_001' });
        window.TA.log({ id: self.totalPoint, _sid: '__ths_002' });
    },
    deactivated: function deactivated() {
        // 重置初始化状态
        this.initParams();
        this.id = '';
        this.isfinishshow = false;
        this.isshadowshow = false;
        this.isreleaseshow = false;
        this.backtestCompleted = false;
        this.isshowtestloading = false;
        this.checked = false;
        this.isPublish = 0;
        this.transactiontype = '1';
        this.currentBacktestType = '1';
        this.buyPosition = 0;
        this.conditionData = [];
        this.reportData = {};
        this.scoreData = {};
        this.backtestData = [];
        this.Hq300Data = [];
        this.pickData = null;
        this.currenttab = 'MACD';
        this.ismarketshow = false;
        this.marketsignals = [];

        this.$refs.question_sentence_input.className = 'question_sentence_input';
        this.$refs.question_cycle_input.className = 'question_cycle_input';
        this.$refs.upper_income.className = '';
        this.$refs.fall_income.className = '';
        this.$refs.lower_income.className = '';
        this.$refs.question_cycle_input_1.className = 'question_cycle_input';
        this.$refs.upper_income_1.className = '';
        this.$refs.fall_income_1.className = '';
        this.$refs.lower_income_1.className = '';
        this.$refs.bear_market_upper_income.className = '';
        this.$refs.bear_market_fall_income.className = '';
        this.$refs.bear_market_lower_income.className = '';
        this.$refs.sentenceNotice.style.display = 'none';
        this.$refs.profitlossNotice.style.display = 'none';
        this.$refs.numberNotice.style.display = 'none';
    },
    mounted: function mounted() {
        var _this2 = this;

        var self = this;
        this.defaultqueryLoading = true;
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/backtestonce/defaultquery?type=1').then(function (res) {
            self.defaultqueryLoading = false;
            if (res.data.result) {
                self.defaultQuery = res.data.result;
                self.initParams();
            }
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.$route.query) !== '{}') {
                self.startBacktestByRoute(self.$route.query);
            }
        }).catch(function (error) {
            self.defaultqueryLoading = false;
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/tradebacktest/menvdata').then(function (res) {
            _this2.signalType = res.data.result.type;
            _this2.signalData = res.data.result.data;
        }).catch(function (error) {
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });
    }
});

/***/ }),

/***/ "HDOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('div',{staticClass:"fixed-header"},[_c('div',{staticClass:"header-left-bar"},[_vm._v("欢迎您！\n            "),(_vm.userId != null)?_c('span',[_vm._v(_vm._s(_vm.userName)),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.logout}},[_vm._v(" [退出]")])]):_c('span',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.login}},[_vm._v("登录")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"//upass.10jqka.com.cn/register"}},[_vm._v("注册")])])]),_vm._v(" "),_c('div',{staticClass:"header-right-bar"},[_c('a',{attrs:{"href":"//x.10jqka.com.cn/stockpick?qs=return_stock"}},[_vm._v("\n                i问财首页\n            ")]),_vm._v(" "),_c('span',{staticClass:"top-bar-img bar-separator"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"top-bar-img bar-separator"}),_vm._v(" "),_c('a',{style:(_vm.$route.name === 'strategysquare' ? _vm.topActiveStyle : {}),attrs:{"href":"/backtest/app.html#/strategysquare"}},[_c('span',{staticClass:"top-bar-img bar-invest"}),_vm._v("\n                投资策略\n            ")]),_vm._v(" "),_c('span',{staticClass:"top-bar-img bar-separator"}),_vm._v(" "),_c('a',{style:(_vm.$route.name === 'backtest' ? _vm.topActiveStyle : {}),attrs:{"href":"/backtest/app.html#/backtest?qs=backtest_menu2"}},[_c('span',{staticClass:"top-bar-img bar-backtest"}),_vm._v("\n                策略回测\n            ")]),_vm._v(" "),_c('span',{staticClass:"top-bar-img bar-separator"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"top-bar-img bar-separator"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('span',{staticClass:"top-bar-img bar-separator"})])]),_vm._v(" "),_c('header-nav'),_vm._v(" "),_c('div',{staticClass:"routerbody"},[_c('div',{staticClass:"routerbodymain"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),_c('footer-nav')],1)]),_vm._v(" "),_c('qr-code'),_vm._v(" "),_c('feed-back')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"//x.10jqka.com.cn/stockpick?tid=stockpick&ts=1&qs=pc_~soniu~stock~stock~znxg~topbar&zhineng=opened"}},[_c('span',{staticClass:"top-bar-img bar-intelligent"}),_vm._v("\n                智能查找\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"//x.10jqka.com.cn/yuqingmonitor/query-favorites?type=0&qs=favorite_entry"}},[_c('span',{staticClass:"top-bar-img bar-mystrategy"}),_vm._v("\n                我的策略\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://xtz.10jqka.com.cn/pc/home"}},[_c('span',{staticClass:"top-bar-img bar-school"}),_vm._v("\n                股民学校\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HVf/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HY8Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HauX":
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "HauX";

/***/ }),

/***/ "Huel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ISVN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_userInfo__ = __webpack_require__("QmKZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_logo__ = __webpack_require__("VWE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_myStrategy__ = __webpack_require__("CjS2");
// @charset "utf-8"







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var state = {};
var mutations = {};
var actions = {};
var getters = {};
var modules = {
    userInfo: __WEBPACK_IMPORTED_MODULE_2__modules_userInfo__["a" /* default */],
    logo: __WEBPACK_IMPORTED_MODULE_3__modules_logo__["a" /* default */],
    myStrategy: __WEBPACK_IMPORTED_MODULE_4__modules_myStrategy__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
    modules: modules
}));

/***/ }),

/***/ "IpBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
var filterNum = D3Charts.hqHelper.filterNum;
var fsPrice_tooltip = D3Charts.hqHelper.fsPrice_tooltip;
var klinePrice_tooltip = D3Charts.hqHelper.klinePrice_tooltip;
var getStockType = D3Charts.hqHelper.getStockType;
var getLimitByMarket = D3Charts.hqHelper.getLimitByMarket;
var merge = D3Charts.util.merge;
var clone = D3Charts.util.clone;

function getFsOption(d, chart) {
    var code = d.code;
    var xData = d.xData;
    var xTick = d.xTick;
    var color = d.color;
    var kData = d.kData;
    var pre = d.pre;
    var stockType = d.stockType;

    var keepLen = stockType.keepLen;
    var needConvertoShou = stockType.needConvertoShou;
    var option = {
        data: [{
            originData: kData
        }, {
            $dataIndex: 0,
            formatter: function formatter(data) {
                for (var i = 0; i < data.length; i++) {
                    xData[i] = data[i].t.split(' ')[1];
                }
                return xData;
            }
        }],
        grid: [{
            top: 0,
            left: 55,
            right: 90,
            bottom: '30%',
            background: {
                show: true,
                borderEnable: [0, 0, 0, 0],
                style: {
                    stroke: color.axisLine,
                    lineWidth: 1
                }
            },
            bottomPlaceHolder: {
                show: true,
                borderEnable: [0, 0, 0, 0]
            }
        }, {
            top: '70%',
            left: 55,
            right: 90,
            bottom: 0,
            background: {
                show: true,
                borderEnable: [0, 0, 0, 0],
                style: {
                    stroke: color.axisLine,
                    lineWidth: 1
                }
            }
        }],
        series: [{
            type: 'line',
            aliasType: 'hqline',
            name: 'fs_price',
            $dataIndex: 0,
            dataKey: 'nowpPct',
            color: '#53A8E2',
            line: {
                style: {
                    lineWidth: 1
                }
            },
            area: {
                show: true,
                snapToBottom: true,
                style: {
                    opacity: 0.1
                }
            }
        }, {
            type: 'line',
            aliasType: 'hqline',
            name: 'fs_av',
            $dataIndex: 0,
            space: [20, 50],
            dataKey: 'avPct',
            color: '#efaa50',
            line: {
                style: {
                    lineWidth: 1
                }
            }
        }, {
            type: 'hqbar',
            name: 'fs_vol',
            hqbarType: 'vol',
            $axisIndex: [0, 3],
            $dataIndex: 0,
            getXKey: function getXKey(d) {
                return d.t.split(' ')[1];
            }
        }],
        axis: [{
            position: 'bottom',
            type: 'band',
            $dataIndex: 1,
            $gridIndex: [0, 1],
            paddingOuter: 0,
            tick: {
                show: false
            },
            label: {
                padding: 4,
                inRange: true,
                formatter: function formatter(d) {
                    return d.substr(0, 2) + ':' + d.substr(2, 2);
                },
                style: {
                    fill: color.eqAxis
                }
            },
            splitLine: {
                show: false
            },
            line: {
                show: false,
                onZero: true
            },
            tickValues: xTick,
            ifTriggerMove: function ifTriggerMove(event) {
                if (event.axisData.match('___') || event.data.series.length === 0) {
                    return false;
                } else {
                    return true;
                }
            },
            findLastIndex: function findLastIndex(data, startIndex, endIndex) {

                for (var i = startIndex; i <= endIndex; i++) {
                    if (data[i].match('___')) {
                        i--;
                        return i;
                    }
                }

                return endIndex;
            }
        }, {
            position: 'right',
            type: 'linear',
            xOrY: 'y',
            symmetry: true,
            domainScale: 1.2,
            domainEqualZero: [-0.1, 0.1],
            tickValues: function tickValues(domain) {
                return [domain[0], domain[0] / 2, 0, domain[1] / 2, domain[1]];
            },
            splitLine: {
                show: false
            },
            label: {
                padding: 4,
                inside: true,
                inRange: true,
                style: function style(v) {
                    var fill;

                    if (v > 0) {
                        fill = color.abAxis;
                    } else if (v === 0) {
                        fill = color.eqAxis;
                    } else {
                        fill = color.beAxis;
                    }

                    return {
                        fill: fill,
                        textAlign: 'right'
                    };
                },
                formatter: function formatter(v) {
                    return (v * 100).toFixed(2) + '%';
                }
            },
            line: {
                show: false
            },
            tick: {
                show: false
            }
        }, {
            position: 'left',
            relyOtherAxis: true,
            $axisIndex: 1,
            type: 'linear',
            xOrY: 'y',
            label: {
                padding: 4,
                inRange: true,
                style: function style(v) {
                    var fill;

                    if (v > 0) {
                        fill = color.abAxis;
                    } else if (v === 0) {
                        fill = color.eqAxis;
                    } else {
                        fill = color.beAxis;
                    }

                    return {
                        fill: fill
                    };
                },
                formatter: function formatter(v) {
                    return ((v + 1) * pre).toFixed(2);
                }
            },
            line: {
                show: false
            },
            tick: {
                show: false
            }
        }, {
            z: 3,
            position: 'left',
            type: 'linear',
            domainEqualZero: [0, 1],
            xOrY: 'y',
            tickValues: function tickValues(domain) {
                var min = Math.min(domain[0], domain[1]);
                var max = Math.max(domain[0], domain[1]);
                return [min, (max - min) / 2 + min, max];
            },
            splitLine: {
                show: false
            },
            $gridIndex: 1,
            label: {
                padding: 4,
                inRange: true,
                formatter: function formatter(v) {
                    return filterNum(v, needConvertoShou);
                },
                style: {
                    fill: color.eqAxis
                }
            },
            line: {
                show: false
            },
            tick: {
                show: false
            }
        }],
        axisPointer: [{
            $axisIndex: 0,
            line: {
                style: {
                    stroke: color.hoverLine,
                    lineDash: [2, 3],
                    lineWidth: 1
                }
            },
            label: {
                gap: 0,
                style: {
                    fill: 'white',
                    textBorderRadius: 0,
                    textBackgroundColor: '#555'
                }
            }
        }, {
            $axisIndex: [2],
            $axisPointerIndex: 0,
            $seriesIndex: 0,
            label: {
                gap: 0,
                // inside: true,
                style: function style(v) {
                    var fill;

                    if (v > 0) {
                        fill = color.abAxis;
                    } else if (v === 0) {
                        fill = color.eqAxis;
                    } else {
                        fill = color.beAxis;
                    }

                    return {
                        textPadding: 4,
                        fill: 'white',
                        textBackgroundColor: fill
                        // textAlign: 'right'
                    };
                }
            },
            // 指示线
            line: {
                style: {
                    stroke: color.hoverLine,
                    lineDash: [2, 3],
                    lineWidth: 1
                }
            }
        }],
        tooltip: [{
            trigger: 'axis',
            $axisIndex: 0,
            $seriesIndex: 0,
            position: function position(d) {
                var gridModel = chart.getModel('grid', 0);
                var globalModel = d.model.globalModel;
                var seriesModel = globalModel.getComponentByIndex('series', 0);
                var _data = seriesModel.getRealData(d.dataIndex);
                var yValue = _data[1];
                var yAxisModel = seriesModel.getAxisModel('y');
                var y = yAxisModel.scale(yValue);

                return {
                    x: gridModel.position.right + 4,
                    y: y - 8
                };
            },
            alwaysShowContent: true,
            formatter: function formatter(d) {
                var data = kData[d.series[0].dataIndex];
                var hqMarket = 'HS_stock';
                return fsPrice_tooltip(data, {
                    pre: pre,
                    keepLen: keepLen,
                    needConvertoShou: needConvertoShou,
                    hqMarket: hqMarket
                }, function (d) {
                    var tpl = d.tpl;
                    var result = d.result;
                    return tpl.replace(/<%([^%>]+)?%>/g, function (s0, s1) {
                        if (s1 === 't') {
                            return result[s1].substr(9, 2) + ':' + result[s1].substr(11, 2) + '<br/>';
                        } else {
                            return '<span style="color:' + color[result.status + 'Axis'] + ';">' + result[s1] + '</span><br/>';
                        }
                    });
                });
            },

            // 浮窗的css样式
            style: {
                position: 'absolute',
                zIndex: 99999,
                backgroundColor: undefined,
                borderRadius: '0px',
                padding: '2px',
                color: '#555',
                fontSize: '12px',
                display: 'none'
            }
        }],
        animation: false
    };

    var limit = getLimitByMarket(stockType);
    if (!limit.fs.av) {
        option.series.splice(1, 1);
    }
    if (!limit.fs.vol) {
        option.grid[0].bottom = 0;
        option.grid.pop();
        option.axis[0].$gridIndex = 0;
        option.axis.pop();
        option.tooltip.pop();
        option.series.pop();
    }
    return option;
}

function getKlineOption(d, chart) {
    var code = d.code;
    var color = d.color;
    var kData = d.kData;
    var klineCfg = d.kline;
    var stockType = d.stockType;

    var keepLen = stockType.keepLen;
    var needConvertoShou = stockType.needConvertoShou;
    var minValueSpan = klineCfg.minValueSpan;
    var startValue = klineCfg.startValue;
    var option = {
        axis: [{
            position: 'bottom',
            type: 'band',
            $gridIndex: [0, 1],
            xOrY: 'x',
            $dataIndex: 0,
            dataKey: 't',
            paddingInner: 0.3,
            paddingOuter: 0.3,
            barGap: 0,
            $dataZoomIndex: 0,
            tickValues: function tickValues(domain) {
                var n = domain.length - 1;
                if (n < 6) {
                    return [domain[0]];
                } else if (n < minValueSpan) {
                    return [domain[0], domain[n]];
                } else {
                    var split = n / 6;
                    return [domain[Math.round(n / 6)], domain[Math.round(n * 3 / 6)], domain[Math.round(n * 5 / 6)]];
                }
            },
            splitLine: {
                show: true,
                style: {
                    stroke: color.axisLine,
                    lineDash: [3, 4],
                    lineWidth: 1
                }
            },
            label: {
                padding: 4,
                inRange: true,
                style: {
                    fill: color.eqAxis
                },
                formatter: function formatter(d) {
                    return d.substr(0, 4) + '-' + d.substr(4, 2) + '-' + d.substr(6, 2);
                }
            },
            line: {
                show: false
            },
            tick: {
                show: false
            }
        }, {
            position: 'left',
            type: 'linear',
            space: 10,
            domainEqualZero: [-0.1, 0.1],
            $gridIndex: 0,
            xOrY: 'y',
            tickValues: function tickValues(domain) {
                var min = domain[0];
                var max = domain[1];
                var detar = max - min;
                return [domain[0], detar / 4 + domain[0], detar * 2 / 4 + domain[0], detar * 3 / 4 + domain[0], domain[1]];
            },
            splitLine: {
                show: false
            },
            label: {
                padding: 4,
                style: {
                    fill: color.eqAxis
                },
                formatter: function formatter(v) {
                    return v.toFixed(keepLen);
                }
            },
            line: {
                show: false
            },
            tick: {
                show: false
            }
        }, {
            position: 'left',
            type: 'linear',
            $gridIndex: 1,
            space: [0, 20],
            domainEqualZero: [0, 1],
            xOrY: 'y',
            tickValues: function tickValues(domain) {
                var min = domain[0];
                var max = domain[1];
                var detar = max - min;
                return [domain[0], detar * 2 / 4 + domain[0], domain[1]];
            },
            label: {
                padding: 4,
                inRange: true,
                style: {
                    fill: color.eqAxis
                },
                formatter: function formatter(v) {
                    return filterNum(v, needConvertoShou);
                }
            },
            line: {
                show: false
            },
            tick: {
                show: false
            }
        }],
        grid: [{
            left: 55,
            top: 0,
            right: 90,
            bottom: '30%',
            background: {
                show: true,
                borderEnable: [0, 0, 0, 0],
                style: {
                    stroke: color.axisLine
                }
            },
            topPlaceHolder: {
                show: true,
                height: 25,
                borderEnable: [0, 0, 0, 0]
            },
            bottomPlaceHolder: {
                show: true,
                borderEnable: [0, 0, 0, 0]
            }
        }, {
            left: 55,
            top: '70%',
            right: 90,
            bottom: 0,
            background: {
                show: true,
                borderEnable: [0, 0, 0, 0],
                style: {
                    stroke: color.axisLine
                }
            }
        }],
        axisPointer: [{
            $axisIndex: 0,
            line: {
                style: {
                    stroke: color.hoverLine,
                    lineDash: [2, 3],
                    lineWidth: 1
                }
            },
            label: {
                gap: 0,
                style: {
                    fill: 'white',
                    textBorderRadius: 0,
                    textBackgroundColor: '#555'
                }
            }
        }, {
            $axisIndex: [1],
            $axisPointerIndex: 0,
            $seriesIndex: 0,
            valueIndex: 3,
            line: {
                style: {
                    stroke: color.hoverLine,
                    lineDash: [2, 3],
                    lineWidth: 1
                }
            },
            label: {
                gap: 0,
                style: {
                    fill: 'white',
                    textBorderRadius: 0,
                    textBackgroundColor: '#555'
                }
            }
        }],
        tooltip: [{
            trigger: 'axis',
            $axisIndex: 0,
            position: [10, 0],
            alwaysShowContent: true,
            formatter: function formatter(d) {
                return klinePrice_tooltip(kData[d.series[0].dataIndex], {
                    needConvertoShou: needConvertoShou,
                    keepLen: keepLen
                }, function (d) {
                    var tpl = d.tpl;
                    var maTpl = d.maTpl;
                    var result = d.result;
                    var data = d.data;
                    return maTpl.replace(/<%([^%>]+)?%>/g, function (s0, s1) {
                        if (s1 === 'status' || s1 === 'openPStatus' || s1 === 'maxPStatus' || s1 === 'minPStatus') {
                            return color[result[s1] + 'Axis'];
                        } else if (/^(ma[{0-9}]+Status)$/.test(s1)) {
                            return color[s1.slice(0, -6)];
                        } else if (/^(ma[{0-9}]+)$/.test(s1)) {
                            return parseFloat(data[s1]).toFixed(keepLen);
                        } else {
                            return result[s1];
                        }
                    });
                });
            },
            // 浮窗的css样式
            style: {
                position: 'absolute',
                zIndex: 99999,
                backgroundColor: undefined,
                borderRadius: '0px',
                padding: '2px',
                color: '#555',
                fontSize: '12px',
                display: 'none'
            }
        }, {
            trigger: 'axis',
            $axisIndex: 0,
            position: function position(d) {
                var gridModel = chart.getModel('grid', 0);
                var globalModel = d.model.globalModel;
                var seriesModel = globalModel.getComponentByIndex('series', 0);
                var _data = seriesModel.getRealData(d.dataIndex);
                var value = _data[1];
                var yAxisModel = seriesModel.getAxisModel('y');
                var yValue = value[3];
                var y = yAxisModel.scale(yValue);

                return {
                    x: gridModel.position.right + 4,
                    y: y - 8
                };
            },
            alwaysShowContent: true,
            formatter: function formatter(d) {
                return klinePrice_tooltip(kData[d.series[0].dataIndex], {
                    needConvertoShou: needConvertoShou,
                    keepLen: keepLen
                }, function (d) {
                    var tpl = d.tpl.slice(0, -5);
                    var maTpl = d.maTpl;
                    var result = d.result;
                    var data = d.data;
                    tpl += '<span>量：' + filterNum(d.data.n, needConvertoShou) + '</span>';

                    return tpl.replace(/<%([^%>]+)?%>/g, function (s0, s1) {
                        if (s1 === 'status' || s1 === 'openPStatus' || s1 === 'maxPStatus' || s1 === 'minPStatus') {
                            return color[result[s1] + 'Axis'];
                        } else if (/^(ma[{0-9}]+Status)$/.test(s1)) {
                            return color[s1.slice(0, -6)];
                        } else if (/^(ma[{0-9}]+)$/.test(s1)) {
                            return parseFloat(data[s1]).toFixed(keepLen);
                        } else {
                            return result[s1] + ' <br/> ';
                        }
                    });
                });
            },
            // 浮窗的css样式
            style: {
                position: 'absolute',
                zIndex: 99999,
                backgroundColor: undefined,
                borderRadius: '0px',
                padding: '2px',
                color: '#555',
                fontSize: '12px',
                display: 'none'
            }
        }],
        dataZoom: [{
            $gridIndex: [0, 1],
            // 初始 绘制的k线范围
            // startValue: '20180115',
            // endValue: '20180531',
            minValueSpan: minValueSpan,
            // maxValueSpan: 100
            startValue: startValue,
            pressStop: true
        }],
        series: [{
            type: 'hqbar',
            name: 'kline_price',
            hqbarType: 'kline',
            $axisIndex: [0, 1],
            $dataIndex: 0
        }, {
            type: 'hqbar',
            name: 'kline_vol',
            hqbarType: 'vol',
            $axisIndex: [0, 2],
            $dataIndex: 0
        }, {
            type: 'line',
            $dataIndex: 0,
            dataKey: 'ma5',
            name: 'ma5',
            line: {
                show: true,
                style: {
                    normal: {
                        stroke: color.ma5,
                        lineWidth: 1
                    }
                }
            }
        }, {
            type: 'line',
            $dataIndex: 0,
            dataKey: 'ma10',
            name: 'ma10',
            line: {
                show: true,
                style: {
                    normal: {
                        stroke: color.ma10,
                        lineWidth: 1
                    }
                }
            }
        }, {
            type: 'line',
            $dataIndex: 0,
            dataKey: 'ma30',
            name: 'ma30',
            line: {
                show: true,
                style: {
                    normal: {
                        stroke: color.ma30,
                        lineWidth: 1
                    }
                }
            }
        }],
        markPoint: [{
            $axisIndex: [0, 1],
            $seriesIndex: 0,
            symbol: {
                type: 'none'
            },
            label: {
                normal: {
                    show: true,
                    style: {
                        fill: 'black',
                        textDistance: 0,
                        position: function position(d, item, _position) {
                            var gridModel = chart.getModel('grid', 0);

                            if (_position[0] > gridModel.position.left + gridModel.position.width / 2) {
                                return 'left';
                            } else {
                                return 'right';
                            }
                        }
                    },
                    formatter: function formatter(item, position) {
                        var gridModel = chart.getModel('grid', 0);

                        if (position[0] > gridModel.position.left + gridModel.position.width / 2) {
                            return item.data[1].toFixed(keepLen) + ' ←';
                        } else {
                            return '→ ' + item.data[1].toFixed(keepLen);
                        }
                    }
                }
            },
            data: [{
                type: 'max',
                valueIndex: 1
            }, {
                type: 'min',
                valueIndex: 2
            }]
        }],
        animation: false,
        data: [{
            originData: kData
        }]
    };

    var limit = getLimitByMarket(stockType);
    if (!limit.kline.vol) {
        option.grid[0].bottom = 0;
        option.axis[0].$gridIndex = 0;
        option.axis.pop();
        option.axisPointer[0].$axisIndex = [0, 1];
        option.tooltip.pop();
        option.dataZoom[0].$gridIndex = 0;
        option.series.splice(1, 1);
    }
    return option;
}

function PcHq(configs) {
    var defaultConfigs = {
        // 是否需要实时行情头部
        enableRealhead: true,
        color: {
            axisLine: '#ccc',
            abAxis: '#de422e',
            beAxis: '#3e9663',
            eqAxis: '#444',
            ma5: '#1F6195',
            ma10: '#E0AC58',
            ma30: '#9C73AF',
            // 悬停十字线
            hoverLine: '#A0A0A0',
            hideColor: 'rgba(255,255,255,0)'
        },
        intervalTime: 60000,
        isKeepingGet: true,
        code: 'hs_300033'
    };
    this.configs = merge(clone(configs), defaultConfigs);
}

// 渲染
PcHq.prototype.renderRealhead = function (realheadData, hoverData) {
    var data;

    if (hoverData) {
        data = merge(clone(hoverData), this.realheadData);
    } else {
        data = realheadData;
    }
    // if (!data) {return;}

    // curP : "38.25"
    // curPStatus : "ab"
    // dynamicSYL : "68.234"
    // isStop : 0
    // keepLen : 2
    // maxP : "38.85"
    // maxPStatus : "ab"
    // minP : "37.92"
    // minPStatus : "be"
    // n : "2.8万"
    // name : "同花顺"
    // np : "1.1亿"
    // openP : "38.00"
    // openPStatus : "be"
    // rate : "0.18"
    // rateP : "0.07"
    // shortcode : "300033"
    // sjl : "7.49"
    // staticSYL : "28.338"
    // stockM : "101亿"
    // totalM : "206亿"
    // turnRate : "1.08"
    // yesterdayP : "38.18"
    // zf : "2.44"

    var $dom = $('#' + this.configs.realheadId);
    var color = this.configs.color;
    var htmlStr = this.configs.realheadTpl;
    var infoItemCss = 'display: inline-block; width: 80px; line-height: 26px;';
    var boxColor = {
        'ab': color.abAxis,
        'eq': color.eqAxis,
        'be': color.beAxis
    };

    data.curP = data.curP === '' ? '00.00' : data.curP;
    data.wgtColor = boxColor[data.curPStatus];
    data.wgtStopStr = data.isStop ? ' 停牌' : '';
    data.arrowEnable = /^(ab|be)/.test(data.curPStatus) ? 'inline' : 'none';
    data.arrowDirect = /^(ab)/.test(data.curPStatus) ? '' : 'transform: scale(-1); margin-top:9px;';
    var calcWidth = ($dom.width() - 300) / 4 > 70 ? ($dom.width() - 300) / 4 : 70;
    data.infoItemCss = infoItemCss + 'width: ' + calcWidth + 'px;';

    htmlStr = htmlStr.replace(/<%([^%>]+)?%>/g, function (s0, s1) {
        return data[s1];
    });

    var wrapCss = 'position: absolute; top: 0;left: 0;width: 100%;font-family: DIN-Regular; height: 90px; overflow: hidden;';
    var boxSpaceCss = 'padding: 10px; verflow: hidden;';

    var realheadbox = $dom.find('.hxc3-wgt-toggle');
    if (realheadbox.length) {
        realheadbox.html('');
    } else {
        realheadbox = $('<div class="hxc3-wgt-toggle" style="' + wrapCss + '"><div style="' + boxSpaceCss + '"></div></div>').appendTo($dom);
    }
    realheadbox.html('<div style="' + boxSpaceCss + '">' + htmlStr + '</div>');
};

// 绘制实时行情头部
PcHq.prototype.drawRealhead = function () {
    var configs = this.configs;
    var code = configs.code;

    var that = this;

    var realdata = {
        type: 'othersHq',
        dType: 'realhead',
        code: code,
        isKeepingGet: configs.isKeepingGet,
        intervalTime: configs.intervalTime

        // 港美股盘前，盘后特殊状态
        // var stockstatus = new Stockstatus({
        //     stockTypeObj: this.stockType
        // });

        // 获得数据
    };var realheadProvider = D3Charts.getDataPool().register(realdata);
    D3Charts.getDataPool().offAction(realheadProvider, 'PROVIDER_UPDATE.mhxreal');
    D3Charts.getDataPool().onAction(realheadProvider, 'PROVIDER_UPDATE.mhxreal', function (d) {
        if (d.data) {
            var data = d.data.afterArrage;
            // stockstatus.initStatus(d.data.remoteData.items);

            that.realheadData = data;
            that.renderRealhead(data);
        }
    });
};

// 绘制分时tab
PcHq.prototype._drawFs = function () {
    var configs = this.configs;
    var chart = this.chart;
    var that = this;

    var code = configs.code;
    var color = configs.color;

    that.hqRemoveLoading();

    // fs数据配置
    var fsdata = {
        type: 'fsToday',
        code: code,
        isKeepingGet: configs.isKeepingGet,
        // 间隔多久更新一次(推荐大于60秒,因为现在服务端缓存是1分钟)
        intervalTime: 60000
    };

    // 获得数据
    var fsProvider = D3Charts.getDataPool().register(fsdata);
    D3Charts.getDataPool().offAction(fsProvider, 'PROVIDER_UPDATE.mhxfs');
    D3Charts.getDataPool().onAction(fsProvider, 'PROVIDER_UPDATE.mhxfs', function (d) {
        if (d.data) {

            var data = d.data[code];
            var pre = parseFloat(data.preClosePrice);
            var kData = data.dataArray;
            var xDataObj = D3Charts.hqHelper.getXData(data.stockType, data.totalTimeNum, data.tradeTime);
            var fsOption = getFsOption({
                code: code,
                xData: xDataObj.xData,
                xTick: xDataObj.xTick,
                color: color,
                kData: kData,
                pre: pre,
                stockType: data.stockType
            }, chart);
            chart.setOption(fsOption);

            var axisModel = chart.getModel('axis', 0);
            var tooltipModel = chart.getModel('tooltip', 0);
            var tooltipView = chart.getViewOfComponentModel(tooltipModel);
            chart.registerAction(axisModel, 'AXIS_OUT', function (d) {
                var lastData = d.lastData;
                if (lastData) {
                    tooltipView.showTooltip(tooltipModel, lastData);
                }
            });
        }
    });
};

// 绘制kline tab
PcHq.prototype._drawKline = function (klineType) {
    var configs = this.configs;
    var chart = this.chart;
    var that = this;

    klineType = klineType || 'Day';
    var code = configs.code;
    var color = configs.color;

    // kline数据配置
    var klinedata = {
        type: 'klineLast',
        dType: 'qfq' + klineType,
        code: code,
        ma: [5, 10, 30],
        lastDays: 360
    };
    // 获得数据
    var klineProvider = D3Charts.getDataPool().register(klinedata);

    D3Charts.getDataPool().offAction(klineProvider, 'PROVIDER_UPDATE.mhxkline');
    D3Charts.getDataPool().onAction(klineProvider, 'PROVIDER_UPDATE.mhxkline', function (d) {

        if (d.fetchStatus.msg !== 'success') return;
        that.hqRemoveLoading();

        var kData = d.data.dataArray;

        var klineOption = getKlineOption({
            code: code,
            color: color,
            kData: kData,
            stockType: d.data.stockType,
            kline: configs.kline
        }, chart);
        chart.setOption(klineOption);

        var axisModel = chart.getModel('axis', 0);
        var tooltipModel = chart.getModel('tooltip', 0);
        var tooltipModel2 = chart.getModel('tooltip', 1);
        var tooltipView = chart.getViewOfComponentModel(tooltipModel);
        var tooltipView2 = chart.getViewOfComponentModel(tooltipModel2);
        chart.registerAction(axisModel, 'AXIS_OUT', function (d) {
            var lastData = d.lastData;
            if (lastData) {
                tooltipView.showTooltip(tooltipModel, lastData);
                tooltipView2.showTooltip(tooltipModel2, lastData);
            }
        });
    });
};

// 切换到分时tab
PcHq.prototype.toggleFs = function () {
    this.hqAddLoading();

    // 如果是在大量请求时，使用下面的切换
    // 原数据不再做缓存
    // D3Charts.getDataPool().removeProvider('.mhxkline');
    D3Charts.getDataPool().offAction('.mhxkline');

    this._drawFs();
};

// 切换到kline tab
PcHq.prototype.toggleKline = function (klineType) {
    this.hqAddLoading();

    // 如果是在大量请求时，使用下面的切换
    // 原数据不再做缓存
    // D3Charts.getDataPool().removeProvider('.mhxfs');
    D3Charts.getDataPool().offAction('.mhxfs');

    this._drawKline(klineType);
};

// 移除loading图标
PcHq.prototype.hqRemoveLoading = function () {}
// console.log('加载完成')


// 可添加loading图标
;PcHq.prototype.hqAddLoading = function () {
    // var dom = this.chart.getDom();
    // console.log('加载中...')
};

PcHq.prototype.init = function () {
    var elementId = this.configs.elementId;
    var chart = D3Charts.init(elementId);
    this.chart = chart;
    this.stockType = getStockType(this.configs.code);

    if (this.configs.enableRealhead) {
        this.drawRealhead();
    }
};

var scrollTop;
function scrollCb() {
    if (document.documentElement && document.documentElement.scrollTop) {
        document.documentElement.scrollTop = scrollTop;
    } else if (document.body) {
        document.body.scrollTop = scrollTop;
    } else {}
}

var pchq = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            visible: false,

            leave: true, // 是否离开行情图

            code: '',

            type: 'fs',

            closed: false,

            top: 0,

            left: 0
        };
    },

    computed: {
        elementId: function elementId() {
            return 'quotechart-'; //  + this.code
        },
        realheadId: function realheadId() {
            return 'quotehead-'; //  + this.code
        },
        arrowTop: function arrowTop() {
            if (this.top > window.document.body.clientHeight - 172) {
                return 450;
            } else if (this.top > 300) {
                return 300;
            } else if (this.top > 100) {
                return 100;
            } else {
                return 30;
            }
        }
    },

    created: function created() {
        var totalConfigs = {
            elementId: this.elementId,
            realheadId: this.realheadId,
            // 是否需要实时行情头部
            enableRealhead: true,
            color: {
                axisLine: '#ccc',
                abAxis: '#de422e',
                beAxis: '#3e9663',
                eqAxis: '#BCBCBC',
                ma5: '#1F6195',
                ma10: '#E0AC58',
                ma30: '#9C73AF',
                // 悬停十字线
                hoverLine: '#A0A0A0',
                hideColor: 'rgba(255,255,255,0)'
            },
            intervalTime: 30000,
            isKeepingGet: false,
            code: this.code,
            kline: {
                minValueSpan: 20,
                startValue: -45
            },
            // 文字模板
            realheadTpl: ['<div style="position: absolute; top: 0;left: 0;width: 100%;font-family: DIN-Regular;">', '                <div style="padding: 10px;display: block; overflow: hidden;">', '                    <div style="float:left;">', '                        <div style="color: <%wgtColor%>;">', '                            <div style="line-height: 26px">', '                                <span style="font-size: 14px;"><%name%></span>', '                                <span style=""><%shortcode%></span>', '                            </div>', '                            <div style="line-height: 26px">', '                                <span style="font-size: 22px;"><%curP%></span>', '                                <span><%rate%>%    ', '                                    <span style="padding:0; display: <%arrowEnable%>;margin-left: 0px; width: 16px; height: 16px; color: #3cbc98; white-space: nowrap; text-overflow: ellipsis; line-height: 16px; margin-top: 7px; float: right;<%arrowDirect%>">', '                                        <svg viewBox="0 0 1024 1024" width="16" height="16">', '                                            <path fill="<%wgtColor%>" stroke-linecap="round" stroke-width="2" d="M288.864 636.032 511.968 405.312 735.136 636Z"></path>', '                                        </svg>', '                                    </span>', '                                </span>', '                            </div>', '                        </div>', '                    </div>', '                    <div style="float:left;margin-left: 16px; color: #636363;">', '                        <div>', '                            <div style="<%infoItemCss%>" data-hqitro="换手率"><span style="margin-right: 3px;">换手</span><span><%turnRate%>%</span></div>', '                            <div style="<%infoItemCss%>" data-hqitro="振幅"><span style="margin-right: 3px;">振幅</span><span><%zf%>%</span></div>', '                            <div style="<%infoItemCss%>" data-hqitro="成交量"><span style="margin-right: 3px;">量</span><span><%n%></span></div>', '                            <div style="<%infoItemCss%>" data-hqitro="成交额"><span style="margin-right: 3px;">额</span><span><%np%></span></div>', '                        </div>', '                        <div style="margin-top: 3px;">', '                            <div style="<%infoItemCss%>" data-hqitro="总市值"><span style="margin-right: 3px;">市值</span><span><%totalM%></span></div>', '                            <div style="<%infoItemCss%>" data-hqitro="流通市值"><span style="margin-right: 3px;">流通</span><span><%stockM%></span></div>', '                            <div style="<%infoItemCss%>" data-hqitro="市盈率"><span style="margin-right: 3px;">市盈</span><span><%staticSYL%></span></div>', '                            <div style="<%infoItemCss%>" data-hqitro="市净率"><span style="margin-right: 3px;">市净</span><span><%sjl%></span></div>', '                        </div>', '                    </div>', '                </div>', '<div style="width: 100%; height:10px;background: #f7f7f7;"></div>', '            </div>'].join('')
        };
        var self = this;
        this.$nextTick(function () {
            pchq = new PcHq(totalConfigs);
            pchq.init();
            self.toggleChart(self.type);
        });
    },


    watch: {
        type: function type(value) {
            this.toggleChart(value);
            this.updateCurType(value);
        },
        visible: function visible(value) {
            pchq.configs.code = this.code;
            if (value) {
                this.toggleChart(this.type);
                pchq.drawRealhead();
            }
        },
        code: function code(value) {
            pchq.configs.code = value;
            if (this.visible) {
                this.toggleChart(this.type);
                pchq.drawRealhead();
            }
        }
    },

    methods: {
        toggleChart: function toggleChart(type) {
            switch (type) {
                case 'fs':
                    pchq.toggleFs();
                    break;

                case 'daykline':
                    pchq.toggleKline();
                    break;

                case 'weekkline':
                    pchq.toggleKline('Week');
                    break;

                case 'monthkline':
                    pchq.toggleKline('Month');
                    break;
            }
        },
        hide: function hide() {
            var self = this;
            self.leave = true;
            setTimeout(function () {
                if (self.leave) {
                    self.visible = false;
                }
            }, 1000);
        },
        show: function show(options) {
            if (this.leave) {
                for (var key in options) {
                    this[key] = options[key];
                }
                this.visible = true;
            }
        },
        mouseleave: function mouseleave() {
            this.hide();
            document.removeEventListener('scroll', scrollCb);
        },
        mouseenter: function mouseenter() {
            if (this.leave) {
                this.leave = false;
                this.visible = true;
            }
            if (document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop;
            } else if (document.body) {
                scrollTop = document.body.scrollTop;
            } else {}
            document.addEventListener('scroll', scrollCb);
        }
    }
});

/***/ }),

/***/ "Is35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("W1k5");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("ZYGC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// @charset "utf-8";
/* harmony default export */ __webpack_exports__["a"] = ({
    backtest: {
        index: {
            beginButton: '开始回测',
            restartButton: '再次回测',
            loadingButton: '计算中…'
        }
    }
});

/***/ }),

/***/ "JRkc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// @charset "utf-8";
/* harmony default export */ __webpack_exports__["a"] = ({
    myStrategy: { // 我的策略
        createdStrategy: { // 我创建的策略
            strategyBacktestPage: 'backtest_mine.type1', // 点击策略回测分页
            backtestOncePage: 'backtest_mine.type2', // 点击回测一下分页
            search: 'backtest_mine.search1', // 搜索
            delete: 'backtest_mine.delete', // 点击删除
            deleteOk: 'backtest_mine.delete.1', // 删除-确认
            deleteCancel: 'backtest_mine.delete.0', // 删除-取消
            subscribe: 'backtest_mine.sub.1', // 订阅
            cancelSubscribe: 'backtest_mine.sub.0', // 取消订阅
            inStrategyDetails: 'backtest_mine.wdcl', // 进入策略报告页
            inBacktestOnce: 'backtest_mine.hcyx' // 进入回测一下保存页
        },
        collectStrategy: { // 我收藏的策略
            search: 'backtest_mine.search2', // 搜索
            inStrategyDetails: 'backtest_mine.sccl', // 进入策略报告页
            cancelCollect: 'backtest_mine.qxsc', // 取消收藏
            cancelCollectOk: 'backtest_mine.qxsc.1', // 取消收藏-确认
            cancelCollectCancel: 'backtest_mine.qxsc.0' // 取消收藏-取消
        },
        takeDiscuss: { // 参与的讨论
            receiveDiscuss: 'backtest_mine.comment1', // 点击收到的评论
            sendDiscuss: 'backtest_mine.comment2' // 点击发出的评论
        },
        // scrollBar: 'backtest_5aab2461_668', // 滚动条拉到低
        pageAccess: 'backtest_mine' // 页面访问
    },
    eventEvaluation: { // 事件评测
        modifyQuestion: 'backtest_sjhc.query', // 修改事件
        modifySubject: 'backtest_sjhc.target', // 修改标的
        holdingCycle: 'backtest_sjhc.duration', // 持股周期
        startDate: 'backtest_sjhc.startdate', // 回测开始时间
        endDate: 'backtest_sjhc.enddate', // 回测结束时间
        startUpBacktest: 'backtest_sjhc.start', // 启动回测
        hotBacktest: 'backtest_sjhc.hot', // 点击热门回测
        // scrollBar: 'backtest_5aab55de_242', // 滚动条拉到低
        pageAccess: 'backtest_sjhc' // 页面访问
    },
    strategySquare: { // 策略广场
        search: 'backtest_square.search', // 搜索
        sort: { // 排序
            'hot': 'backtest_square.hot',
            'profit': 'backtest_square.profit',
            'winRate': 'backtest_square.success',
            'createTime': 'backtest_square.new',
            'gain': 'backtest_square.month'
        },
        collect: 'backtestsquare.sc.1', // 收藏
        collectCancel: 'backtest_square.sc.0', // 取消收藏
        todayStockOpen: 'backtest_square.jrxg.1', // 今日选股展开
        todayStockClose: 'backtest_square.jrxg.0', // 今日选股关闭
        inStrategyDetails: 'backtest_square.clbg', // 点击进入策略
        // goPage: 'backtest_square.',  // 翻页
        // scrollBar: 'backtest_5aab23f7_683', // 滚动条拉到低
        pageAccess: 'backtest_square' // 页面访问
    },
    strategyDetails: { // 策略报告（详情）
        strategyParam: { // 策略参数面板
            modifyParam: 'backtest_square.modify', // 修改参数
            release: 'backtest_square.publish' // 发布
        },
        profitChart: { // 累计收益图
            zoomSwitch: 'backtest_square.graph.daterange', // 缩放切换
            timingOption: 'backtest_square.graph.timing', // 择时选项
            startDate: 'backtest_square.graph.startdate', // 开始时间修改
            endDate: 'backtest_square.graph.enddate' // 结束时间修改
        },
        iwencai: 'backtest_square.iwencai',
        pickStockDate: 'backtest_square.xuangu',
        upsDownsChart: { // 涨跌分布图
            timingOption: 'backtest_square.pie.timing', // 择时选项
            cycleOption: 'backtest_square.pie.duration' // 周期选择
        },
        history: { // 历史明细查询
            startDate: 'backtest_square.list.startdate', // 开始时间修改
            endDate: 'backtest_square.list.enddate', // 结束时间修改
            timingOption: 'backtest_square.list.timing', // 择时选项
            cycleOption: 'backtest_square.list.duration', // 周期选择
            export: 'backtest_square.list.export'
        },
        strategyDiscuss: { // 策略评论
            comment: 'backtest_square.comment', // 评论
            reply: 'backtest_square.reply' // 回复
        },
        pageAccess: 'backtest_square' // 页面访问
    },
    strategyBacktest: { // 策略回测
        strategyParam: { // 策略参数面板
            modifyQuestion: 'backtest_clhc.query', // 修改问句
            holdingCycle: 'backtest_clhc.duration', // 持股周期
            startDate: 'backtest_clhc.startdate', // 回测开始时间
            endDate: 'backtest_clhc.enddate', // 回测结束时间
            startUpBacktest: 'backtest_clhc.start', // 启动回测
            holdingNumber: 'backtest_clhc.stocknum', // 持股数
            marketTimingTrade: 'backtest_clhc.timing.1', // 点击切换市场择时交易
            commonRuleTrade: 'backtest_clhc.timing.0' // 点击切换普通规则交易
        },
        commonRuleTrade: { // 普通规则交易
            targetProfit: { // 止盈
                riseRapidly: 'backtest_clhc.cg', // 冲高
                fall: 'backtest_clhc.hl' // 回落
            },
            stopProfit: 'backtest_clhc.zs' // 止损
        },
        marketTimingTrade: { // 市场择时交易
            strong: { // 强势
                targetProfit: { // 止盈
                    riseRapidly: 'backtest_clhc.radical.cg', // 冲高
                    fall: 'backtest_clhc.radical.hl' // 回落
                },
                stopProfit: 'backtest_clhc.radical.zs' // 止损
            },
            weak: { // 弱势
                targetProfit: { // 止盈
                    riseRapidly: 'backtest_clhc.conservative.cg', // 冲高
                    fall: 'backtest_clhc.conservative.hl' // 回落
                },
                stopProfit: 'backtest_clhc.conservative.zs', // 止损
                positionControl: 'backtest_clhc.position' // 仓位控制
            }
        },
        timingSignal: { // 择时信号
            openPanel: 'backtest_clhc.signal', // 打开面板
            selectSignal: 'backtest_clhc.signal.1', // 选择信号
            deleteSignal: 'backtest_clhc.signal.0', // 删除信号
            selectAll: 'backtest_clhc.signal.all' // 全选
        },
        saveRelease: 'backtest_clhc.save', // 点击保存发布
        releaseBacktestReport: { // 发布回测报告
            // modifyName: 'backtest_5aab52c9_339',  // 修改报告名称
            // modifyLogic: 'backtest_5aab52d5_789',  // 修改逻辑说明
            // modifyLabel: 'backtest_5aab52e5_938',  // 修改策略标签
            saveDraft: 'backtest_clhc.save.1', // 点击保存草稿
            releaseStrategy: 'backtest_clhc.save.2' // 点击发布策略
        },
        iwencai: 'backtest_clhc.iwencai',
        pickStockDate: 'backtest_clhc.xuangu',
        // saveAfterRelease: {// 保存后点击发布
        //     ok: 'backtest_5aab52f3_263',  // 确定
        //     cancel: 'backtest_5aab5300_438' // 取消
        // },
        profitChart: { // 累计收益图
            zoomSwitch: 'backtest_clhc.graph.daterange', // 缩放切换
            timingOption: 'backtest_clhc.graph.timing', // 择时选项
            startDate: 'backtest_clhc.graph.startdate', // 开始时间修改
            endDate: 'backtest_clhc.graph.enddate' // 结束时间修改
        },
        upsDownsChart: { // 涨跌分布图
            timingOption: 'backtest_clhc.pie.timing', // 择时选项
            cycleOption: 'backtest_clhc.pie.duration' // 周期选择
        },
        history: { // 历史明细查询
            startDate: 'backtest_clhc.list.startdate', // 开始时间修改
            endDate: 'backtest_clhc.list.enddate', // 结束时间修改
            timingOption: 'backtest_clhc.list.timing', // 择时选项
            cycleOption: 'backtest_clhc.list.duration',
            export: 'backtest_clhc.list.export' // 周期选择
        },
        // scrollBar: 'backtest_5aab2397_374', // 滚动条拉到低
        pageAccess: 'backtest_clhc' // 页面访问
    },
    backtestOnce: { // 回测一下
        strategyParam: { // 策略参数面板
            modifyQuestion: 'backtest_hcyx.query', // 修改问句
            holdingCycle: 'backtest_hcyx.duration', // 持股周期
            startDate: 'backtest_hcyx.startdate', // 回测开始时间
            endDate: 'backtest_hcyx.enddate', // 回测结束时间
            startUpBacktest: 'backtest_hcyx.start' // 启动回测
        },
        upsDownsChart: { // 涨跌分布图
            cycleOption: 'backtest_hcyx.pie.duration' // 周期选择
        },
        history: { // 历史明细查询
            startDate: 'backtest_hcyx.list.startdate', // 开始时间修改
            endDate: 'backtest_hcyx.list.enddate', // 结束时间修改
            cycleOption: 'backtest_hcyx.list.duration', // 周期选择
            export: 'backtest_hcyx.list.export'
        },
        hotBacktest: 'backtest_hcyx.hot', // 点击热门回测
        backtestResult: { // 回测结果页
            save: 'backtest_hcyx.save.1', // 保存
            saveCancel: 'backtest_hcyx.save.0' // 取消保存
        },
        // scrollBar: 'backtest_5ab09e6d_335', // 滚动条拉到低
        pageAccess: 'backtest_hcyx' // 页面访问
    }
    // export default {
    //     myStrategy: {// 我的策略
    //         createdStrategy: {// 我创建的策略
    //             strategyBacktestPage: 'backtest_5aab560a_991',  // 点击策略回测分页
    //             backtestOncePage: 'backtest_5aab5616_327',  // 点击回测一下分页
    //             search: 'backtest_5aab5622_380',  // 搜索
    //             delete: 'backtest_5aab562d_988',  // 点击删除
    //             deleteOk: 'backtest_5aab5639_327',  // 删除-确认
    //             deleteCancel: 'backtest_5aab5644_673',  // 删除-取消
    //             subscribe: 'backtest_5aab5661_838',  // 订阅
    //             cancelSubscribe: 'backtest_5aab5697_483',  // 取消订阅
    //             inStrategyDetails: 'backtest_5aab566c_650',  // 进入策略报告页
    //             inBacktestOnce: 'backtest_5aab5677_262' // 进入回测一下保存页
    //         },
    //         collectStrategy: {// 我收藏的策略
    //             search: 'backtest_5aab56a7_277',  // 搜索
    //             cancelCollect: 'backtest_5aab56b1_808',  // 取消收藏
    //             cancelCollectOk: 'backtest_5aab56bc_713',  // 取消收藏-确认
    //             cancelCollectCancel: 'backtest_5aab56c7_420' // 取消收藏-取消
    //         },
    //         takeDiscuss: {// 参与的讨论
    //             receiveDiscuss: 'backtest_5aab2438_905',  // 点击收到的评论
    //             sendDiscuss: 'backtest_5aab244f_745' // 点击发出的评论
    //         },
    //         scrollBar: 'backtest_5aab2461_668', // 滚动条拉到低
    //         pageAccess: 'backtest_5b20d439_659' // 页面访问
    //     },
    //     eventEvaluation: {// 事件评测
    //         modifyQuestion: 'backtest_5aab554e_994',  // 修改事件
    //         modifySubject: 'backtest_5aab555c_883',  // 修改标的
    //         holdingCycle: 'backtest_5aab5585_151',  // 持股周期
    //         startDate: 'backtest_5aab55b9_500',  // 回测开始时间
    //         endDate: 'backtest_5aab55c4_620',  // 回测结束时间
    //         startUpBacktest: 'backtest_5aab241b_107',  // 启动回测
    //         hotBacktest: 'backtest_5aab55d0_798',  // 点击热门回测
    //         scrollBar: 'backtest_5aab55de_242', // 滚动条拉到低
    //         pageAccess: 'backtest_5b20d425_898' // 页面访问
    //     },
    //     strategySquare: {// 策略广场
    //         search: 'backtest_5aab5501_530',  // 搜索
    //         sort: 'backtest_5aab23d4_713',  // 排序
    //         collect: 'backtest_5aab550e_32',  // 收藏
    //         collectCancel: 'backtest_5aab5518_430',  // 取消收藏
    //         todayStockOpen: 'backtest_5aab5525_150',  // 今日选股展开
    //         todayStockClose: 'backtest_5aab5530_822',  // 今日选股关闭
    //         inStrategyDetails: 'backtest_5aab553b_819',  // 点击进入策略
    //         goPage: 'backtest_5aab23e1_697',  // 翻页
    //         scrollBar: 'backtest_5aab23f7_683', // 滚动条拉到低
    //         pageAccess: 'backtest_5b20d40d_263' // 页面访问
    //     },
    //     strategyDetails: {// 策略报告（详情）
    //         strategyParam: {// 策略参数面板
    //             modifyParam: 'backtest_5aab5417_43',  // 修改参数
    //             release: 'backtest_5aab5424_613' // 发布
    //         },
    //         profitChart: {// 累计收益图
    //             zoomSwitch: 'backtest_5aab543a_784',  // 缩放切换
    //             timingOption: 'backtest_5aab5447_634',  // 择时选项
    //             startDate: 'backtest_5aab5454_930',  // 开始时间修改
    //             endDate: 'backtest_5aab5463_808' // 结束时间修改
    //         },
    //         upsDownsChart: {// 涨跌分布图
    //             timingOption: 'backtest_5aab5471_83',  // 择时选项
    //             cycleOption: 'backtest_5aab547d_433' // 周期选择
    //         },
    //         history: {// 历史明细查询
    //             startDate: 'backtest_5aab548b_135',  // 开始时间修改
    //             endDate: 'backtest_5aab5496_613',  // 结束时间修改
    //             timingOption: 'backtest_5aab54a2_758',  // 择时选项
    //             cycleOption: 'backtest_5aab54d4_923' // 周期选择
    //         },
    //         strategyDiscuss: {// 策略评论
    //             comment: 'backtest_5aab54e3_197',  // 评论
    //             reply: 'backtest_5aab54ed_659' // 回复
    //         },
    //         pageAccess: 'backtest_5b20d450_29' // 页面访问
    //     },
    //     strategyBacktest: {// 策略回测
    //         strategyParam: {// 策略参数面板
    //             modifyQuestion: 'backtest_5aab3bb1_132',  // 修改问句
    //             holdingCycle: 'backtest_5aab3be7_240',  // 持股周期
    //             startDate: 'backtest_5aab3bfc_133',  // 回测开始时间
    //             endDate: 'backtest_5aab3c0d_352',  // 回测结束时间
    //             startUpBacktest: 'backtest_5aab234f_584',  // 启动回测
    //             holdingNumber: 'backtest_5aab3c1c_948',  // 持股数
    //             marketTimingTrade: 'backtest_5aab3c2b_563',  // 点击切换市场择时交易
    //             commonRuleTrade: 'backtest_5aab3c38_382' // 点击切换普通规则交易
    //         },
    //         commonRuleTrade: {// 普通规则交易
    //             targetProfit: {// 止盈
    //                 riseRapidly: 'backtest_5aab3c49_343', // 冲高
    //                 fall: 'backtest_5aab3c5c_643' // 回落
    //             },
    //             stopProfit: 'backtest_5aab3c6c_693' // 止损
    //         },
    //         marketTimingTrade: {// 市场择时交易
    //             strong: {// 强势
    //                 targetProfit: {// 止盈
    //                     riseRapidly: 'backtest_5aab3c79_989',  // 冲高
    //                     fall: 'backtest_5aab3c87_212' // 回落
    //                 },
    //                 stopProfit: 'backtest_5aab522a_692' // 止损
    //             },
    //             weak: {// 弱势
    //                 targetProfit: {// 止盈
    //                     riseRapidly: 'backtest_5aab5239_331',  // 冲高
    //                     fall: 'backtest_5aab5246_681' // 回落
    //                 },
    //                 stopProfit: 'backtest_5aab5258_112',  // 止损
    //                 positionControl: 'backtest_5aab5265_333' // 仓位控制
    //             }
    //         },
    //         timingSignal: {// 择时信号
    //             openPanel: 'backtest_5aab5274_612',  // 打开面板
    //             selectSignal: 'backtest_5aab528f_855',  // 选择信号
    //             deleteSignal: 'backtest_5aab529d_219',  // 删除信号
    //             selectAll: 'backtest_5aab52ad_951' // 全选
    //         },
    //         saveRelease: 'backtest_5aab52bb_788',  // 点击保存发布
    //         releaseBacktestReport: {// 发布回测报告
    //             modifyName: 'backtest_5aab52c9_339',  // 修改报告名称
    //             modifyLogic: 'backtest_5aab52d5_789',  // 修改逻辑说明
    //             modifyLabel: 'backtest_5aab52e5_938',  // 修改策略标签
    //             saveDraft: 'backtest_5aab2382_435',  // 点击保存草稿
    //             releaseStrategy: 'backtest_5aab236d_608' // 点击发布策略
    //         },
    //         saveAfterRelease: {// 保存后点击发布
    //             ok: 'backtest_5aab52f3_263',  // 确定
    //             cancel: 'backtest_5aab5300_438' // 取消
    //         },
    //         profitChart: {// 累计收益图
    //             zoomSwitch: 'backtest_5aab530d_209',  // 缩放切换
    //             timingOption: 'backtest_5aab531a_143',  // 择时选项
    //             startDate: 'backtest_5aab5325_833',  // 开始时间修改
    //             endDate: 'backtest_5aab5359_682' // 结束时间修改
    //         },
    //         upsDownsChart: {// 涨跌分布图
    //             timingOption: 'backtest_5aab539f_968',  // 择时选项
    //             cycleOption: 'backtest_5aab53ad_814' // 周期选择
    //         },
    //         history: {// 历史明细查询
    //             startDate: 'backtest_5aab53c3_89',  // 开始时间修改
    //             endDate: 'backtest_5aab53d0_29',  // 结束时间修改
    //             timingOption: 'backtest_5aab53df_653',  // 择时选项
    //             cycleOption: 'backtest_5aab53ec_835' // 周期选择
    //         },
    //         scrollBar: 'backtest_5aab2397_374', // 滚动条拉到低
    //         pageAccess: 'backtest_5b20d3df_680' // 页面访问
    //     },
    //     backtestOnce: {// 回测一下
    //         strategyParam: {// 策略参数面板
    //             modifyQuestion: 'backtest_5aab3b15_532',  // 修改问句
    //             holdingCycle: 'backtest_5aab3b22_983',  // 持股周期
    //             startDate: 'backtest_5aab3b37_331',  // 回测开始时间
    //             endDate: 'backtest_5aab3b44_961',  // 回测结束时间
    //             startUpBacktest: 'backtest_5aab22e0_406' // 启动回测
    //         },
    //         upsDownsChart: {// 涨跌分布图
    //             cycleOption: 'backtest_5aab3b51_654' // 周期选择
    //         },
    //         history: {// 历史明细查询
    //             startDate: 'backtest_5aab3b61_489',  // 开始时间修改
    //             endDate: 'backtest_5aab3b6d_654',  // 结束时间修改
    //             cycleOption: 'backtest_5aab3b79_693' // 周期选择
    //         },
    //         hotBacktest: 'backtest_5aab3b8a_431',  // 点击热门回测
    //         backtestResult: {// 回测结果页
    //             save: 'backtest_5aab22ef_56',  // 保存
    //             saveCancel: 'backtest_5aab3b98_239' // 取消保存
    //         },
    //         scrollBar: 'backtest_5ab09e6d_335', // 滚动条拉到低
    //         pageAccess: 'backtest_5b20d3cb_303' // 页面访问
    //     },
    //     navigationBar: {// 导航栏
    //         home: 'backtest_5aa8d520_374',  // 首页
    //         backtestOnce: 'backtest_5aab22cc_934',  // 回测一下
    //         strategyBacktest: 'backtest_5aab2325_767',  // 策略回测
    //         strategySquare: 'backtest_5aab23c4_988',  // 策略广场
    //         eventEvaluation: 'backtest_5aab2406_897',  // 事件评测
    //         myStrategy: 'backtest_5aab242b_623' // 我的策略
    //     },
    //     totalPlatformAccess: 'backtest_5b20d46c_372' // 平台总访问量
    // }

});

/***/ }),

/***/ "K5kc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'backtest-once',
    data: function data() {
        return {
            onceKeyWord: '',
            currentPage: 1,
            pageSize: 10,
            sort: 'ctime',
            order: 'DESC',
            isshowloading: false,
            isFromSearch: true,
            isSearchResult: false
        };
    },

    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.myStrategy.createdStrategy;
        },
        backtestOnceData: function backtestOnceData() {
            return this.$store.getters['myStrategy/backtestOnceData'];
        },
        onceDataList: function onceDataList() {
            return this.backtestOnceData.list;
        },
        total: function total() {
            return this.backtestOnceData.num;
        }
    },
    methods: {
        buriedPoints: function buriedPoints() {
            window.TA.log(this.buriedPoint.inBacktestOnce);
        },
        goPage: function goPage(page) {
            window.TA.log(this.buriedPoint.backtestOncePage);
            this.currentPage = page;
        },
        updateList: function updateList() {
            var self = this;
            this.isshowloading = true;
            this.isSearchResult = false;
            this.$store.dispatch('myStrategy/requestBacktestOnce', {
                keyword: this.onceKeyWord,
                page: this.currentPage,
                pagesize: this.pageSize,
                sort: this.sort,
                order: this.order
            }).then(function (result) {
                self.isshowloading = false;
                if (self.onceDataList.length === 0) {
                    self.isFromSearch = Boolean(self.onceKeyWord);
                    self.isSearchResult = true;
                } else {
                    self.isSearchResult = false;
                }
            }).catch(function (error) {
                self.isshowloading = false;
                self.$tip({ message: error ? error.message : '网络异常', type: 'error' });
            });
        },
        updateSearchOnce: function updateSearchOnce() {
            window.TA.log(this.buriedPoint.search);
            this.updateList();
        },
        parseQuery: function parseQuery(item) {
            return {
                endDate: item.end_time,
                startDate: item.start_time,
                daysForSaleStrategy: item.days_for_sale,
                query: item.query,
                benchmark: item.benchmark
            };
        }
    },
    created: function created() {
        this.updateList();
    },

    watch: {
        currentPage: function currentPage() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "KgfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcode_vue__ = __webpack_require__("rEFo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d811e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcode_vue__ = __webpack_require__("Vv6i");
function injectStyle (ssrContext) {
  __webpack_require__("C33N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42d811e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d811e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L2VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vue-button",class:[
        _vm.type ? 'vue-button--' + _vm.type : '',
        _vm.size ? 'vue-button--' + _vm.size : '',
        _vm.disabled ? 'vue-button--disabled' : '',
        _vm.loading ? 'vue-button--loading' : ''
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i'):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L8SC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__strategybacktest_chart__ = __webpack_require__("SHHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strategybacktest_history__ = __webpack_require__("NOyp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strategybacktest_backtest_analysis__ = __webpack_require__("Ze1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strategybacktest_strategy_select__ = __webpack_require__("wC/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__strategybacktest_profit_chart__ = __webpack_require__("ac+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__strategybacktest_report_grade__ = __webpack_require__("gG4O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__receive_discuss__ = __webpack_require__("M0ul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-new */









var requestarr = [];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'strategydetail',
    components: {
        'change-rate-group': __WEBPACK_IMPORTED_MODULE_0__strategybacktest_chart__["a" /* default */],
        'history-detail': __WEBPACK_IMPORTED_MODULE_1__strategybacktest_history__["a" /* default */],
        'backtest-analysis': __WEBPACK_IMPORTED_MODULE_2__strategybacktest_backtest_analysis__["a" /* default */],
        'strategy-select': __WEBPACK_IMPORTED_MODULE_3__strategybacktest_strategy_select__["a" /* default */],
        'profit-chart': __WEBPACK_IMPORTED_MODULE_4__strategybacktest_profit_chart__["a" /* default */],
        'report-grade': __WEBPACK_IMPORTED_MODULE_5__strategybacktest_report_grade__["a" /* default */],
        'receive-discuss': __WEBPACK_IMPORTED_MODULE_6__receive_discuss__["a" /* default */]
    },
    data: function data() {
        var nowDate = this._getNowDate();
        return {
            myBarOption: {
                barWidth: 9, // 滚动条宽度
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                horizrailenabled: false // 是否显示水平滚动条
            },
            tradeStartDate: nowDate,
            tradeEndDate: nowDate,
            iscommentshow: false,
            isshowtestloading: false,
            detailCompleted: false,
            iscancel: false,
            isCollected: false,
            collectedNum: 0,
            isPublish: 2, // 2-未发布 1-发布
            isOwn: false, // 是否为当用用户的回测
            pid: 0,
            authorid: 0,
            id: '',
            currentBacktestType: '1',
            number: '',
            strategydetail: {},
            reportdata: {
                maxAnnualYield: {},
                maxWinRate: {}
            },
            signalData: {},
            scoreData: {},
            backtestdata: {},
            cumulative: [],
            change: [],
            Hsdata: [],
            selectData: null,
            comment: '',
            commentUploading: false,
            profitgraphCompleted: false // 图表数据请求完成
        };
    },

    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.strategyDetails;
        },
        totalPoint: function totalPoint() {
            return this.$buriedPoint.totalPlatformAccess;
        },
        strategyId: function strategyId() {
            return this.$route.params.id;
        },
        dayselect: function dayselect() {
            return this.number.split(',');
        },
        marketsignals: function marketsignals() {
            var marketsignal = [];
            for (var key in this.backtestdata) {
                marketsignal.push(key);
            }
            return marketsignal;
        },

        // 取最优的两条
        backtestAnalysisData: function backtestAnalysisData() {
            if (this.currentBacktestType === '1') {
                return this.backtestdata;
            } else {
                var maxWinRate = this.reportdata.maxWinRate;
                var maxAnnualYield = this.reportdata.maxAnnualYield;

                var analysisData = {};
                analysisData[maxWinRate[1]] = this.backtestdata[maxWinRate[1]];
                analysisData[maxAnnualYield[1]] = this.backtestdata[maxAnnualYield[1]];
                return analysisData;
            }
        },

        // 取最优的两条
        bestMarketsignals: function bestMarketsignals() {
            if (this.currentBacktestType === '1') {
                return this.marketsignals;
            } else {
                var maxWinRate = this.reportdata.maxWinRate;
                var maxAnnualYield = this.reportdata.maxAnnualYield;
                if (maxWinRate[1] === maxAnnualYield[1]) {
                    return [maxWinRate[1]];
                } else {
                    return [maxWinRate[1], maxAnnualYield[1]];
                }
            }
        }
    },
    created: function created() {
        this.request(this.strategyId);
    },
    mounted: function mounted() {
        var _this = this;

        window.TA.log({ id: this.buriedPoint.pageAccess.replace('_square', '_square_' + this.strategyId), _sid: '__ths_001' });
        // window.TA.log({id: this.totalPoint, _sid: '__ths_002'})
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/tradebacktest/menvdata').then(function (res) {
            _this.signalData = res.data.result.data;
        }).catch(function (error) {
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });
    },

    watch: {
        strategyId: function strategyId(id) {
            this.request(id);
        }
    },
    methods: {
        positionTitle: function positionTitle(position) {
            position = parseInt(position);
            if (position === 0) {
                return '空仓';
            } else if (position === 100) {
                return '满仓';
            } else {
                return '' + position + '%仓位';
            }
        },
        buriedPoints: function buriedPoints() {
            window.TA.log(this.buriedPoint.strategyParam.modifyParam.replace('_square', '_square_' + this.strategyId));
        },

        _getNowDate: function _getNowDate() {
            var now = new Date();
            var month = now.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
            var nowDate = now.getFullYear() + '-' + month + '-' + date;
            return nowDate;
        },
        request: function request(id) {
            var _this2 = this;

            var self = this;
            var counts1 = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/strategysquare/detail', { params: { strategyId: id } });
            counts1.then(function (res) {
                return res.data;
            }).then(function (data) {
                if (data.errorcode !== 0) {
                    if (data.errorcode === -410) {
                        self.$router.replace({ name: 'strategysquare' });
                        return;
                    }
                    self.$tip({ message: data.errormsg ? data.errormsg : '获取策略详情失败', type: 'error' });
                } else {
                    _this2.strategydetail = data.result;
                    _this2.number = data.result.daysForSaleStrategy;
                    _this2.id = data.result.key;
                    _this2.pid = data.result.pid;
                    _this2.authorid = data.result.authorId;
                    _this2.tradeStartDate = data.result.startDate;
                    _this2.tradeEndDate = data.result.endDate;
                    _this2.isCollected = data.result.isCollected;
                    _this2.collectedNum = data.result.collectedNum;
                    _this2.isPublish = parseInt(data.result.isPublish);
                    _this2.isOwn = data.result.isOwn;
                    _this2.currentBacktestType = data.result.menv ? '2' : '1';
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });

            requestarr.push(counts1);

            var counts2 = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/strategysquare/backtestresult', { params: { strategyId: id } });
            counts2.then(function (res) {
                return res.data;
            }).then(function (data) {
                if (data.errorcode !== 0) {
                    if (data.errorcode === -410) {
                        self.$router.replace({ name: 'strategysquare' });
                        return;
                    }
                    self.$tip({ message: data.errormsg ? data.errormsg : '获取策略详情失败', type: 'error' });
                } else {
                    _this2.reportdata = data.result.statistics.reportData;
                    _this2.backtestdata = data.result.analysis.backtestData;
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });

            requestarr.push(counts2);

            this.isshowtestloading = true;
            this.detailCompleted = false;
            this.profitgraphCompleted = false;
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.all(requestarr).then(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.spread(function () {
                self.$nextTick(function () {
                    self.chartdata();
                    self.pickdata();
                });
                _this2.isshowtestloading = false;
                _this2.detailCompleted = true;
            }));
        },

        chartdata: function chartdata() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/strategysquare/profitgraph', { params: { strategyId: this.strategyId } }).then(function (res) {
                return res.data;
            }).then(function (data) {
                if (data.errorcode !== 0) {
                    self.$tip({ message: data.errormsg ? data.errormsg : '获取图表失败', type: 'error' });
                } else {
                    self.cumulative = data.result.profitRateLine;
                    self.scoreData = data.result.rankScore;
                    self.change = data.result.profitRatePie;
                    self.Hsdata = data.result.HS300Line;
                    self.profitgraphCompleted = true;
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        },
        pickdata: function pickdata() {
            var _this3 = this;

            var self = this;
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('/strategysquare/pickstock', { params: { strategyId: this.strategyId } }).then(function (res) {
                return res.data;
            }).then(function (data) {
                if (data.errorcode !== 0) {
                    if (data.errorcode === -410) {
                        _this3.$router.replace({ name: 'strategysquare' });
                        return;
                    }
                    _this3.$tip({ message: data.errormsg ? data.errormsg : '获取选股失败', type: 'error' });
                } else {
                    _this3.selectData = data.result;
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        },
        // 发布
        releaseBacktest: function releaseBacktest(id) {
            var self = this;

            this.$confirm({
                'title': '您确定要发布该策略吗？',
                'okBtnTitle': '确定',
                'okBtnCallback': function okBtnCallback(done) {
                    window.TA.log(self.buriedPoint.strategyParam.release.replace('_square', '_square_' + this.strategyId));
                    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('/tradebacktest/release', {
                        id: id
                    }).then(function (res) {
                        done();
                        if (res) {
                            if (res.data.errorcode !== 0 && res.data.errorcode !== -99) {
                                self.$tip({ message: res.data.errormsg ? res.data.errormsg : '发布失败', type: 'error' });
                            } else if (res.data.errorcode === -99) {
                                self.$tip({ message: '发布失败，您的同花顺账户暂未绑定手机号码', type: 'error' });
                            } else {
                                self.$store.dispatch('myStrategy/requestTradeBacktest');
                                self.$tip({ message: '提交成功！正在审核中', type: 'success' });
                                self.isPublish = 1;
                            }
                        }
                    }).catch(function (error) {
                        done();
                        self.$tip({
                            message: error ? error.message : '发布失败',
                            duration: 2000,
                            type: 'error'
                        });
                    });
                }
            });
        },
        addCollection: function addCollection(id) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('/strategysquare/collect', {
                strategyId: id
            }).then(function (res) {
                if (res) {
                    if (res.data.errorcode === 0) {
                        self.$tip({
                            message: '策略收藏成功',
                            duration: 2000,
                            type: 'success'
                        });
                        self.isCollected = true;
                        self.$store.dispatch('myStrategy/requestCollectBacktest');
                    } else {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg : '策略收藏失败',
                            duration: 2000,
                            type: 'error'
                        });
                    }
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '策略收藏失败',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        removeCollection: function removeCollection(id) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('/strategysquare/uncollect', {
                strategyId: id
            }).then(function (res) {
                if (res) {
                    if (res.data.errorcode === 0) {
                        self.$tip({
                            message: '策略取消收藏成功',
                            duration: 2000,
                            type: 'success'
                        });
                        self.$store.dispatch('myStrategy/requestCollectBacktest');
                    }
                    self.isCollected = false;
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '策略取消收藏失败',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        commentClick: function commentClick() {
            var _this4 = this;

            var self = this;
            if (this.commentUploading) {
                return;
            }
            if (this.comment === '') {
                this.iscommentshow = true;
            } else {
                window.TA.log(this.buriedPoint.strategyDiscuss.comment.replace('_square', '_square_' + this.strategyId));
                this.commentUploading = true;
                __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('/sns/addcomment', {
                    pid: this.pid,
                    receiver_id: this.authorid,
                    content: this.comment
                }).then(function (res) {
                    if (!res.data.result) {
                        _this4.$tip({
                            message: '回复失败，请稍后再试',
                            duration: 2000,
                            type: 'error'
                        });
                    } else {
                        _this4.$tip({
                            message: '回复内容正在后台审核中',
                            duration: 2000,
                            type: 'success'
                        });
                        _this4.comment = '';
                        self.$store.dispatch('myStrategy/requestSendDiscuss');
                    }
                    _this4.commentUploading = false;
                }).catch(function (error) {
                    _this4.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                    _this4.commentUploading = false;
                });
            }
        }
    }
});

/***/ }),

/***/ "LBNZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LN0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strategybacktest_strategy_select__ = __webpack_require__("wC/k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'itemrow',
    components: {
        pickstock: __WEBPACK_IMPORTED_MODULE_1__strategybacktest_strategy_select__["a" /* default */]
    },
    data: function data() {
        return {
            myBarOption: {
                barWidth: 9, // 滚动条宽度
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                horizrailenabled: false // 是否显示水平滚动条
            },
            isCollected: false,
            showOrder: '',
            isshowitemstock: false,
            isshoworder: false,
            strategyTime: '',
            stocksList: [],
            pickData: null
        };
    },

    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.strategySquare;
        }
    },
    filters: {
        positionControl: function positionControl(num) {
            switch (num) {
                case 1:
                    return '满仓';
                case 0:
                    return '空仓';
                default:
                    return Number(num * 100) + '%';
            }
        },
        closePrices: function closePrices(num) {
            return !num ? '--' : Number(num);
        }
    },
    methods: {
        buriedPoints: function buriedPoints() {
            window.TA.log({ id: this.buriedPoint.inStrategyDetails + '.' + ((this.page - 1) * 10 + this.indexSerial), targid: this.strategyId });
        },
        addCollection: function addCollection(id) {
            window.TA.log(this.buriedPoint.collect);
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/strategysquare/collect', {
                strategyId: id
            }).then(function (res) {
                if (res) {
                    if (res.data.errorcode === 0) {
                        self.$tip({
                            message: '策略收藏成功',
                            duration: 2000,
                            type: 'success'
                        });
                        self.isCollected = true;
                        self.$store.dispatch('myStrategy/requestCollectBacktest');
                    } else {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg : '策略收藏失败',
                            duration: 2000,
                            type: 'error'
                        });
                    }
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '策略收藏失败',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        removeCollection: function removeCollection(id) {
            window.TA.log(this.buriedPoint.collectCancel);
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/strategysquare/uncollect', {
                strategyId: id
            }).then(function (res) {
                if (res) {
                    if (res.data.errorcode === 0) {
                        self.$tip({
                            message: '策略取消收藏成功',
                            duration: 2000,
                            type: 'success'
                        });
                        self.isCollected = false;
                        self.$store.dispatch('myStrategy/requestCollectBacktest');
                    }
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '策略取消收藏失败',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        closeTodayStock: function closeTodayStock() {
            window.TA.log(this.buriedPoint.todayStockClose);
            this.isshoworder = false;
        },
        showTodayStock: function showTodayStock(id) {
            window.TA.log(this.buriedPoint.todayStockOpen);
            this.isshoworder = true;
            this.showTodayStockData(id);
        },
        showTodayStockData: function showTodayStockData(id) {
            var self = this;
            if (this.isshoworder) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/strategysquare/pickstock', { params: {
                        strategyId: id
                    }
                }).then(function (res) {
                    if (res.data.errorcode !== 0) {
                        self.$tip({
                            message: '获取选股数据有误',
                            duration: 2000,
                            type: 'error'
                        });
                        return;
                    }

                    var data = res.data.result;
                    self.pickData = data;
                    self.strategyTime = data.date;
                    if (data.stocks.length === 0) {
                        self.stocksList = [];
                    } else {
                        self.stocksList = data.stocks;
                    }
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            }
        }
    },
    mounted: function mounted() {
        this.isCollected = this.strategyIsCollected;
        if (this.indexSerial < 3 && this.indexSerial >= 0 && this.page === 1) {
            this.isshowitemstock = true;
        }
    },

    props: {
        buyPosition: Number,
        indexSerial: {
            type: Number,
            default: null
        },
        page: {
            type: Number,
            default: null
        },
        strategyId: {
            type: Number,
            default: ''
        },
        strategyName: {
            type: String,
            default: ''
        },
        strategyLogic: {
            type: String,
            default: ''
        },
        strategyCtime: {
            type: String,
            default: ''
        },
        strategyAnnualYield: {
            type: String,
            default: '0.00%'
        },
        strategyWinRate: {
            type: String,
            default: '0.00%'
        },
        strategyTags: {
            type: Array,
            default: []
        },
        strategyUser: {
            type: String,
            default: ''
        },
        strategyAvatar: {
            type: String,
            default: ''
        },
        strategyUserId: {
            type: Number,
            default: ''
        },
        strategyCollectNum: {
            type: Number,
            default: 0
        },
        strategyCommentNum: {
            type: Number,
            default: 0
        },
        strategyIsCollected: {
            type: Boolean,
            default: false
        },
        strategyType: {
            type: Number,
            default: 1
        },
        resetStock: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        resetStock: function resetStock() {
            this.isshoworder = false;
            this.pickData = null;
        },
        page: function page(val) {
            if (this.indexSerial < 3 && this.indexSerial >= 0 && val === 1) {
                this.isshowitemstock = true;
            } else {
                this.isshowitemstock = false;
                this.isshoworder = false;
            }
        },
        strategyIsCollected: function strategyIsCollected(val) {
            this.isCollected = val;
        },
        strategyId: function strategyId(val) {
            this.showTodayStockData(val);
        }
    }
});

/***/ }),

/***/ "LqjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__("vIEB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b82c5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__("L2VX");
function injectStyle (ssrContext) {
  __webpack_require__("diAU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42b82c5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b82c5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LrGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notice_tip_vue__ = __webpack_require__("ZusK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598fe226_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notice_tip_vue__ = __webpack_require__("1QJR");
function injectStyle (ssrContext) {
  __webpack_require__("oMgd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-598fe226"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notice_tip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598fe226_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notice_tip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M0ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receive_discuss_vue__ = __webpack_require__("T3Wr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d55ce10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receive_discuss_vue__ = __webpack_require__("CnZp");
function injectStyle (ssrContext) {
  __webpack_require__("ZwxE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d55ce10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receive_discuss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d55ce10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receive_discuss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca400dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("HDOl");
function injectStyle (ssrContext) {
  __webpack_require__("Ys1f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca400dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MOFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-message-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"main-tip",class:[_vm.customClass],style:(_vm.style),on:{"mouseenter":_vm.clearTimer,"mouseleave":_vm.startTimer}},[_c('div',{staticClass:"order-successful-execution-order",class:_vm.iconSrc,domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mitt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("7eQW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b84ba1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("U9rU");
function injectStyle (ssrContext) {
  __webpack_require__("jDkR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b84ba1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b84ba1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_vueGlobalConfig__ = __webpack_require__("29jA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_easyscroll__ = __webpack_require__("Iz3d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_feedback__ = __webpack_require__("lSu3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_qrcode__ = __webpack_require__("lmiR");
// @charset "utf-8";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_easyscroll__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__lib_feedback__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__lib_qrcode__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    template: '<App></App>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NOyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__ = __webpack_require__("Oa+M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88caeeea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("0JoO");
function injectStyle (ssrContext) {
  __webpack_require__("Fe+q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88caeeea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88caeeea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Na95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__ = __webpack_require__("mYLJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b08216a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__ = __webpack_require__("/VZa");
function injectStyle (ssrContext) {
  __webpack_require__("556f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b08216a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b08216a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oa+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__ = __webpack_require__("RarY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_exportCsv_js__ = __webpack_require__("2Eis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_quoteChartVue_js__ = __webpack_require__("lJCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-new */






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        strategyId: {
            type: String
        },
        // 回测id
        backtestId: {
            type: String,
            required: true
        },
        // 回测日期最大值
        maxDate: {
            type: String,
            required: true
        },
        // 回测日期最小值
        minDate: {
            type: String,
            required: true
        },
        // 滚动条配置
        myBarOption: {
            type: Object,
            required: true
        },
        // 周期可选值
        daySelect: {
            type: Array,
            required: true
        },
        transactiontype: String,
        maxWinrate: Array,
        signalData: Object,
        refresh: Boolean,
        marketSignals: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        var self = this;
        var debounceShowQuoteChart = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["debounce"])(function () {
            // 鼠标还停留在dom上
            if (arguments[0].target.contains(self.$mousemoveEvent.target)) {
                self.showQuoteChart.apply(self, arguments);
            }
        }, 1000);

        return {
            debounceShowQuoteChart: debounceShowQuoteChart,
            tradeStartDate: '',
            tradeEndDate: '',
            currentday: '',
            selectedSignal: '',
            historyarr: [],
            detailContent: '',
            backtestContent: '',
            exportLoading: false
        };
    },

    computed: {
        historyList: function historyList() {
            return this.filterHistory(this.historyarr.slice(0, 300));
        },
        detailContentPoint: function detailContentPoint() {
            return this.$buriedPoint.strategyDetails.history;
        },
        backtestContentPoint: function backtestContentPoint() {
            return this.$buriedPoint.strategyBacktest.history;
        }
    },
    methods: {
        hideQuoteChart: function hideQuoteChart(item) {
            __WEBPACK_IMPORTED_MODULE_4__lib_quoteChartVue_js__["a" /* default */].hide(item.stock_market.toLowerCase() + '_' + item.stock_code);
        },
        showQuoteChart: function showQuoteChart(event, item) {
            var DOMRect = event.srcElement.getBoundingClientRect();
            Object(__WEBPACK_IMPORTED_MODULE_4__lib_quoteChartVue_js__["a" /* default */])({
                code: item.stock_market.toLowerCase() + '_' + item.stock_code,
                top: DOMRect.top,
                left: DOMRect.right - 30
            });
        },
        filterHistory: function filterHistory(arr) {
            var self = this;
            return arr.filter(function (item) {
                return Number(item.start_date) >= self.dateToNumber(self.tradeStartDate) && item.start_date <= self.dateToNumber(self.tradeEndDate);
            });
        },
        getFileName: function getFileName() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            var second = date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds();
            var filename = '' + year + month + day + hour + minute + second;
            return filename;
        },
        exportHistory: function exportHistory() {
            var tableStr = '';
            var titleStr = '股票代码,股票简称,买入时间,卖出时间,买入价,卖出价,单次收益率';
            var filename = this.getFileName();

            var historyList = this.filterHistory(this.historyarr);

            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.export.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.export);
            }

            if (this.transactiontype === '1') {
                // 非择时
                tableStr = this.currentday + '天\n' + titleStr + '\n' + this.dataToCsvStr(historyList);
                Object(__WEBPACK_IMPORTED_MODULE_2__lib_exportCsv_js__["a" /* default */])(tableStr, filename);
            } else {
                // 择时
                if (this.marketSignals.length === 1) {
                    tableStr = this.currentday + '天,"' + this.signalData[this.selectedSignal] + '"\n' + titleStr + '\n' + this.dataToCsvStr(historyList);
                    Object(__WEBPACK_IMPORTED_MODULE_2__lib_exportCsv_js__["a" /* default */])(tableStr, filename);
                } else {
                    var requestSignal = this.selectedSignal === this.marketSignals[0] ? this.marketSignals[1] : this.marketSignals[0];
                    var self = this;
                    this.exportLoading = true;
                    this.requestHistory({
                        id: this.backtestId,
                        start_date: this.tradeStartDate,
                        end_date: this.tradeEndDate,
                        period: Number(this.currentday),
                        menv: requestSignal
                    }).then(function (res) {
                        self.exportLoading = false;
                        var requestHistory = '';
                        if (res.data.result instanceof Array) {
                            requestHistory = res.data.result;
                        } else {
                            requestHistory = [];
                        }

                        var dayStr = '';
                        var menvTitleStr = '';
                        self.marketSignals.forEach(function (item) {
                            dayStr += self.currentday + '天,"' + self.signalData[item] + '",,,,,,,';
                            menvTitleStr += titleStr + ',,,';
                        });
                        tableStr += dayStr + '\n' + menvTitleStr + '\n' + self.menvDataToCsvStr(historyList, requestHistory, requestSignal);

                        Object(__WEBPACK_IMPORTED_MODULE_2__lib_exportCsv_js__["a" /* default */])(tableStr, filename);
                    }).catch(function (error) {
                        self.exportLoading = false;
                        self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                    });
                }
            }
        },
        dataToCsvStr: function dataToCsvStr(historyList) {
            var csvStr = '';
            var endDate = '';
            historyList.forEach(function (item) {
                endDate = item.status === 3 ? '持仓' : item.end_date;
                csvStr += '\'' + item.stock_code + ',' + item.stock_name + ',' + item.start_date + ',' + endDate + ',' + item.start_price + ',' + item.end_price + ',' + Object(__WEBPACK_IMPORTED_MODULE_3__filters__["safePercentFixedTwo"])(item.profit) + '\n';
            });
            return csvStr;
        },
        menvDataToCsvStr: function menvDataToCsvStr(historyList, requestHistory, requestSignal) {
            var csvObj = {};
            var requestLength = requestHistory.length;
            var historyLength = historyList.length;
            csvObj[this.selectedSignal] = historyList;
            csvObj[requestSignal] = requestHistory;
            var endDate = '';
            var itemData = void 0;
            var maxLength = requestLength > historyLength ? requestLength : historyLength;
            var tableStr = '';
            for (var i = 0; i < maxLength; i++) {
                this.marketSignals.forEach(function (item) {
                    if (csvObj[item][i] === undefined) {
                        tableStr += ',,,,,,,,,';
                    } else {
                        itemData = csvObj[item][i];
                        endDate = itemData.status === 3 ? '持仓' : itemData.end_date;
                        tableStr += '\'' + itemData.stock_code + ',' + itemData.stock_name + ',' + itemData.start_date + ',' + endDate + ',' + itemData.start_price + ',' + itemData.end_price + ',' + Object(__WEBPACK_IMPORTED_MODULE_3__filters__["safePercentFixedTwo"])(itemData.profit) + ',,,';
                    }
                });
                tableStr += '\n';
            }

            return tableStr;
        },
        startDatePoint: function startDatePoint() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.startDate.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.startDate);
            }
        },
        endDatePoint: function endDatePoint() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.endDate.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.endDate);
            }
        },
        charySelect: function charySelect() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.cycleOption.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.cycleOption);
            }
        },
        charySelectTow: function charySelectTow() {
            if (this.detailContent) {
                window.TA.log(this.detailContentPoint.timingOption.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.backtestContentPoint.timingOption);
            }
        },
        dateToNumber: function dateToNumber(date) {
            return Number(date.replace(/-/g, ''));
        },

        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        gethistorydetail: function gethistorydetail() {
            var self = this;

            var params = {
                id: this.backtestId,
                start_date: this.tradeStartDate,
                end_date: this.tradeEndDate,
                period: Number(this.currentday)
            };
            if (this.transactiontype === '2') {
                params['menv'] = this.selectedSignal;
            }
            this.requestHistory(params).then(function (res) {
                if (res.data.result instanceof Array) {
                    self.historyarr = res.data.result;
                } else {
                    self.historyarr = [];
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        },
        requestHistory: function requestHistory(params) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/tradebacktest/historydetail?sort_by=desc', {
                params: params
            });
        },
        init: function init() {
            if (this.transactiontype === '2') {
                this.selectedSignal = this.maxWinrate[1];
                this.currentday = this.maxWinrate[2];
            } else {
                this.currentday = this.maxWinrate[1];
            }

            this.tradeStartDate = this.minDate;
            this.tradeEndDate = this.maxDate;
        }
    },
    created: function created() {
        this.init();
    },

    watch: {
        refresh: function refresh() {
            this.init();
        },
        backtestId: function backtestId() {
            this.gethistorydetail();
            this.init();
        },
        currentday: function currentday() {
            this.gethistorydetail();
        },
        selectedSignal: function selectedSignal() {
            this.gethistorydetail();
        },
        period: function period() {
            this.currentday = this.period;
        },
        maxDate: function maxDate() {
            this.tradeEndDate = this.maxDate;
        },
        minDate: function minDate() {
            this.tradeStartDate = this.minDate;
        }
    },
    mounted: function mounted() {
        this.detailContent = document.getElementsByClassName('strategydetailmain')[0];
        this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0];
    }
});

/***/ }),

/***/ "Q+5e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "levelType", function() { return levelType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "character", function() { return character; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safeNumber", function() { return safeNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safeIntegerNumber", function() { return safeIntegerNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safeFloatFixedTwo", function() { return safeFloatFixedTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safeFloatPerFixedTwo", function() { return safeFloatPerFixedTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "safePercentFixedTwo", function() { return safePercentFixedTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "riseAndFallClass", function() { return riseAndFallClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "limitlength", function() { return limitlength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventNumberFixed", function() { return eventNumberFixed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventFallClass", function() { return eventFallClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeDateVal", function() { return changeDateVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slicetwo", function() { return slicetwo; });
// @charset "utf-8";
var levelType = function levelType(type) {
    switch (Number(type)) {
        case 1:
            return 'level1';
        case 2:
            return 'level2';
        case 3:
            return 'level3';
        case 4:
            return 'level4';
        default:
            return '--';
    }
};

var character = function character(type) {
    switch (Number(type)) {
        case 1:
            return 'radical';
        case 2:
            return 'positive';
        case 3:
        case 4:
            return 'steady';
        // return 'conservative'
        default:
            return '--';
    }
};

var safeNumber = function safeNumber(num) {
    if (num === null) {
        return '--';
    }
    return isNaN(num) ? '--' : Number(num);
};

var safeIntegerNumber = function safeIntegerNumber(num) {
    if (num === null) {
        return '--';
    }
    return isNaN(num) ? '--' : Number(num).toFixed(0);
};

var safeFloatFixedTwo = function safeFloatFixedTwo(num) {
    if (num === null) {
        return '--';
    }
    return isNaN(num) ? '--' : Number(num).toFixed(2);
};

var safeFloatPerFixedTwo = function safeFloatPerFixedTwo(num) {
    if (num === null) {
        return '--';
    }
    return isNaN(num) ? '--' : Number(num).toFixed(2) + '%';
};

var safePercentFixedTwo = function safePercentFixedTwo(num) {
    if (num === null) {
        return '--';
    }
    return isNaN(num) ? '--' : Number(num * 100).toFixed(2) + '%';
};

var riseAndFallClass = function riseAndFallClass(num, standard) {
    if (isNaN(num)) {
        return '';
    }
    if (!standard) {
        standard = 0;
    }
    return Number(num) > standard ? 'rise-red' : Number(num) < standard ? 'fall-green' : '';
};

var eventNumberFixed = function eventNumberFixed(num) {
    if (Number(num) === -1) {
        return '--';
    } else if (Number(num) > -10 && Number(num) < 10) {
        return isNaN(num) ? '--' : Number(num * 100).toFixed(2) + '%';
    } else {
        return num;
    }
};

var eventFallClass = function eventFallClass(num, standard) {
    if (Number(num) === -1) {
        return '';
    } else if (Number(num) > -10 && Number(num) < 10) {
        if (isNaN(num)) {
            return '';
        }
        if (!standard) {
            standard = 0;
        }
        return Number(num) > standard ? 'rise-red' : Number(num) < standard ? 'fall-green' : '';
    } else {
        return '';
    }
};

var limitlength = function limitlength(num) {
    if (Number(num) <= 200) {
        return Number(num);
    } else {
        return 200;
    }
};

var changeDateVal = function changeDateVal(date) {
    if (date === undefined) {
        return '--';
    }
    return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6);
};

var slicetwo = function slicetwo(data) {
    return String(data).substring(0, 6);
};



/***/ }),

/***/ "QUI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tip_vue__ = __webpack_require__("DwA6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_170e90b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tip_vue__ = __webpack_require__("MOFW");
function injectStyle (ssrContext) {
  __webpack_require__("LBNZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-170e90b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_170e90b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QYgY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QmKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_cookieApi__ = __webpack_require__("i1oC");
// @charset "utf-8"
/* eslint-disable no-undef */
/* eslint-disable no-new */

var state = {
    userName: __WEBPACK_IMPORTED_MODULE_0__lib_cookieApi__["a" /* default */].get('escapename'),
    userId: __WEBPACK_IMPORTED_MODULE_0__lib_cookieApi__["a" /* default */].get('userid')
};
var mutations = {};
var actions = {};

var getters = {
    userName: function userName(state) {
        return state.userName;
    },
    userId: function userId(state) {
        return state.userId;
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "RarY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showTradeDateDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

// @charset "utf-8"
/* eslint-disable no-undef */
/* eslint-disable no-new */
function showTradeDateDialog(event, maxDate, minDate, options) {
    var theEvent = window.event || event;
    var domEl = theEvent.target || theEvent.srcElement || theEvent.toElement;
    var settings = {
        el: domEl,
        maxDate: maxDate,
        minDate: minDate,
        startDate: '%y-$M-%d',
        isShowClear: false,
        readOnly: true,
        onpicked: function onpicked(val) {
            /* fire v-model event begin */
            /* TODO fireEvent for IE */
            var inputEvent = document.createEvent('HTMLEvents');
            inputEvent.initEvent('input', false, true);
            domEl.dispatchEvent(inputEvent);
            /* fire v-model event end */
        }
    };

    new WdatePicker(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(settings, options));
}

/***/ }),

/***/ "RjME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chart",staticClass:"score_chart",staticStyle:{"width":"300px","height":"180px"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S796":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    props: {
        strategyId: String,
        signalData: Object,
        reportData: Object,
        transactiontype: String,
        query: String
    },
    methods: {
        iwencaiPoint: function iwencaiPoint() {
            if (document.getElementsByClassName('strategydetailmain')[0]) {
                window.TA.log(this.$buriedPoint.strategyDetails.iwencai.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.$buriedPoint.strategyBacktest.iwencai);
            }
        }
    }
});

/***/ }),

/***/ "SHHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__ = __webpack_require__("GB74");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f15a21b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__ = __webpack_require__("eNHJ");
function injectStyle (ssrContext) {
  __webpack_require__("rsWu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f15a21b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f15a21b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SKcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("4iDb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e25e54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("Huel");
function injectStyle (ssrContext) {
  __webpack_require__("ISVN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e25e54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SXK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-strategy"},[_c('div',{staticClass:"own-strategy"},[_c('p',{staticClass:"own-title"},[_vm._v("我创建的策略")]),_vm._v(" "),_c('div',{staticClass:"own-tabs"},[_c('ul',[_c('li',{staticClass:"item",class:{'active': _vm.itemTab === 1},on:{"click":function($event){_vm.itemTab = 1}}},[_vm._v("策略回测")]),_vm._v(" "),_c('li',{staticClass:"item",class:{'active': _vm.itemTab === 2},on:{"click":function($event){_vm.itemTab = 2}}},[_vm._v("回测一下")])])]),_vm._v(" "),(_vm.userId)?_c('div',{staticClass:"own-list"},[_c('strategy-backtest',{directives:[{name:"show",rawName:"v-show",value:(_vm.itemTab === 1),expression:"itemTab === 1"}]}),_vm._v(" "),_c('backtest-once',{directives:[{name:"show",rawName:"v-show",value:(_vm.itemTab === 2),expression:"itemTab === 2"}]})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"own-collect-strategy"},[_c('p',{staticClass:"own-collect-title"},[_vm._v("我收藏的策略")]),_vm._v(" "),_c('div',{staticClass:"own-collect-list-body"},[_c('div',{staticClass:"body-search"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyWord),expression:"keyWord"}],attrs:{"type":"text","placeholder":"搜索关键词"},domProps:{"value":(_vm.keyWord)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateSearch.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.keyWord=$event.target.value}}}),_vm._v(" "),_c('span',{on:{"click":_vm.updateSearch}})])]),_vm._v(" "),_c('div',{staticClass:"body-list"},[_c('div',{staticClass:"list"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult && !_vm.isFromSearch),expression:"isSearchResult && !isFromSearch"}]},[_c('span',[_vm._v("你还没有收藏任何策略哦~")]),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":'/strategysquare'}},[_c('span',{staticClass:"created"},[_vm._v("去策略广场逛逛")])])],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult && _vm.isFromSearch),expression:"isSearchResult && isFromSearch"}]},[_vm._v("暂无查询列表数据")]),_vm._v(" "),_c('vue-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowloading),expression:"isshowloading"}],staticStyle:{"height":"calc(100% - 20px)","border":"none","top":"0","left":"0"}}),_vm._v(" "),_vm._l((_vm.ownCollectDataLiat),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearchResult && !_vm.isshowloading),expression:"!isSearchResult && !isshowloading"}],key:index,staticClass:"list-item"},[_c('div',{staticClass:"item-left"},[_c('div',{staticClass:"item-logo"},[_c('router-link',{key:item.property.id,attrs:{"to":'/strategysquare/' + item.property.id},on:{"click":function($event){return _vm.strategyDetailPoint(item.property.id)}}},[_c('img',{attrs:{"src":'/svg/' + item.property.id + '.svg'}})])],1)]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"item-right-t"},[_c('div',{staticClass:"item-details"},[_c('router-link',{key:item.property.id,attrs:{"to":'/strategysquare/' + item.property.id},on:{"click":function($event){return _vm.strategyDetailPoint(item.property.id)}}},[_c('h3',[_vm._v(_vm._s(item.property.name))])]),_vm._v(" "),_c('div',{staticClass:"item-label"},_vm._l((item.property.tags),function(itemm,i){return _c('span',{directives:[{name:"show",rawName:"v-show",value:(itemm === '' ? false : true),expression:"itemm === '' ? false : true"}],key:i},[_vm._v(_vm._s(itemm))])}),0),_vm._v(" "),_c('p',[_c('b',[_vm._v("投资逻辑：")]),_vm._v(_vm._s(item.property.logic))])],1),_vm._v(" "),_c('div',{staticClass:"item-annual-income"},[_c('p',{class:_vm._f("riseAndFallClass")(item.property.annualYield)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item.property.annualYield)))]),_vm._v(" "),_c('span',[_vm._v("年化收益")])]),_vm._v(" "),_c('div',{staticClass:"item-success-rate"},[_c('p',{class:_vm._f("riseAndFallClass")(item.property.winRate)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item.property.winRate)))]),_vm._v(" "),_c('span',[_vm._v("成功率")])]),_vm._v(" "),_c('div',{staticClass:"item-user"},[_c('div',{staticClass:"item-user-img right"},[_c('img',{attrs:{"src":item.author.avatar}})]),_vm._v(" "),_c('p',{staticClass:"right"},[_vm._v(_vm._s(item.author.userName))])])]),_vm._v(" "),_c('div',{staticClass:"item-right-b"},[_c('div',{staticClass:"item-comment"},[_c('span',[_vm._v("评论("+_vm._s(item.interaction.commentNum)+")")])]),_vm._v(" "),_c('div',{staticClass:"item-collect",on:{"click":function($event){return _vm.removeCollect(item.property.id)}}},[_c('div',{staticClass:"item-collect"},[_c('span',[_vm._v("收藏数("+_vm._s(item.interaction.collectNum)+")")])])]),_vm._v(" "),_c('div',{staticClass:"item-set-date"},[_c('span',[_vm._v("创建时间："+_vm._s(item.property.ctime))])])])])])})],2),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"own-discuss"},[_c('p',{staticClass:"own-discuss-title"},[_vm._v("我参与的讨论")]),_vm._v(" "),_c('div',{staticClass:"own-discuss-tabs"},[_c('ul',[_c('li',{staticClass:"item",class:{'active': _vm.discussTab === 1},on:{"click":function($event){_vm.discussTab = 1; _vm.receivePoint()}}},[_vm._v("收到的评论")]),_vm._v(" "),_c('li',{staticClass:"item",class:{'active': _vm.discussTab === 2},on:{"click":function($event){_vm.discussTab = 2; _vm.sendPoint()}}},[_vm._v("发出的评论")])])]),_vm._v(" "),(_vm.userId)?_c('div',{staticClass:"own-discuss-list"},[_c('receive-discuss',{directives:[{name:"show",rawName:"v-show",value:(_vm.discussTab === 1),expression:"discussTab === 1"}]}),_vm._v(" "),_c('send-discuss',{directives:[{name:"show",rawName:"v-show",value:(_vm.discussTab === 2),expression:"discussTab === 2"}]})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sj4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formValidation_js__ = __webpack_require__("AdV3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            logictext: '',
            titletext: '',
            tagtext: '',
            isSaveLoading: false,
            backtestClass: true,
            labelTen: false,
            labelSixteen: false,
            issavebindtel: false
        };
    },

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        backtestId: {
            type: String,
            default: ''
        },
        isPublish: {
            type: Number,
            default: 0
        }
    },
    watch: {
        visible: function visible(val) {
            if (val) {
                this.logictext = '';
                this.titletext = '';
                this.tagtext = '';
            }
        }
    },
    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.strategyBacktest.releaseBacktestReport;
        }
    },
    methods: {
        labelDataValidation: function labelDataValidation(even) {
            // window.TA.log(this.buriedPoint.modifyLabel)
            var val = even.value;
            switch (Object(__WEBPACK_IMPORTED_MODULE_1__lib_formValidation_js__["a" /* labelVal */])(val)) {
                case 1:
                    this.labelTen = true;
                    this.labelSixteen = false;
                    this.backtestClass = true;
                    even.focus();
                    even.className = 'focus';
                    break;
                case 2:
                    this.labelSixteen = true;
                    this.backtestClass = true;
                    even.focus();
                    even.className = 'focus';
                    break;
                default:
                    this.labelTen = false;
                    this.labelSixteen = false;
                    // this.backtestClass = false
                    if (this.titletext.length < 5) {
                        this.backtestClass = true;
                    } else {
                        this.backtestClass = false;
                    }
                    even.className = '';
            }
        },
        limitinput: function limitinput(num) {
            // if (num === 0) {
            //     window.TA.log(this.buriedPoint.modifyName)
            // }
            if (this.titletext.length > 15) {
                this.titletext = this.titletext.substr(0, 15);
            }
            if (this.titletext.length < 5) {
                this.backtestClass = true;
            } else {
                this.backtestClass = false;
            }
        },
        limitarea: function limitarea(num) {
            // if (num === 0) {
            //     window.TA.log(this.buriedPoint.modifyLogic)
            // }
            if (this.logictext.length > 200) {
                this.logictext = this.logictext.substr(0, 200);
            }
        },
        close: function close() {
            this.$emit('update:visible', false);
        },

        // publish: 0-保存回测 1-发布回测
        saveBacktest: function saveBacktest(publish) {
            var self = this;
            if (!this.backtestClass) {
                if (this.isSaveLoading) {
                    return;
                }
                var requestData = { id: this.backtestId };
                requestData['title'] = this.titletext;
                requestData['logic'] = this.logictext;
                requestData['tag'] = this.tagtext;
                if (publish === 1) {
                    window.TA.log(this.buriedPoint.saveDraft);
                    requestData['is_publish'] = 1;
                    this.isSaveLoading = true;
                } else {
                    window.TA.log(this.buriedPoint.releaseStrategy);
                    requestData['is_publish'] = 2;
                }
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tradebacktest/save', requestData).then(function (res) {
                    self.isSaveLoading = false;
                    var response = res.data;
                    if (res) {
                        if (response.errorcode !== 0 && response.errorcode !== -99) {
                            self.$tip({ message: response.errormsg ? response.errormsg : '操作失败', duration: 2000, type: 'error' });
                        } else if (response.errorcode === -99) {
                            self.issavebindtel = true;
                        } else {
                            self.$store.dispatch('myStrategy/requestTradeBacktest');
                            self.$tip({ message: publish ? '提交成功！正在审核中' : '保存成功', duration: 2000, type: 'success' });
                            self.close();
                            self.$emit('update:isPublish', requestData['is_publish']);
                        }
                    }
                }).catch(function (error) {
                    self.isSaveLoading = false;
                    self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                });
            }
        }
    }
});

/***/ }),

/***/ "T+OU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T3Wr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'receive-discuss',
    mounted: function mounted() {
        this.updateList();
    },

    props: {
        pid: {
            type: Number,
            required: true
        },
        sid: {
            type: Number,
            required: true
        }
    },
    computed: {
        discussDataList: function discussDataList() {
            return this.discussResult.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
        }
    },
    data: function data() {
        return {
            discussResult: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            inputDiscuss: '',
            bereplyDiscuss: '',
            isdiscusscontent: false,
            isbereplycontent: false,
            clickIndex: -1,
            bereplyIndex: -1,
            countIndex: -1,
            reportIndex: -1,
            numIndex: -1
        };
    },

    methods: {
        commentLikes: function commentLikes(pid, cid, item) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/commentlikes', { params: {
                    pid: pid,
                    cid: cid
                } }).then(function (res) {
                if (!res.data.result) {
                    self.$tip({
                        message: res.data.errormsg ? res.data.errormsg.toString() : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                } else {
                    self.$tip({
                        message: '点赞成功',
                        duration: 2000,
                        type: 'success'
                    });
                    item.likes += 1;
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        commentReport: function commentReport(pid, cid, userid) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/commentreport', { params: {
                    pid: pid,
                    userid: userid,
                    cid: cid
                } }).then(function (res) {
                if (!res.data.errorcode) {
                    self.$tip({
                        message: res.data.errormsg ? res.data.errormsg.toString() : '举报成功，后台审核中',
                        duration: 2000,
                        type: 'success'
                    });
                } else {
                    self.$tip({
                        message: '举报失败，请稍后再试',
                        duration: 2000,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        changeInput: function changeInput() {
            if (!this.inputDiscuss) {
                this.isdiscusscontent = false;
            } else {
                this.isdiscusscontent = true;
            }
        },
        bereplyInput: function bereplyInput() {
            if (!this.bereplyDiscuss) {
                this.isbereplycontent = false;
            } else {
                this.isbereplycontent = true;
            }
        },
        isShowInputDiscuss: function isShowInputDiscuss(index) {
            if (this.clickIndex === index) {
                this.clickIndex = -1;
            } else {
                this.clickIndex = index;
                this.inputDiscuss = '';
            }
        },
        isShowInputBereply: function isShowInputBereply(num, index) {
            if (this.bereplyIndex === num) {
                this.bereplyIndex = -1;
                this.countIndex = -1;
            } else {
                this.bereplyIndex = num;
                this.countIndex = index;
                this.bereplyDiscuss = '';
            }
        },
        goPage: function goPage(page) {
            this.currentPage = page;
        },
        enter: function enter(num, index) {
            if (this.reportIndex === num) {
                this.reportIndex = -1;
                this.numIndex = -1;
            } else {
                this.reportIndex = num;
                this.numIndex = index;
            }
        },
        submitDiscuss: function submitDiscuss(pid, userid, cid, item) {
            var self = this;
            if (!this.inputDiscuss) {
                self.$tip({
                    message: '回复内容不能为空',
                    duration: 2000,
                    type: 'error'
                });
            } else {
                window.TA.log(this.$buriedPoint.strategyDetails.strategyDiscuss.reply.replace('_square', '_square_' + this.strategyId));
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/sns/addcomment', {
                    pid: pid,
                    receiver_id: userid,
                    rid: cid,
                    content: this.inputDiscuss
                }).then(function (res) {
                    if (!res.data.result) {
                        self.$tip({
                            message: '回复失败，请稍后再试',
                            duration: 2000,
                            type: 'error'
                        });
                        self.inputDiscuss = '';
                    } else {
                        self.$tip({
                            message: '回复内容正在后台审核中',
                            duration: 2000,
                            type: 'success'
                        });
                        self.inputDiscuss = '';
                        self.$store.dispatch('myStrategy/requestSendDiscuss');
                    }
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                    self.inputDiscuss = '';
                });
            }
        },
        submitBereply: function submitBereply(pid, userid, cid, item) {
            var self = this;
            if (!this.bereplyDiscuss) {
                self.$tip({
                    message: '回复内容不能为空',
                    duration: 2000,
                    type: 'error'
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/sns/addcomment', {
                    pid: pid,
                    receiver_id: userid,
                    rid: cid,
                    content: this.bereplyDiscuss
                }).then(function (res) {
                    if (!res.data.result) {
                        self.$tip({
                            message: '回复失败，请稍后再试',
                            duration: 2000,
                            type: 'error'
                        });
                        self.bereplyDiscuss = '';
                    } else {
                        self.$tip({
                            message: '回复内容正在后台审核中',
                            duration: 2000,
                            type: 'success'
                        });
                        self.bereplyDiscuss = '';
                        self.$store.dispatch('myStrategy/requestSendDiscuss');
                    }
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                    self.bereplyDiscuss = '';
                });
            }
        },
        updateList: function updateList() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/sns/querycommentbypid', { params: {
                    sid: this.sid,
                    pid: this.pid,
                    page: this.currentPage,
                    pagesize: -1 // all
                } }).then(function (res) {
                if (res) {
                    if (res.data.errorcode === 0) {
                        self.discussResult = res.data.result;
                        self.total = self.discussResult.length;
                        self.currentPage = 1;
                    }
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        }
    },
    watch: {
        pid: function pid() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "TAD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__("tRtx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702244f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__("dj+g");
function injectStyle (ssrContext) {
  __webpack_require__("yUH/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-702244f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702244f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TSZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lib_confirm__ = __webpack_require__("Na95");
// @charset "utf-8"



// import { PopupManager } from 'element-ui/src/utils/popup'
// import { isVNode } from 'element-ui/src/utils/vdom',
var ConfirmConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_1__components_lib_confirm__["a" /* default */]);

var instance;
var instances = [];
var seed = 1;

var Confirm = function Confirm(options) {
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$isServer) {
        return;
    }
    options = options || {};
    if (typeof options === 'string') {
        options = {
            tip: options
        };
    }
    var userOnClose = options.onClose;
    var id = 'confirm_' + seed++;

    options.onClose = function () {
        Confirm.close(id, userOnClose);
    };
    instance = new ConfirmConstructor({
        data: options
    });
    instance.id = id;
    // if (isVNode(instance.tip)) {
    //   instance.$slots.default = [instance.tip]
    //   instance.tip = null
    // }
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.vm.visible = true;
    instance.dom = instance.vm.$el;
    // instance.dom.style.zIndex = PopupManager.nextZIndex()
    instances.push(instance);
    return instance.vm;
};

Confirm.close = function (id, userOnClose) {
    for (var i = 0, len = instances.length; i < len; i++) {
        if (id === instances[i].id) {
            if (typeof userOnClose === 'function') {
                userOnClose(instances[i]);
            }
            instances.splice(i, 1);
            break;
        }
    }
};

Confirm.closeAll = function () {
    for (var i = instances.length - 1; i >= 0; i--) {
        instances[i].close();
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Confirm);

/***/ }),

/***/ "U95Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receive_discuss_vue__ = __webpack_require__("7WqP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ff0f8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receive_discuss_vue__ = __webpack_require__("zOTn");
function injectStyle (ssrContext) {
  __webpack_require__("tbID")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47ff0f8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receive_discuss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ff0f8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receive_discuss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U9rU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"big-heart"},[_c('ul',{staticClass:"left-tabs"},[_vm._m(0),_vm._v(" "),_c('router-link',{attrs:{"to":"/backtest"}},[_c('li',{class:_vm.$route.path.indexOf('/backtest') >= 0 ? 'active' : 'active_false'},[_vm._v("回测一下")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/strategybacktest"}},[_c('li',{class:_vm.$route.path.indexOf('/strategybacktest') >= 0 ? 'active' : 'active_false'},[_vm._v("策略回测")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/strategysquare"}},[_c('li',{class:_vm.$route.path.indexOf('/strategysquare') >= 0 ? 'active' : 'active_false'},[_vm._v("策略广场")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/eventevaluation"}},[_c('li',{class:_vm.$route.path.indexOf('/eventevaluation') >= 0 ? 'active' : 'active_false'},[_vm._v("事件评测")])])],1),_vm._v(" "),_c('ul',{staticClass:"right-tabs"},[_c('router-link',{attrs:{"to":"/mystrategy"}},[_c('li',{class:_vm.$route.path.indexOf('/mystrategy') >= 0 ? 'active' : 'active_false'},[_c('span'),_vm._v("我的策略")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/"}},[_c('li',[_vm._v("首页")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UBWs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V9Hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-discuss"},[_c('div',{staticClass:"discuss-list"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult),expression:"isSearchResult"}]},[_vm._v("你还没有发表任何评论")]),_vm._v(" "),_c('vue-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowloading),expression:"isshowloading"}],staticStyle:{"height":"calc(100% - 20px)","border":"none","top":"0","left":"0"}}),_vm._v(" "),_vm._l((_vm.discussDataList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearchResult && !_vm.isshowloading),expression:"!isSearchResult && !isshowloading"}],key:index,staticClass:"list-item"},[_c('div',{staticClass:"item-left"},[_c('img',{attrs:{"src":item.my_avatar}})]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.mine))]),_vm._v(" "),_c('div',{staticClass:"item-mix"},[_c('span',[_vm._v(_vm._s(item.ctime))]),_vm._v(" "),_c('span',{staticClass:"item-like"},[_vm._v("赞同("+_vm._s(item.likes)+")")])])])])})],2),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VWE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

// @charset "utf-8"


var state = {
    pool: []
};

var getters = {
    logoSeries: function logoSeries(state) {
        return function (fundId) {
            var result = state.pool.find(function (serie) {
                return Number(serie.fundId) === Number(fundId);
            });
            if (!result) {
                return false;
            }
            return result.series;
        };
    }
};

var mutations = {
    updatePool: function updatePool(state, data) {
        var poolIdx = state.pool.findIndex(function (serie) {
            return Number(serie.fundId) === Number(data.fundId);
        });
        if (poolIdx === -1) {
            state.pool.push(data);
        } else {
            state.pool[poolIdx] = data;
        }
    }
};

var actions = {
    requestSeries: function requestSeries(context, fundId) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/robot/robot/queryprofitrate/?fund_id=' + fundId).then(function (response) {
            // 判断http状态
            return response.data;
        }).then(function (data) {
            // 判断errorcode
            return data.result;
        }).then(function (result) {
            var series = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).forEach(function (date) {
                series.push([Number(date), Number(result[date][0])]);
            });
            context.commit('updatePool', { fundId: fundId, series: series });
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "Vv6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode_main",on:{"mouseover":function($event){_vm.isShow = true},"mouseout":function($event){_vm.isShow = false}}},[_c('div',{staticClass:"qrcode_main_trans"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShow),expression:"!isShow"}],staticClass:"qrcode_main_icon"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"qrcode_main_text"},[_vm._v("加入"),_c('br'),_vm._v("群聊")])]),_vm._v(" "),_c('div',{staticClass:"qrcode_main_placeholder"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"qrcode_main_img"},[_vm._v("扫一扫加入官方QQ群")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W1k5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_resize_event__ = __webpack_require__("k4bk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__("6ub1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scrollbar_width__ = __webpack_require__("bKVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bar__ = __webpack_require__("iIOJ");

//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EasyScrollbar',
  components: { Bar: __WEBPACK_IMPORTED_MODULE_4__bar__["a" /* default */] },
  props: {
    native: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    },
    barOption: {}
  },
  created: function created() {
    this._data.opt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this._data.opt, this.barOption);
  },
  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0,
      preScrollHeigt: 0,
      opt: {
        barColor: "#959595", //滚动条颜色
        barWidth: 6, //滚动条宽度
        railColor: "#eee", //导轨颜色
        barMarginRight: 0, //垂直滚动条距离整个容器右侧距离单位（px）
        barMaginBottom: 0, //水平滚动条距离底部距离单位（px)
        barOpacityMin: 0.3, //滚动条非激活状态下的透明度
        zIndex: "auto", //滚动条z-Index
        autohidemode: true, //自动隐藏模式
        horizrailenabled: true //是否显示水平滚动条
      }
    };
  },


  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },
  render: function render(h) {
    var gutter = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scrollbar_width__["a" /* default */])();
    var style = this.wrapStyle;
    var barStyle = { color: this.opt.barColor, width: this.opt.barWidth + "px", barOpacityMin: this.opt.barOpacityMin };
    var railStyle = { zIndex: this.opt.zIndex, color: this.opt.railColor, marginRight: this.opt.barMarginRight + "px", marginBottom: this.opt.barMaginBottom + "px" };
    if (gutter) {
      var gutterWith = "-" + gutter + "px";
      var gutterStyle = "margin-bottom:" + gutterWith + ";" + " margin-right:" + gutterWith;

      if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    var view = h(this.tag, {
      class: ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots.default);
    var wrap = h(
      'div',
      {
        ref: 'wrap',
        style: style,
        on: {
          'scroll': this.handleScroll,
          'mouseenter': this.handleMouseEnter,
          'mouseleave': this.handleMouseLeave
        },

        'class': [this.wrapClass, 'easy-scrollbar__wrap', gutter ? '' : 'easy-scrollbar__wrap--hidden-default'] },
      [[view]]
    );
    var nodes = void 0;

    if (!this.native) {
      if (this.opt.horizrailenabled == true) {
        //水平滚动条使能
        nodes = [wrap, h(__WEBPACK_IMPORTED_MODULE_4__bar__["a" /* default */], {
          ref: 'refHBar',
          attrs: { barStyle: barStyle,
            railStyle: railStyle,
            move: this.moveX,
            size: this.sizeWidth }
        }), h(__WEBPACK_IMPORTED_MODULE_4__bar__["a" /* default */], {
          ref: 'refVBar',
          attrs: { vertical: true,
            barStyle: barStyle,
            railStyle: railStyle,
            move: this.moveY,
            size: this.sizeHeight }
        })];
      } else {
        //隐藏水平滚动条
        nodes = [wrap, h(__WEBPACK_IMPORTED_MODULE_4__bar__["a" /* default */], {
          ref: 'refVBar',
          attrs: { vertical: true,
            barStyle: barStyle,
            railStyle: railStyle,
            move: this.moveY,
            size: this.sizeHeight }
        })];
      }
    } else {
      //原生的滚动条
      nodes = [h(
        'div',
        {
          ref: 'wrap',
          'class': [this.wrapClass, 'easy-scrollbar__wrap'],
          style: style },
        [[view]]
      )];
    }
    return h('div', { class: 'easy-scrollbar' }, nodes);
  },


  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;
      if (this.preScrollHeigt !== wrap.scrollHeight) {
        this.preScrollHeigt = wrap.scrollHeight;
        this.update();
      }
      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
    },

    handleMouseEnter: function handleMouseEnter() {
      if (this.$refs.refHBar) {
        this.$refs.refHBar.$el.children[0].style.opacity = 1;
      }
      if (this.$refs.refVBar) {
        this.$refs.refVBar.$el.children[0].style.opacity = 1;
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      if (this.$refs.refHBar) {
        this.$refs.refHBar.$el.children[0].style.opacity = this.opt.barOpacityMin;
      }
      if (this.$refs.refVBar) {
        this.$refs.refVBar.$el.children[0].style.opacity = this.opt.barOpacityMin;
      }
    },
    update: function update() {
      var heightPercentage = void 0,
          widthPercentage = void 0;
      var wrap = this.wrap;
      if (!wrap) return;
      debugger;
      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
      if (this.$refs.refVBar) {
        if (this.sizeHeight == 0) {
          this.$refs.refVBar.$el.style.display = "none";
        } else {
          this.$refs.refVBar.$el.style.display = "block";
        }
      }
      if (this.$refs.refHBar) {
        //存在水平滚动条的情况下
        if (this.sizeWidth == 0) {
          this.$refs.refHBar.$el.style.display = "none";
        } else {
          this.$refs.refHBar.$el.style.display = "block";
        }
      }
    }
  },

  mounted: function mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && Object(__WEBPACK_IMPORTED_MODULE_1__utils_resize_event__["a" /* addResizeListener */])(this.$refs.resize, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.native) return;
    !this.noresize && Object(__WEBPACK_IMPORTED_MODULE_1__utils_resize_event__["b" /* removeResizeListener */])(this.$refs.resize, this.update);
  }
});

/***/ }),

/***/ "WTOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__item_row__ = __webpack_require__("mbt3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'strategysquare',
    components: {
        itemRow: __WEBPACK_IMPORTED_MODULE_1__item_row__["a" /* default */]
    },
    data: function data() {
        return {
            pageSize: 10,
            currentPage: 1,
            total: 0,
            tradeStraKeyWord: '',
            sortSelect: '',
            sortSelectList: [{ text: '热度', value: 'hot' }, { text: '年化收益', value: 'profit' }, { text: '成功率', value: 'winRate' }, { text: '最新', value: 'createTime' }, { text: '本月收益', value: 'gain' }],
            strategyDataList: [],
            loading: false,
            resetStock: false
        };
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.updateList();
        });
    },

    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.strategySquare;
        },
        totalPoint: function totalPoint() {
            return this.$buriedPoint.totalPlatformAccess;
        }
    },
    methods: {
        updateSort: function updateSort() {
            window.TA.log(this.buriedPoint.sort[this.sortSelect]);
            this.resetStock = !this.resetStock;
            this.updateList();
        },
        updateSearch: function updateSearch() {
            window.TA.log(this.buriedPoint.search);
            this.updateList();
        },
        updateList: function updateList() {
            this.loading = true;
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/strategysquare/list?order=desc', { params: {
                    page: this.currentPage,
                    pageNum: this.pageSize,
                    sortType: this.sortSelect,
                    keyword: this.tradeStraKeyWord
                }
            }).then(function (res) {
                self.loading = false;
                self.total = res.data.result.num;
                return res.data.result.list;
            }).then(function (data) {
                self.strategyDataList = data;
            }).catch(function (error) {
                self.loading = false;
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        goPage: function goPage(page) {
            // window.TA.log(this.buriedPoint.goPage)
            this.currentPage = page;
        }
        // __scrollBar__ () {
        //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
        //         window.TA.log(this.buriedPoint.scrollBar)
        //     }
        // }

    },
    created: function created() {
        if (this.sortSelect === '') {
            this.sortSelect = this.sortSelectList[0].value;
        }
    },
    beforeDestroy: function beforeDestroy() {
        // window.removeEventListener('scroll', this.__scrollBar__)
    },
    mounted: function mounted() {
        var self = this;
        // window.addEventListener('scroll', self.__scrollBar__)
        window.TA.log({ id: self.buriedPoint.pageAccess, _sid: '__ths_001' });
        // window.TA.log({id: self.totalPoint, _sid: '__ths_002'})
    },

    watch: {
        currentPage: function currentPage() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "X7eQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            noticeList: ['1. 根据涨跌幅和上涨概率判断可以持有多久。', '2. 当上涨概率不高时，可以参考盈亏比。'],
            myBarOption: {
                // barColor: '#f60', // 滚动条颜色
                barWidth: 9, // 滚动条宽度
                // railColor: '#f5f5f5', // 导航颜色
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                // zIndex: 'auto', // 滚动条的z-index
                // autohidemode: true, // 自动隐藏模式
                horizrailenabled: false // 是否显示水平滚动条
            }
        };
    },

    computed: {
        maxAnnualyieldDay: function maxAnnualyieldDay() {
            if (this.maxAnnualyield.length !== 0) {
                return this.transactiontype === '1' ? this.maxAnnualyield[1] : this.maxAnnualyield[2];
            }
        },
        maxWinrateDay: function maxWinrateDay() {
            if (this.maxWinrate.length !== 0) {
                return this.transactiontype === '1' ? this.maxWinrate[1] : this.maxWinrate[2];
            }
        }
    },
    props: {
        backtestData: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        },
        transactiontype: String,
        signalData: Object,
        maxWinrate: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        },
        maxAnnualyield: {
            type: [Array, Object],
            default: function _default() {
                return [];
            }
        }
    },
    methods: {
        trBorderClass: function trBorderClass(signal, day, isLast) {
            if (this.isRecommend(signal, day)) {
                return 'blue';
            } else if (isLast) {
                return 'thin-blue';
            } else {
                return '';
            }
        },
        tdBorderClass: function tdBorderClass(signal, day) {
            return this.isRecommend(signal, day) ? 'recommend' : 'transparent';
        },
        isRecommend: function isRecommend(signal, day) {
            return signal === this.maxWinrate[1] && day === this.maxWinrateDay || signal === this.maxAnnualyield[1] && day === this.maxAnnualyieldDay;
        }
    }
});

/***/ }),

/***/ "YHT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'send-discuss',
    mounted: function mounted() {
        this.updateList();
    },
    data: function data() {
        return {
            currentPage: 1,
            pageSize: 10,
            isshowloading: false,
            isSearchResult: false
        };
    },

    computed: {
        sendDiscussData: function sendDiscussData() {
            return this.$store.getters['myStrategy/sendDiscussData'];
        },
        discussDataList: function discussDataList() {
            return this.sendDiscussData.list;
        },
        total: function total() {
            return this.sendDiscussData.total;
        }
    },
    methods: {
        goPage: function goPage(page) {
            this.currentPage = page;
        },
        updateList: function updateList() {
            var self = this;
            this.isshowloading = true;
            this.$store.dispatch('myStrategy/requestSendDiscuss', {
                page: this.currentPage,
                pagesize: this.pageSize
            }).then(function (result) {
                self.isshowloading = false;
                if (self.discussDataList.length === 0) {
                    self.isSearchResult = true;
                } else {
                    self.isSearchResult = false;
                }
            }).catch(function (error) {
                self.isshowloading = false;
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        }
    },
    watch: {
        currentPage: function currentPage() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_backtest__ = __webpack_require__("AfG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_strategybacktest__ = __webpack_require__("eNfU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_strategysquare__ = __webpack_require__("wn+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_eventevaluation__ = __webpack_require__("kIsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mystrategy__ = __webpack_require__("531N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_strategysquare_strategydetail__ = __webpack_require__("xpcf");
// @charset "utf-8";


// import home from '@/components/home'







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [
    // 首页
    // {
    //     path: '/',
    //     name: 'home',
    //     component: home
    // },
    {
        path: '/backtest',
        name: 'backtest',
        component: __WEBPACK_IMPORTED_MODULE_2__components_backtest__["a" /* default */],
        meta: {
            keepAlive: true
        }
    }, {
        path: '/strategybacktest',
        name: 'strategybacktest',
        component: __WEBPACK_IMPORTED_MODULE_3__components_strategybacktest__["a" /* default */],
        meta: {
            keepAlive: true
        }
    }, {
        path: '/strategysquare',
        name: 'strategysquare',
        component: __WEBPACK_IMPORTED_MODULE_4__components_strategysquare__["a" /* default */],
        meta: {
            keepAlive: true
        }
    }, {
        path: '/strategysquare/:id',
        name: 'strategydetail',
        component: __WEBPACK_IMPORTED_MODULE_7__components_strategysquare_strategydetail__["a" /* default */]
    }, {
        path: '/eventevaluation',
        name: 'eventevaluation',
        component: __WEBPACK_IMPORTED_MODULE_5__components_eventevaluation__["a" /* default */],
        meta: {
            keepAlive: true
        }
    }, {
        path: '/mystrategy',
        name: 'mystrategy',
        component: __WEBPACK_IMPORTED_MODULE_6__components_mystrategy__["a" /* default */],
        meta: {
            keepAlive: true
        }
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.path === '/') {
        window.location = '/';
        next(false);
    }
    if (to.path.indexOf('/pickresult') >= 0) {
        next(false);
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$Bus.$emit('pickresult', to.path.substring(12));
    } else {
        next();
    }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yg3b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ys1f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z4s2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategy_backtest_vue__ = __webpack_require__("6M7N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b456404_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategy_backtest_vue__ = __webpack_require__("eGe1");
function injectStyle (ssrContext) {
  __webpack_require__("gcrr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b456404"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategy_backtest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b456404_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategy_backtest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z8My":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZMMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart__ = __webpack_require__("c5dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__history__ = __webpack_require__("tbC+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_wDatePicker_js__ = __webpack_require__("RarY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__backtest_base__ = __webpack_require__("FZS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-new */







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'backtest',
    mixins: [__WEBPACK_IMPORTED_MODULE_8__backtest_base__["a" /* default */]],
    components: {
        'change-rate-group': __WEBPACK_IMPORTED_MODULE_5__chart__["a" /* default */],
        'history-detail': __WEBPACK_IMPORTED_MODULE_6__history__["a" /* default */]
    },
    data: function data() {
        var yesDate = this._getNowDate();
        var self = this;
        var debounceQuestion = Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["debounce"])(function () {
            self.questionDataValidation.apply(self, arguments);
        }, 500);

        var debounceBenchmark = Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["debounce"])(function () {
            self.benchmarkDataValidation.apply(self, arguments);
        }, 500);
        return {
            debounceQuestion: debounceQuestion,
            debounceBenchmark: debounceBenchmark,
            benchmarkListVisible: false,
            myBarOption: {
                // barColor: '#f60', // 滚动条颜色
                barWidth: 9, // 滚动条宽度
                // railColor: '#f5f5f5', // 导航颜色
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                // zIndex: 'auto', // 滚动条的z-index
                // autohidemode: true, // 自动隐藏模式
                horizrailenabled: false // 是否显示水平滚动条
            },
            backtestId: '',
            backtestCompleted: false,
            operateLoading: false,
            tradeStartDate: '',
            tradeEndDate: '',
            benchmark: '399300 沪深300',
            sentence: '',
            number: '',
            yesterdayDate: yesDate,
            isintroduceshow: false,
            issave: true,
            loadingText: '正在为您计算，请耐心等待……',
            textPool: {
                backtest: '正在为您计算，请耐心等待……',
                save: '回测保存中……',
                cancel: '回测取消保存中……'
            },
            alreadysave: '已保存',
            hotbacktest: [],
            conditions: [],
            reportData: {},
            backtestData: [],
            defaultParams: {},
            refresh: false,
            paramKeys: {
                query: 'sentence',
                daysForSaleStrategy: 'number',
                startDate: 'tradeStartDate',
                endDate: 'tradeEndDate',
                benchmark: 'benchmark'
            },
            defaultqueryLoading: true,
            noticeList: ['1. 根据涨跌幅和上涨概率判断可以持有多久。', '2. 当上涨概率不高时，可以参考盈亏比。 ']
        };
    },

    computed: {
        benchmarkCode: function benchmarkCode() {
            return this.benchmark.split(' ')[0];
        },
        hotbacktestList: function hotbacktestList() {
            var list = [];
            this.hotbacktest.forEach(function (item) {
                list.push(item.query);
            });
            return list;
        },
        lefthot: function lefthot() {
            return this.hotbacktest.slice(0, 3);
        },
        righthot: function righthot() {
            return this.hotbacktest.slice(3, 6);
        },
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.backtestOnce;
        },
        totalPoint: function totalPoint() {
            return this.$buriedPoint.totalPlatformAccess;
        },

        dayselect: function dayselect() {
            var arraySet = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(this.number.split(','));
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arraySet);
        },
        staticText: function staticText() {
            return this.$staticText.backtest.index;
        },
        showClear: function showClear() {
            return this.sentence.length > 0;
        },
        buttonText: function buttonText() {
            return this.operateLoading ? this.staticText.loadingButton : this.backtestCompleted ? this.staticText.restartButton : this.staticText.beginButton;
        }
    },
    methods: {
        validateInput: function validateInput() {
            this.number = this.number.replace(/，/, ',');
        },
        standardDate: function standardDate(date) {
            if (date === undefined) {
                return '--';
            }
            if (date.indexOf('-') < 0) {
                return String(date).substring(0, 4) + '-' + String(date).substring(4, 6) + '-' + String(date).substring(6);
            }
            return date;
        },
        buriedPoints: function buriedPoints() {
            window.TA.log({ id: this.buriedPoint.hotBacktest, _sid: '__ths_003' });
        },
        startDatePoint: function startDatePoint() {
            window.TA.log(this.buriedPoint.strategyParam.startDate);
        },
        endDatePoint: function endDatePoint() {
            window.TA.log(this.buriedPoint.strategyParam.endDate);
        },
        questionCyclePoint: function questionCyclePoint() {
            window.TA.log(this.buriedPoint.strategyParam.holdingCycle);
        },
        questionDataValidation: function questionDataValidation(event, num) {
            var val = event.target.value;
            if (val === '') {
                this.searchList = this.hotbacktestList;
                this.searchVis = true;
                return;
            }
            if (this.sentence.length > 200) {
                this.sentence = val.substr(0, 200);
            }
            if (num === 0) {
                window.TA.log(this.buriedPoint.strategyParam.modifyQuestion);
            } else {
                if (this.filterKey.indexOf(event.keyCode) > -1) {
                    return;
                }
                var self = this;
                var lastStr = this.sentence[this.sentence.length - 1];
                if (this.chunkSeparator.indexOf(lastStr) > -1) {
                    // chunk
                    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/chunk/search?query=' + this.sentence).then(function (res) {
                        if (res) {
                            if (res.data.errorcode === 0) {
                                var list = [];
                                res.data.result.forEach(function (item) {
                                    list.push(self.sentence + item);
                                });
                                self.searchList = list;
                                self.searchVis = self.searchList.length !== 0;
                                self.defaultSentence = self.sentence;
                            } else {
                                self.searchVis = false;
                                self.searchList = [];
                            }
                        }
                    }).catch(function (error) {
                        self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/chunk/searchdataextract?query=' + this.sentence).then(function (res) {
                        if (res) {
                            if (res.data.errorcode === 0) {
                                self.searchList = res.data.result;
                                self.searchVis = self.searchList.length !== 0;
                                self.defaultSentence = self.sentence;
                            } else {
                                self.searchVis = false;
                                self.searchList = [];
                            }
                        }
                    }).catch(function (error) {
                        self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                    });
                }
            }
        },
        benchmarkDataValidation: function benchmarkDataValidation(event) {
            var _this = this;

            var self = this;
            if (!this.benchmark) {
                return false;
            } else {
                if (this.filterKey.indexOf(event.keyCode) > -1) {
                    return;
                }

                this.requestSpellSearch().then(function (data) {
                    _this.benchmarkList = data.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { label: _this.parseItem(item) });
                    });
                    if (_this.benchmarkList.length === 0) {
                        _this.benchmarkListVisible = false;
                    } else {
                        _this.benchmarkListVisible = true;
                    }

                    _this.defaultBenchmark = _this.benchmark;
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            }
        },
        parseItem: function parseItem(item) {
            return item.code + ' ' + item.name;
        },
        hideBenchmarkList: function hideBenchmarkList() {
            this.benchmarkListVisible = false;
        },
        benchmarkNochecked: function benchmarkNochecked() {
            this.benchmark = this.defaultBenchmark;
        },
        updateBenchmarkInput: function updateBenchmarkInput(item) {
            this.benchmark = this.parseItem(item);
        },
        requestSpellSearch: function requestSpellSearch() {
            var spell = this.benchmarkCode;
            return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/eventbacktest/spellsearch?query=' + spell).then(function (res) {
                return res.data.result;
            });
        },

        _getNowDate: function _getNowDate() {
            var now = new Date();
            now.setDate(now.getDate() - 1); // 获取昨天时间
            var month = now.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
            var nowDate = now.getFullYear() + '-' + month + '-' + date;
            return nowDate;
        },
        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_7__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        empty: function empty() {
            this.sentence = '';
            document.getElementById('question_sentence_input').focus();
        },
        enter_1: function enter_1() {
            this.alreadysave = '取消保存';
        },
        leave_1: function leave_1() {
            this.alreadysave = '已保存';
        },
        sortNumber: function sortNumber(a, b) {
            return a - b;
        },

        startBacktest: function startBacktest() {
            var _this2 = this;

            if (this.searchVis) {
                this.searchVis = false;
                return;
            }

            if (this.benchmarkListVisible) {
                this.benchmarkListVisible = false;
                return;
            }

            var self = this;
            this.$nextTick(function () {
                if (!_this2.$refs.question_sentence_input.validate() || !_this2.$refs.question_benchmark.validate() || !_this2.$refs.question_cycle_input.validate()) {
                    return;
                }

                window.TA.log(_this2.buriedPoint.strategyParam.startUpBacktest);

                self.requestSpellSearch().then(function (data) {
                    if (data.length === 0) {
                        self.$tip({
                            message: '基准指数错误',
                            duration: 2000,
                            type: 'error'
                        });
                    } else {
                        _this2.defaultBenchmark = _this2.parseItem(data[0]);
                        _this2.benchmark = _this2.defaultBenchmark;
                        var indexCode = data[0]['code'];

                        self.operateLoading = true;
                        var numberArry = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(self.number.split(',').sort(self.sortNumber)));
                        self.number = numberArry.join(',');
                        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/backtestonce/backtest', {
                            query: self.sentence,
                            period: self.number,
                            start_date: self.tradeStartDate,
                            end_date: self.tradeEndDate,
                            benchmark: indexCode
                        }).then(function (res) {
                            if (res.data.errorcode !== 0) {
                                self.$tip({ message: res.data.errormsg ? res.data.errormsg : '网络异常', duration: 2000, type: 'error' });
                                self.operateLoading = false;
                                return false;
                            }
                            if (res.data.result.isSaved) {
                                self.issave = false;
                            } else {
                                self.issave = true;
                            }
                            self.operateLoading = false;
                            self.backtestId = res.data.result.id;
                            if (self.backtestId === res.data.result.id) {
                                self.refresh = !self.refresh;
                            }
                            self.conditions = res.data.result.conditionData;
                            self.reportData = res.data.result.reportData;
                            self.backtestData = res.data.result.backtestData;
                            self.backtestCompleted = true;
                            location.hash = '#/backtest?query=' + encodeURIComponent(self.sentence) + '&daysForSaleStrategy=' + self.number + '&startDate=' + self.tradeStartDate + '&endDate=' + self.tradeEndDate + '&benchmark=' + encodeURIComponent(self.benchmark);
                        }).catch(function (error) {
                            self.operateLoading = false;
                            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
                        });
                    }
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            });
        },
        save: function save() {
            var _this3 = this;

            window.TA.log(this.buriedPoint.backtestResult.save);
            if (this.operateLoading) {
                return;
            }
            this.loadingText = this.textPool.save;
            this.operateLoading = true;
            var self = this;
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/backtestonce/save', {
                id: this.backtestId
            }).then(function (res) {
                self.$store.dispatch('myStrategy/requestBacktestOnce');
                self.operateLoading = false;
                self.loadingText = self.textPool.backtest;
                if (res) {
                    if (res.data.errorcode === 0) {
                        _this3.issave = false;
                    }
                }
            }).catch(function (error) {
                self.operateLoading = false;
                self.loadingText = self.textPool.backtest;
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        },
        cancel: function cancel() {
            var _this4 = this;

            window.TA.log(this.buriedPoint.backtestResult.saveCancel);
            var self = this;
            if (this.operateLoading) {
                return;
            }
            this.loadingText = this.textPool.cancel;
            this.operateLoading = true;

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/backtestonce/cancelsave', {
                id: this.backtestId
            }).then(function (res) {
                self.$store.dispatch('myStrategy/requestBacktestOnce');
                self.operateLoading = false;
                self.loadingText = self.textPool.backtest;
                if (res) {
                    if (res.data.errorcode === 0) {
                        _this4.issave = true;
                    }
                }
            }).catch(function (error) {
                self.operateLoading = false;
                self.loadingText = self.textPool.backtest;
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        },
        initParams: function initParams() {
            if (this.defaultParams) {
                this.sentence = this.defaultParams.query;
                this.tradeStartDate = this.defaultParams.startDate;
                this.tradeEndDate = this.defaultParams.endDate;
                this.number = this.defaultParams.daysForSaleStrategy;
                // todo 后台设置
                this.benchmark = '399300 沪深300';
            } else {
                this.sentence = '';
                this.tradeStartDate = '';
                this.tradeEndDate = '';
                this.number = '';
                this.benchmark = '399300 沪深300';
            }
        },
        startBacktestByRoute: function startBacktestByRoute(routeParam) {
            var self = this;
            var hasChanged = false;
            for (var key in this.paramKeys) {
                if (routeParam.hasOwnProperty(key) && routeParam[key] !== '' && self[self.paramKeys[key]] !== routeParam[key]) {
                    self[self.paramKeys[key]] = routeParam[key];
                    hasChanged = true;
                }
            }

            if (!self.backtestCompleted || hasChanged) {
                this.startBacktest();
            }
        }
    },
    activated: function activated() {
        window.TA.log({ id: this.buriedPoint.pageAccess, _sid: '__ths_001' });
        window.TA.log({ id: this.totalPoint, _sid: '__ths_002' });
    },
    deactivated: function deactivated() {
        // 重置初始化状态
        this.backtestCompleted = false;
        this.operateLoading = false;
        this.isintroduceshow = false;

        this.$refs.sentenceNotice.style.display = 'none';
        this.$refs.benchmarkNotice.style.display = 'none';
        this.$refs.numberNotice.style.display = 'none';

        this.$refs.question_sentence_input.className = '';
        this.$refs.question_benchmark.className = '';
        this.$refs.question_cycle_input.className = '';

        this.initParams();
    },
    mounted: function mounted() {
        var _this5 = this;

        var self = this;
        self.defaultqueryLoading = true;
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/backtestonce/defaultquery').then(function (res) {
            self.defaultParams = res.data.result;
            self.initParams();
            self.defaultqueryLoading = false;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.$route.query) !== '{}') {
                self.startBacktestByRoute(self.$route.query);
            }
        }).catch(function (error) {
            self.defaultqueryLoading = false;
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/backtestonce/backtestexample?num=6').then(function (res) {
            _this5.hotbacktest = res.data.result;
        }).catch(function (error) {
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });
    },

    watch: {
        '$route': function $route(newRoute, oldRoute) {
            if (this.defaultqueryLoading) {
                return;
            }
            if (newRoute.name === 'backtest') {
                var params = newRoute.query;
                if (newRoute.name === oldRoute.name) {
                    this.startBacktestByRoute(params);
                } else {
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params) !== '{}') {
                        this.startBacktestByRoute(params);
                    }
                }
            }
        }
    }
});

/***/ }),

/***/ "ZQ0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cumulative_income"},[_c('div',{staticClass:"cumulative_income_title"},[_c('p',[_vm._v("累计收益图")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactiontype === '2'),expression:"transactiontype === '2'"}],staticClass:"distribution_chart_select"},[_c('p',[_vm._v("择时选项 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSignal),expression:"selectedSignal"}],staticClass:"chary_select",on:{"click":_vm.charySelect,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSignal=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.marketSignals),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(_vm.signalData[item]))])}),0)])]),_vm._v(" "),_c('cumulative-income',{attrs:{"default-selected-day":_vm.defaultSelectedDay,"profitdata":_vm.currentProfitData,"dayselect":_vm.daySelect,"HSData":_vm.hsData}}),_vm._v(" "),_c('div',{staticClass:"strategy_score"},[_c('p',[_vm._v("策略得分\n            "),_c('vue-notice-tip',{attrs:{"list":_vm.noticeList}})],1),_vm._v(" "),_c('score',{attrs:{"refresh":_vm.refresh,"scoreData":_vm.scoreData}})],1),_vm._v(" "),_c('p',{staticClass:"ranking"},[_vm._v("该策略在广场上的排名")]),_vm._v(" "),_c('div',{staticClass:"gradient"},[_c('p',{staticClass:"numranking",style:({left: Math.max(-5, Math.min(295 - ((_vm.scoreData.rank + '').length*0.587 + 2) * 12, _vm.posileft * 290 - ((_vm.scoreData.rank + '').length*0.587 + 2) * 6))+ 'px',  whiteSpace: 'nowrap'})},[_vm._v("第"+_vm._s(_vm.scoreData.rank)+"名")]),_vm._v(" "),_c('span',{staticClass:"rankingtri",style:({left: -5 + _vm.posileft * 290 + 'px'})})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZYGC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ze1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtest_analysis_vue__ = __webpack_require__("X7eQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29178036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtest_analysis_vue__ = __webpack_require__("8Nok");
function injectStyle (ssrContext) {
  __webpack_require__("HVf/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29178036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtest_analysis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29178036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtest_analysis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZusK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            visible: false
        };
    },

    props: {
        list: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    computed: {
        top: function top() {
            return -this.list.length * 20 - 44;
        }
    }
});

/***/ }),

/***/ "ZwxE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ac+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profit_chart_vue__ = __webpack_require__("1EXE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5558354_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profit_chart_vue__ = __webpack_require__("ZQ0k");
function injectStyle (ssrContext) {
  __webpack_require__("Q+5e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5558354"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profit_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5558354_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profit_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aif2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "axSx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c5dG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__ = __webpack_require__("9PKd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403e79fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__ = __webpack_require__("EX75");
function injectStyle (ssrContext) {
  __webpack_require__("luhk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-403e79fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403e79fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c71g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_key_list_vue__ = __webpack_require__("qocl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f04a05f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_key_list_vue__ = __webpack_require__("oX69");
function injectStyle (ssrContext) {
  __webpack_require__("wYTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f04a05f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_key_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f04a05f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_key_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cHTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__("6ub1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("c8l7");
//




/* istanbul ignore next */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Bar',

  props: {
    vertical: Boolean,
    size: String,
    move: Number,
    barStyle: Object,
    railStyle: Object
  },

  computed: {
    bar: function bar() {
      return __WEBPACK_IMPORTED_MODULE_1__util__["a" /* BAR_MAP */][this.vertical ? 'vertical' : 'horizontal'];
    },
    railStyles: function railStyles() {
      return this.vertical ? "background-color:" + this.railStyle.color + ";z-Index:" + this.railStyle.zIndex + ";width:" + this.barStyle.width + ";right:" + this.railStyle.marginRight : "background-color:" + this.railStyle.color + ";z-Index:" + this.railStyle.zIndex + ";height:" + this.barStyle.width + ";bottom:" + this.railStyle.marginBottom;
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },

  render: function render(h) {
    var size = this.size,
        move = this.move,
        bar = this.bar,
        barStyle = this.barStyle;

    return h(
      'div',
      {
        ref: 'railway',
        'class': ['esay-scrollbar__bar', 'is-' + bar.key],
        style: this.railStyles,
        on: {
          'mouseenter': this.handleRailMouseEnter,
          'mousedown': this.clickTrackHandler
        }
      },
      [h('div', {
        ref: 'thumb',
        'class': 'easy-scrollbar__thumb',
        on: {
          'mousedown': this.clickThumbHandler
        },

        style: Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* renderThumbStyle */])({ size: size, move: move, bar: bar, barStyle: barStyle }) })]
    );
  },


  methods: {
    clickThumbHandler: function clickThumbHandler(e) {
      this.startDrag(e);
      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },

    handleRailMouseEnter: function handleRailMouseEnter() {

      this.$refs.railway.children[0].style.opacity = 1;
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;

      Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* on */])(document, 'mousemove', this.mouseMoveDocumentHandler);
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["b" /* on */])(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.cursorDown === false) return;
      var prevPage = this[this.bar.axis];

      if (!prevPage) return;

      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* off */])(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    }
  },

  destroyed: function destroyed() {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["a" /* off */])(document, 'mouseup', this.mouseUpDocumentHandler);
  }
});

/***/ }),

/***/ "cO1D":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "cvfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.isNoShowForm),expression:"isNoShowForm"}],staticClass:"feedback_main"},[_c('div',{staticClass:"main_edit",on:{"click":function($event){$event.stopPropagation();return _vm.isShowForm.apply(null, arguments)},"mouseover":function($event){_vm.isTextShow = true},"mouseout":function($event){_vm.isTextShow = false}}},[_c('div',{staticClass:"main_edit_img"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTextShow),expression:"isTextShow"}],staticClass:"main_edit_text"},[_vm._v("提交"),_c('br'),_vm._v("反馈")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFormShow),expression:"isFormShow"}],staticClass:"main_form"},[_c('span',{staticClass:"form_close",on:{"click":function($event){_vm.isFormShow = false}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSendSpit),expression:"!isSendSpit"}]},[_c('div',{staticClass:"form_head"},[_c('p',[_vm._v("你想吐槽的原因是：")]),_vm._v(" "),_c('ul',_vm._l((_vm.spitBadList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.addContent(item)}}},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form_content"},[_c('p',[_vm._v("再说点什么")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formContent),expression:"formContent"}],ref:"form_content",attrs:{"placeholder":"使用中有哪些不爽啊，各种错误啊，马上反馈给我吧~","maxlength":"150"},domProps:{"value":(_vm.formContent)},on:{"keyup":_vm.formCheck,"blur":_vm.formCheck,"input":function($event){if($event.target.composing){ return; }_vm.formContent=$event.target.value}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isContentNotice),expression:"isContentNotice"}],staticClass:"form_notice"},[_vm._v("请尽量详细描述您的意见")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("limitlength")(_vm.formContent.length))+"/150")])]),_vm._v(" "),_c('div',{staticClass:"form_submit"},[_c('label',[_vm._v("\n                    联系方式："),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formTel),expression:"formTel"}],attrs:{"type":"text","placeholder":"留下您的联系方式，我们会及时答复您"},domProps:{"value":(_vm.formTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.formTel=$event.target.value}}})]),_vm._v(" "),_c('span',{on:{"click":_vm.submitSpit}},[_vm._v("提交")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSendSpit),expression:"isSendSpit"}],staticClass:"form_send"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "czPP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"release"},[_c('div',{staticClass:"releaseshadow"}),_vm._v(" "),_c('div',{staticClass:"releasemain"},[_c('div',{staticClass:"releasebox"},[_c('div',{staticClass:"release_title"},[_c('p',[_vm._v("发布回测报告")]),_vm._v(" "),_c('span',{on:{"click":_vm.close}})]),_vm._v(" "),_c('div',{staticClass:"release_main"},[_c('div',{staticClass:"report_name"},[_c('p',[_vm._v("报告名称 : ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.titletext.length === 0 ? '名称不能为空' : (_vm.titletext.length < 5 ? '名称不能少于5个字' : '')))]),_vm._v(" "),_c('p',[_vm._v("（不超过15字）")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.titletext),expression:"titletext",modifiers:{"trim":true}}],attrs:{"type":"text","maxlength":"15"},domProps:{"value":(_vm.titletext)},on:{"keyup":function($event){return _vm.limitinput(1)},"blur":[function($event){return _vm.limitinput(0)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.titletext=$event.target.value.trim()}}})]),_vm._v(" "),_c('div',{staticClass:"report_logical"},[_c('p',[_vm._v("逻辑说明 : ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("limitlength")(_vm.logictext.length))+"/200")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.logictext),expression:"logictext",modifiers:{"trim":true}}],attrs:{"maxlength":"200"},domProps:{"value":(_vm.logictext)},on:{"keyup":function($event){return _vm.limitarea(1)},"blur":[function($event){return _vm.limitarea(0)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.logictext=$event.target.value.trim()}}})]),_vm._v(" "),_c('div',{staticClass:"report_label"},[_c('p',[_vm._v("策略标签 : ")]),_vm._v(" "),_c('p',[_vm._v("示例：短线  平台突破  主力流入")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.labelTen),expression:"labelTen"}],staticClass:"label-tip"},[_vm._v("标签数不能超过十个")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.labelSixteen),expression:"labelSixteen"}],staticClass:"label-tip"},[_vm._v("单标签不能超过十六个字符")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.tagtext),expression:"tagtext",modifiers:{"trim":true}}],attrs:{"type":"text"},domProps:{"value":(_vm.tagtext)},on:{"blur":[function($event){return _vm.labelDataValidation($event.target)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.tagtext=$event.target.value.trim()}}})]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.issavebindtel),expression:"issavebindtel"}],staticClass:"save_bind_tel"},[_vm._v("发布失败，您的同花顺账户暂未绑定手机号码")]),_vm._v(" "),(_vm.isPublish !== 2 && _vm.isPublish !== 1)?_c('div',{staticClass:"save_draft",class:_vm.backtestClass ? 'disable' : '',on:{"click":function($event){return _vm.saveBacktest(0)}}},[_vm._v("保存草稿")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"release_strategy",class:_vm.backtestClass ? 'disable' : '',on:{"click":function($event){return _vm.saveBacktest(1)}}},[_vm._v(_vm._s(_vm.isSaveLoading ? '发布中' : '发布策略'))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "diAU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dj+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"loading-box"},[_c('img',{attrs:{"src":__webpack_require__("cO1D"),"alt":"加载中..."}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dy74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strategy_backtest__ = __webpack_require__("Z4s2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backtest_once__ = __webpack_require__("kOQh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__receive_discuss__ = __webpack_require__("U95Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__send_discuss__ = __webpack_require__("t4/8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'mystrategy',
    components: {
        strategyBacktest: __WEBPACK_IMPORTED_MODULE_1__strategy_backtest__["a" /* default */],
        backtestOnce: __WEBPACK_IMPORTED_MODULE_2__backtest_once__["a" /* default */],
        receiveDiscuss: __WEBPACK_IMPORTED_MODULE_3__receive_discuss__["a" /* default */],
        sendDiscuss: __WEBPACK_IMPORTED_MODULE_4__send_discuss__["a" /* default */]
    },
    data: function data() {
        return {
            itemTab: 1,
            discussTab: 1,
            keyWord: '',
            pageSize: 10,
            currentPage: 1,
            sortSelect: '',
            isSearchResult: false,
            isshowloading: false,
            isFromSearch: true
        };
    },
    created: function created() {
        if (this.userId == null) {
            // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
            window.LoginInstance.show();
            return;
        }
        this.updateList();
    },
    activated: function activated() {
        if (this.userId == null) {
            // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
            window.LoginInstance.show();
            return;
        }
        // window.addEventListener('scroll', this.__scrollBar__)
        window.TA.log({ id: this.buriedPoint.pageAccess, _sid: '__ths_001' });
        // window.TA.log({id: this.totalPoint, _sid: '__ths_002'})
    },

    // deactivated () {
    //     window.removeEventListener('scroll', this.__scrollBar__)
    // },
    computed: {
        userId: function userId() {
            return this.$store.getters['userInfo/userId'];
        },
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.myStrategy;
        },
        totalPoint: function totalPoint() {
            return this.$buriedPoint.totalPlatformAccess;
        },
        collectBacktestData: function collectBacktestData() {
            return this.$store.getters['myStrategy/collectBacktestData'];
        },
        ownCollectDataLiat: function ownCollectDataLiat() {
            return this.collectBacktestData.list;
        },
        total: function total() {
            return this.collectBacktestData.num;
        }
    },
    methods: {
        // __scrollBar__ () {
        //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
        //         window.TA.log(this.buriedPoint.scrollBar)
        //     }
        // },
        strategyDetailPoint: function strategyDetailPoint(targid) {
            window.TA.log({ id: this.buriedPoint.inStrategyDetails, targid: targid });
        },
        receivePoint: function receivePoint() {
            window.TA.log(this.buriedPoint.takeDiscuss.receiveDiscuss);
        },
        sendPoint: function sendPoint() {
            window.TA.log(this.buriedPoint.takeDiscuss.sendDiscuss);
        },
        goPage: function goPage(page) {
            this.currentPage = page;
        },
        removeCollect: function removeCollect(id) {
            var self = this;
            window.TA.log(self.buriedPoint.collectStrategy.cancelCollect);
            this.$confirm({
                // 'type': 'warning',
                'title': '您要取消收藏该策略吗？',
                // 'smallTitle': '取消后，我们不再推送给你该机器人的股票操作信息',
                'okBtnTitle': '确定',
                'cancelBtnCallback': function cancelBtnCallback(done) {
                    window.TA.log(self.buriedPoint.collectStrategy.cancelCollectCancel);
                    done();
                },
                'okBtnCallback': function okBtnCallback(done) {
                    window.TA.log(self.buriedPoint.collectStrategy.cancelCollectOk);
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/strategysquare/uncollect', {
                        strategyId: id
                    }).then(function (res) {
                        if (!res.data.result) {
                            self.$tip({
                                message: '策略取消收藏失败',
                                duration: 2000,
                                type: 'error'
                            });
                        } else {
                            done();
                            self.$tip({
                                message: '策略取消收藏成功',
                                duration: 2000,
                                type: 'success'
                            });
                            self.updateList();
                        }
                    }).catch(function (error) {
                        done();
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        });
                    });
                }
            });
        },
        updateSearch: function updateSearch() {
            window.TA.log(this.buriedPoint.collectStrategy.search);
            this.updateList();
        },
        updateList: function updateList() {
            var self = this;
            this.isshowloading = true;
            this.$store.dispatch('myStrategy/requestCollectBacktest', {
                page: this.currentPage,
                pageNum: this.pageSize,
                sortType: this.sortSelect,
                keyword: this.keyWord
            }).then(function (result) {
                if (self.ownCollectDataLiat.length === 0) {
                    self.isFromSearch = Boolean(self.keyWord);
                    self.isSearchResult = true;
                } else {
                    self.isSearchResult = false;
                }
                self.isshowloading = false;
            }).catch(function (error) {
                // 临时处理，后续优化
                if (error.message === '用户未登录') {
                    return;
                }
                self.isshowloading = false;
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        }
    },
    watch: {
        currentPage: function currentPage() {
            this.updateList();
        }
    }
});

/***/ }),

/***/ "eGe1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategy-backtest"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.strategyKeyWord),expression:"strategyKeyWord"}],attrs:{"type":"text","placeholder":"搜索关键词"},domProps:{"value":(_vm.strategyKeyWord)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateSearchStrategy.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.strategyKeyWord=$event.target.value}}}),_vm._v(" "),_c('span',{on:{"click":_vm.updateSearchStrategy}})]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult && !_vm.isFromSearch),expression:"isSearchResult && !isFromSearch"}]},[_c('span',[_vm._v("你还没有创建任何策略哦~")]),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":'/strategybacktest'}},[_c('span',{staticClass:"created"},[_vm._v("立即创建我的策略")])])],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult && _vm.isFromSearch),expression:"isSearchResult && isFromSearch"}]},[_vm._v("暂无查询列表数据")]),_vm._v(" "),_c('vue-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowloading),expression:"isshowloading"}],staticStyle:{"height":"calc(100% - 20px)","border":"none","top":"0","left":"0"}}),_vm._v(" "),_vm._l((_vm.strategyDataList),function(item,index){return _c('strategy-row-item',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearchResult && !_vm.isshowloading),expression:"!isSearchResult && !isshowloading"}],key:index,attrs:{"index-serial":index,"page":_vm.currentPage,"strategy-id":item.property.id,"buy-position":parseInt(item.property.buyPosition),"strategy-type":item.property.type,"strategy-name":item.property.name,"strategy-logic":item.property.logic,"strategy-ctime":item.property.ctime,"strategy-annual-yield":item.property.annualYield,"strategy-win-rate":item.property.winRate,"strategy-tags":item.property.tags,"strategy-user":item.author.userName,"strategy-avatar":item.author.avatar,"strategy-user-id":item.author.userId,"strategy-collect-num":item.interaction.collectNum,"strategy-comment-num":item.interaction.commentNum,"strategy-is-collected":item.interaction.isCollected,"strategy-is-subscribe":item.interaction.isSubscribe,"strategy-is-publish":item.interaction.isPublish},on:{"subscribe":_vm.subscribe,"cancel-subscribe":_vm.cancelSubscribe,"delete-strategy":_vm.deleteStrategy}})})],2),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eKWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lib_tip__ = __webpack_require__("QUI1");
// @charset "utf-8"



// import { PopupManager } from 'element-ui/src/utils/popup'
// import { isVNode } from 'element-ui/src/utils/vdom',
var TipConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_1__components_lib_tip__["a" /* default */]);

var instance;
var instances = [];
var seed = 1;

var Tip = function Tip(options) {
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$isServer) {
        return;
    }
    options = options || {};
    if (typeof options === 'string') {
        options = {
            tip: options
        };
    }
    var userOnClose = options.onClose;
    var id = 'tip_' + seed++;

    options.onClose = function () {
        Tip.close(id, userOnClose);
    };
    instance = new TipConstructor({
        data: options
    });
    instance.id = id;
    // if (isVNode(instance.tip)) {
    //   instance.$slots.default = [instance.tip]
    //   instance.tip = null
    // }
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    // instance.vm.top = 30 + instances.length * 8 + '%'
    instance.vm.top = 8 + instances.length * 8 + '%';
    instance.vm.right = 3 + '%';

    instance.vm.visible = true;
    instance.dom = instance.vm.$el;
    // instance.dom.style.zIndex = PopupManager.nextZIndex()
    instances.push(instance);
    return instance.vm;
};

// var typeArr = ['success', 'warning', 'info', 'error']
// for (var i = 0; i <= 3; i++) {
//   Tip[typeArr[i]] = {
//     options : {
//       if (typeof options === 'string') {
//         options = {
//           tip: options
//         }
//       }
//       options.type = type
//       return Tip(options)
//     }
//   }
// }

Tip.close = function (id, userOnClose) {
    for (var i = 0, len = instances.length; i < len; i++) {
        if (id === instances[i].id) {
            if (typeof userOnClose === 'function') {
                userOnClose(instances[i]);
            }
            instances.splice(i, 1);
            break;
        }
    }
};

Tip.closeAll = function () {
    for (var i = instances.length - 1; i >= 0; i--) {
        instances[i].close();
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Tip);

/***/ }),

/***/ "eNHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution"},[_c('div',{staticClass:"distribution_title"},[_c('p',[_vm._v("涨跌分布图")]),_vm._v(" "),_c('div',{staticClass:"distribution_chart_select"},[_c('p',[_vm._v("持股周期 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDay),expression:"selectedDay"}],staticClass:"chary_select",on:{"click":_vm.charySelect,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedDay=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.daySelect),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(item)+" 天")])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transactiontype === '2'),expression:"transactiontype === '2'"}],staticClass:"distribution_chart_select"},[_c('p',[_vm._v("择时选项 :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSignal),expression:"selectedSignal"}],staticClass:"chary_select",on:{"click":_vm.charySelectTow,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSignal=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.marketSignals),function(item,key,index){return _c('option',{key:key,domProps:{"value":item}},[_vm._v(_vm._s(_vm.signalData[item]))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"distribution_main"},[_c('div',{ref:"chartRef",staticStyle:{"width":"475px","height":"250px","margin":"10px auto 0 auto","border":"1px solid #d6d6d6"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eNfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Gyi1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c9b7e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("AHni");
function injectStyle (ssrContext) {
  __webpack_require__("vEzN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10c9b7e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c9b7e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eUBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gG4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_grade_vue__ = __webpack_require__("S796");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04057469_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_grade_vue__ = __webpack_require__("hoi9");
function injectStyle (ssrContext) {
  __webpack_require__("eUBC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04057469"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_grade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04057469_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_grade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gcrr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hoi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report_grade"},[_c('div',{staticClass:"report_grade_title"},[_c('p',{staticClass:"fl"},[_vm._v("报告评级")]),_vm._v(" "),_c('div',{staticClass:"fr report_stockpick"},[_c('span',[_vm._v("选股结果仅供对比参考")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":'http://x.10jqka.com.cn/stockpick/search?w=' + _vm.query},on:{"click":_vm.iwencaiPoint}},[_c('vue-button',{attrs:{"type":"blue","size":"small"}},[_vm._v("查看问财选股")])],1)])]),_vm._v(" "),(_vm.transactiontype === '1')?_c('div',{staticClass:"report_grade_main"},[_c('div',{staticClass:"average_rise_fall"},[_c('p',[_vm._v("最大预期年化收益率")]),_vm._v(" "),_c('p',{staticClass:"backtestweek"},[_c('span',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.reportData.maxAnnualYield[0])))]),_vm._v(", 回测持股周期 "),_c('span',[_vm._v(_vm._s(_vm.reportData.maxAnnualYield[1]))]),_vm._v(" 天 ")])]),_vm._v(" "),_c('div',{staticClass:"max_win_rise"},[_c('p',[_vm._v("最大成功率")]),_vm._v(" "),_c('p',{staticClass:"backtestweek"},[_c('span',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.reportData.maxWinRate[0])))]),_vm._v(", 回测持股周期 "),_c('span',[_vm._v(_vm._s(_vm.reportData.maxWinRate[1]))]),_vm._v(" 天 ")])]),_vm._v(" "),_c('div',{staticClass:"report_grade_img",class:_vm._f("levelType")(_vm.reportData.level)})]):_c('div',{staticClass:"report_grade_main"},[_c('div',{staticClass:"average_rise_fall"},[_c('p',[_vm._v("最大预期年化收益率")]),_vm._v(" "),_c('p',{staticClass:"choose_signal"},[_vm._v("择时信号："+_vm._s(_vm.signalData[_vm.reportData.maxAnnualYield[1]]))]),_vm._v(" "),_c('p',{staticClass:"backtestweek pdt5"},[_c('span',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.reportData.maxAnnualYield[0])))]),_vm._v(", 回测持股周期 "),_c('span',[_vm._v(_vm._s(_vm.reportData.maxAnnualYield[2]))]),_vm._v(" 天 ")])]),_vm._v(" "),_c('div',{staticClass:"max_win_rise"},[_c('p',[_vm._v("最大成功率")]),_vm._v(" "),_c('p',{staticClass:"choose_signal"},[_vm._v("择时信号："+_vm._s(_vm.signalData[_vm.reportData.maxWinRate[1]]))]),_vm._v(" "),_c('p',{staticClass:"backtestweek pdt5"},[_c('span',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.reportData.maxWinRate[0])))]),_vm._v(", 回测持股周期 "),_c('span',[_vm._v(_vm._s(_vm.reportData.maxWinRate[2]))]),_vm._v(" 天 ")])]),_vm._v(" "),_c('div',{staticClass:"report_grade_img",class:_vm._f("levelType")(_vm.reportData.level)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i1oC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// @charset "utf-8";
var cookieApi = {
    get: function get(name) {
        var arg = name + '=';
        var alen = arg.length;
        var clen = document.cookie.length;
        var i = 0;
        var j = 0;
        while (i < clen) {
            j = i + alen;
            if (document.cookie.substring(i, j) === arg) {
                var endstr = document.cookie.indexOf(';', j);
                if (endstr === -1) {
                    endstr = document.cookie.length;
                }

                var value;
                try {
                    value = decodeURIComponent(document.cookie.substring(j, endstr));
                } catch (err) {
                    value = '';
                }

                return unescape(value);
            }
            i = document.cookie.indexOf(' ', i) + 1;

            if (i === 0) {
                break;
            }
        }
        return null;
    },
    set: function set(name, value, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value + '; ' + expires + '; ' + document.domain + '; /';
    },
    remove: function remove(name) {
        this.set(name, '', -1);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (cookieApi);

/***/ }),

/***/ "iIOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_bar_vue__ = __webpack_require__("cHTz");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_bar_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iZrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cumulativeIncomeChart_vue__ = __webpack_require__("C1Bi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c964408_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cumulativeIncomeChart_vue__ = __webpack_require__("seP5");
function injectStyle (ssrContext) {
  __webpack_require__("axSx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c964408"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cumulativeIncomeChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c964408_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cumulativeIncomeChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jDkR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kGpD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kIsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ty6Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_856198be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("sQby");
function injectStyle (ssrContext) {
  __webpack_require__("ApJG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-856198be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_856198be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kOQh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtest_once_vue__ = __webpack_require__("K5kc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ff5f71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtest_once_vue__ = __webpack_require__("ocdI");
function injectStyle (ssrContext) {
  __webpack_require__("T+OU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65ff5f71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtest_once_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ff5f71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtest_once_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kerX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backtestmain"},[_c('div',{staticClass:"strategyquestion"},[_c('div',{staticClass:"question_main"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideSearchList),expression:"hideSearchList"}],staticClass:"question_title fl"},[_c('div',{staticClass:"item-title"},[_c('p',{staticClass:"normal fl"},[_vm._v("请输入您想要回测的问句：  ")]),_vm._v(" "),_c('p',{ref:"sentenceNotice",staticClass:"highlight fl",staticStyle:{"display":"none"}},[_vm._v("策略问句不能为空且不能超过200字!")])]),_vm._v(" "),_c('div',{staticClass:"item-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sentence),expression:"sentence"},{name:"validate",rawName:"v-validate",value:({ type: 'string', max: 200, min: 1, errClass: 'focus', errRef: 'sentenceNotice' }),expression:"{ type: 'string', max: 200, min: 1, errClass: 'focus', errRef: 'sentenceNotice' }"}],ref:"question_sentence_input",attrs:{"id":"question_sentence_input","placeholder":"请输入问句","autocomplete":"off","type":"text"},domProps:{"value":(_vm.sentence)},on:{"blur":function($event){return _vm.questionDataValidation($event, 0)},"keyup":[function($event){return _vm.debounceQuestion($event, 1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.sentence=$event.target.value}}}),_vm._v(" "),_c('span',{on:{"click":_vm.empty}}),_vm._v(" "),(_vm.searchVis)?_c('key-list',{attrs:{"list-visible":_vm.searchVis,"list-data":_vm.searchList,"max-num":7},on:{"update:listVisible":function($event){_vm.searchVis=$event},"update:list-visible":function($event){_vm.searchVis=$event},"click-item":_vm.updateInput,"select-item":_vm.updateInput,"no-checked":_vm.nochecked}}):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideBenchmarkList),expression:"hideBenchmarkList"}],staticClass:"question_sentence fl"},[_c('div',{staticClass:"item-title"},[_c('p',{staticClass:"normal fl"},[_vm._v("基准指数：  ")]),_vm._v(" "),_c('p',{ref:"benchmarkNotice",staticClass:"highlight fl",staticStyle:{"display":"none"}},[_vm._v("标的不能为空！")])]),_vm._v(" "),_c('div',{staticClass:"item-input",staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.benchmark),expression:"benchmark",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:({type: 'string', max: 50, min: 1, errClass:'focus', errRef: 'benchmarkNotice'}),expression:"{type: 'string', max: 50, min: 1, errClass:'focus', errRef: 'benchmarkNotice'}"}],ref:"question_benchmark",attrs:{"type":"text","placeholder":"请输入对应标的"},domProps:{"value":(_vm.benchmark)},on:{"keyup":[function($event){return _vm.debounceBenchmark($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.benchmark=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.benchmarkListVisible)?_c('key-list',{attrs:{"list-visible":_vm.benchmarkListVisible,"list-data":_vm.benchmarkList,"parse-item":_vm.parseItem,"value-key":"label"},on:{"update:listVisible":function($event){_vm.benchmarkListVisible=$event},"update:list-visible":function($event){_vm.benchmarkListVisible=$event},"click-item":_vm.updateBenchmarkInput,"select-item":_vm.updateBenchmarkInput,"no-checked":_vm.benchmarkNochecked}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"question_cycle"},[_c('p',{staticClass:"fl normal"},[_vm._v("输入您想回测的持股周期：  ")]),_vm._v(" "),_c('p',{ref:"numberNotice",staticClass:"fl highlight",staticStyle:{"display":"none"}},[_vm._v("请正确输入正数，可用英文状态下 \",\" 分隔天数")])]),_vm._v(" "),_c('div',{staticClass:"question_cycle_number"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"},{name:"validate",rawName:"v-validate",value:({ type: 'period', errClass: 'focus', errRef: 'numberNotice'}),expression:"{ type: 'period', errClass: 'focus', errRef: 'numberNotice'}"}],ref:"question_cycle_input",attrs:{"type":"text"},domProps:{"value":(_vm.number)},on:{"blur":_vm.questionCyclePoint,"keyup":[_vm.validateInput,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("  天")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sd-toolbar"},[_c('div',{staticClass:"sd-toolbar_operabox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeStartDate),expression:"tradeStartDate"}],staticClass:"trade_detail_startDate",attrs:{"id":"trade_detail_startDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeStartDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, '#F{$dp.$D(\'trade_detail_endDate\')}', '2014-1-1')},"blur":_vm.startDatePoint,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeStartDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"time-split"},[_vm._v(" 至 ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeEndDate),expression:"tradeEndDate"}],staticClass:"trade_detail_endDate",attrs:{"id":"trade_detail_endDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeEndDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, _vm.yesterdayDate, '#F{$dp.$D(\'trade_detail_startDate\')}')},"blur":_vm.endDatePoint,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeEndDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backtestCompleted),expression:"backtestCompleted"}],staticClass:"question_analysis"},[_c('p',{staticClass:"fl"},[_vm._v("系统对您语句解析后，以下列条件进行回测")]),_vm._v(" "),_vm._l((_vm.conditions),function(condi){return _c('div',{staticClass:"condition",attrs:{"title":condi}},[_vm._v(_vm._s(condi))])})],2),_vm._v(" "),_c('div',{staticClass:"finish"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.backtestCompleted),expression:"backtestCompleted"}],staticClass:"fl"},[_vm._v("回测运行完成 !")]),_vm._v(" "),(_vm.issave)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backtestCompleted),expression:"backtestCompleted"}],staticClass:"savebacktest fl",on:{"click":_vm.save}},[_vm._v("保存回测")]):_vm._e(),_vm._v(" "),(!_vm.issave)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backtestCompleted),expression:"backtestCompleted"}],staticClass:"cancelbacktest fl",on:{"click":_vm.cancel,"mouseenter":_vm.enter_1,"mouseleave":_vm.leave_1}},[_vm._v(_vm._s(_vm.alreadysave))]):_vm._e(),_vm._v(" "),(!_vm.defaultqueryLoading)?_c('div',{staticClass:"beginbacktest fr",on:{"click":_vm.startBacktest}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()])])]),_vm._v(" "),(_vm.backtestCompleted)?_c('div',{staticClass:"report_grade"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"report_grade_main"},[_c('div',{staticClass:"history_happen"},[_c('p',[_vm._v("历史发生次数")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.reportData.historyHappenCount)+"次")])]),_vm._v(" "),_c('div',{staticClass:"average_rise_fall"},[_c('p',[_vm._v("最优平均涨跌幅")]),_vm._v(" "),_c('p',[_vm._v("回测持股周期 "),_c('span',[_vm._v(_vm._s(_vm.backtestData[_vm.reportData.maxAverageChangeRate[1]].daySaleStrategy))]),_vm._v(" 天,平均涨跌幅 "),_c('span',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.reportData.maxAverageChangeRate[0])))])])]),_vm._v(" "),_c('div',{staticClass:"max_win_rise"},[_c('p',[_vm._v("最大上涨概率")]),_vm._v(" "),_c('p',[_vm._v("回测持股周期 "),_c('span',[_vm._v(_vm._s(_vm.backtestData[_vm.reportData.maxWinRate[1]].daySaleStrategy))]),_vm._v(" 天,上涨概率 "),_c('span',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.reportData.maxWinRate[0])))])])]),_vm._v(" "),_c('div',{staticClass:"report_grade_img",class:_vm._f("levelType")(_vm.reportData.level)})])]):_vm._e(),_vm._v(" "),(_vm.backtestCompleted)?_c('div',{staticClass:"backtest_analysis"},[_c('div',{staticClass:"backtest_analysis_title"},[_c('p',[_vm._v("回测分析\n                "),_c('vue-notice-tip',{attrs:{"list":_vm.noticeList}})],1)]),_vm._v(" "),_c('div',{staticClass:"backtest_analysis_main"},[_vm._m(2),_vm._v(" "),_c('EasyScrollbar',{attrs:{"barOption":_vm.myBarOption}},[_c('div',{staticClass:"rolltable"},[_c('table',{attrs:{"cellspacing":"0"}},[_c('tbody',_vm._l((_vm.backtestData),function(back,index){return _c('tr',{class:[(index + 1) % 2 === 0 ? 'gray' : '', index === _vm.reportData.maxWinRate[1] ? 'blue' : index === _vm.reportData.maxAverageChangeRate[1] ? 'blue' : '']},[_c('td',{class:index === _vm.reportData.maxWinRate[1] ? 'recommend' : index === _vm.reportData.maxAverageChangeRate[1] ? 'recommend' : 'transparent',attrs:{"width":"21"}},[_vm._v("荐")]),_vm._v(" "),_c('td',{attrs:{"width":"58"}},[_vm._v(_vm._s(back.daySaleStrategy)+"天")]),_vm._v(" "),_c('td',{attrs:{"width":"115"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.averageChangeRate)))]),_vm._v(" "),_c('td',{attrs:{"width":"104"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.hs300AverageIncome)))]),_vm._v(" "),_c('td',{attrs:{"width":"120"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.highProbability)))]),_vm._v(" "),_c('td',{attrs:{"width":"140"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.averageOpenIncome)))]),_vm._v(" "),_c('td',{attrs:{"width":"102"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.maxChangeRate)))]),_vm._v(" "),_c('td',{attrs:{"width":"103"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.minChangeRate)))]),_vm._v(" "),_c('td',{attrs:{"width":"79"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(back.averageLossRatio)))]),_vm._v(" "),_c('td',{attrs:{"width":"106"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.winRate)))]),_vm._v(" "),_c('td',{attrs:{"width":"130"}},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(back.hs300WinRate)))])])}),0)])])])],1)]):_vm._e(),_vm._v(" "),(_vm.backtestCompleted)?_c('change-rate-group',{attrs:{"dayselect":_vm.dayselect,"chartday":'' + _vm.backtestData[_vm.reportData.maxWinRate[1]].daySaleStrategy,"backtest-data":_vm.backtestData,"refresh":_vm.refresh}}):_vm._e(),_vm._v(" "),(_vm.backtestCompleted)?_c('history-detail',{attrs:{"dayselect":_vm.dayselect,"period":'' + _vm.backtestData[_vm.reportData.maxWinRate[1]].daySaleStrategy,"minDate":_vm.tradeStartDate,"maxDate":_vm.tradeEndDate,"myBarOption":_vm.myBarOption,"backtestId":_vm.backtestId,"refresh":_vm.refresh}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hotbacktest"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"hotbacktest_main"},[_c('div',{staticClass:"hotbacktest_left"},_vm._l((_vm.lefthot),function(leftback){return _c('div',{staticClass:"hotbacktest_name"},[_c('p',{attrs:{"title":leftback.query}},[_vm._v(_vm._s(leftback.query))]),_vm._v(" "),_c('span',{on:{"click":_vm.buriedPoints}},[_c('router-link',{attrs:{"to":{name: 'backtest', query: leftback.cond_data}}},[_vm._v("回测一下")])],1)])}),0),_vm._v(" "),_c('div',{staticClass:"hotbacktest_right"},_vm._l((_vm.righthot),function(rightback){return _c('div',{staticClass:"hotbacktest_name"},[_c('p',{attrs:{"title":rightback.query}},[_vm._v(_vm._s(rightback.query))]),_vm._v(" "),_c('span',{on:{"click":_vm.buriedPoints}},[_c('router-link',{attrs:{"to":{name: 'backtest', query: rightback.cond_data}}},[_vm._v("回测一下")])],1)])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.operateLoading),expression:"operateLoading"}],staticClass:"testmain"},[_c('div',{staticClass:"testshadow"}),_vm._v(" "),_c('div',{staticClass:"testparallel"},[_c('div',{staticClass:"test-loading"},[_c('span',{staticClass:"testing-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.loadingText))])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question_section"},[_c('p',{staticClass:"fl"},[_vm._v("选择您想回测的时间区间：  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report_grade_title"},[_c('p',[_vm._v("报告评级")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"cellspacing":"0"}},[_c('thead',[_c('th',{attrs:{"width":"21"}}),_vm._v(" "),_c('th',{attrs:{"width":"58"}},[_vm._v("持有期")]),_vm._v(" "),_c('th',{attrs:{"width":"115"}},[_vm._v("平均区间涨跌幅")]),_vm._v(" "),_c('th',{attrs:{"width":"104"}},[_vm._v("同期基准")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("次日高开概率")]),_vm._v(" "),_c('th',{attrs:{"width":"140"}},[_vm._v("次日开盘平均涨跌幅")]),_vm._v(" "),_c('th',{attrs:{"width":"102"}},[_vm._v("最大涨跌幅")]),_vm._v(" "),_c('th',{attrs:{"width":"103"}},[_vm._v("最小涨跌幅")]),_vm._v(" "),_c('th',{attrs:{"width":"79"}},[_vm._v("盈亏比")]),_vm._v(" "),_c('th',{attrs:{"width":"106"}},[_vm._v("上涨概率")]),_vm._v(" "),_c('th',{attrs:{"width":"130"}},[_vm._v("基准上涨概率")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotbacktest_title"},[_c('p',[_vm._v("热门回测")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ksvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classComputedName},[_c('div',{staticClass:"strategy_select_title"},[_c('p',{staticClass:"pick-title"},[_vm._v("策略选股 "),(_vm.showPick)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickDate),expression:"pickDate"}],staticClass:"pick_date",attrs:{"id":"pick_date","type":"text","readonly":"readonly"},domProps:{"value":(_vm.pickDate)},on:{"click":function($event){return _vm.showTradeDateDialog($event, _vm.maxDate, '2014-1-1')},"input":function($event){if($event.target.composing){ return; }_vm.pickDate=$event.target.value}}})]:[_vm._v("（"+_vm._s(_vm.pickDate)+"）")]],2),_vm._v(" "),_c('p',{staticClass:"pick-item"},[_vm._v("仓位控制："+_vm._s(_vm.position))]),_vm._v(" "),(_vm.transactiontype === '2')?_c('p',{staticClass:"pick-item"},[_vm._v("次日市场："+_vm._s((_vm.pickStock !== null && _vm.pickStock.market !== null) ? (_vm.pickStock.market > 0 ? '强势行情' : '弱势行情') : '--'))]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('EasyScrollbar',{attrs:{"barOption":_vm.myBarOption}},[(_vm.pickStock !== null)?_c('div',{staticClass:"rolltable"},[_c('table',{attrs:{"cellspacing":"0"}},[(_vm.pickStock.stocks.length !== 0)?_c('tbody',_vm._l((_vm.pickStock.stocks),function(selet,index){return _c('tr',{class:(index + 1) % 2 === 0 ? 'gray' : ''},[_c('td',{attrs:{"width":"124"}},[_vm._v(_vm._s(_vm._f("slicetwo")(selet.stock_code)))]),_vm._v(" "),_c('td',{staticClass:"td-highlight",attrs:{"width":"124"},on:{"click":function($event){return _vm.codeLink(selet.stock_code)},"mouseenter":function($event){return _vm.debounceShowQuoteChart($event, selet)},"mouseleave":function($event){return _vm.hideQuoteChart(selet)}}},[_vm._v(_vm._s(selet.stock_name))]),_vm._v(" "),_c('td',{class:_vm._f("riseAndFallClass")(selet.change_rate),attrs:{"width":"93"}},[_vm._v(_vm._s(_vm._f("safeFloatPerFixedTwo")(selet.change_rate)))]),_vm._v(" "),_c('td',{attrs:{"width":"248"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(selet.close_price)))]),_vm._v(" "),_c('td',{attrs:{"width":"271"}},[_vm._v(_vm._s(_vm._f("safeFloatFixedTwo")(selet.dde)))]),_vm._v(" "),_c('td',{attrs:{"width":"124"}},[_vm._v(_vm._s(selet.equit_scale))]),_vm._v(" "),_c('td',{attrs:{"width":"94"}},[_vm._v(_vm._s(_vm._f("safeFloatPerFixedTwo")(selet.turnover_rate)))])])}),0):_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_vm._v("今日无选股")])])])])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"cellspacing":"0"}},[_c('thead',[_c('th',[_vm._v("股票代码")]),_vm._v(" "),_c('th',[_vm._v("股票简称")]),_vm._v(" "),_c('th',[_vm._v("涨跌幅")]),_vm._v(" "),_c('th',[_vm._v("当日收盘价（元）")]),_vm._v(" "),_c('th',[_vm._v("dde大单净量（%）")]),_vm._v(" "),_c('th',[_vm._v("股本规模")]),_vm._v(" "),_c('th',[_vm._v("换手率")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lJCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lib_quote_chart__ = __webpack_require__("3dFz");
// @charset "utf-8"



var QuoteChartVueConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_1__components_lib_quote_chart__["a" /* default */]);

var instance = null;
var instanceId = 'quotechart_id';
var curType = 'daykline';

var QuoteChart = function QuoteChart(options) {
    if (!('code' in options)) {
        return;
    }

    if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$isServer) {
        return;
    }

    options.updateCurType = function (type) {
        curType = type;
    };
    if (instance) {
        options['type'] = curType;
        instance.vm.show(options);
    } else {
        options['type'] = curType;
        instance = new QuoteChartVueConstructor({
            data: options
        });
        instance.id = instanceId;
        instance.vm = instance.$mount();
        document.body.appendChild(instance.vm.$el);
        instance.vm.visible = true;
        instance.dom = instance.vm.$el;
    }
    return instance.vm;
};

QuoteChart.hide = function (code, userOnClose) {
    if (instance && 'vm' in instance && instance.vm.code === code) {
        instance.vm.hide();
        if (typeof userOnClose === 'function') {
            userOnClose(instance);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (QuoteChart);

/***/ }),

/***/ "lSu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lib_feedback__ = __webpack_require__("wP0F");
// @charset "utf-8";


var feedBack = {
    install: function install(Vue) {
        Vue.component('feedBack', __WEBPACK_IMPORTED_MODULE_0__components_lib_feedback__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (feedBack);

/***/ }),

/***/ "lmiR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lib_qrcode__ = __webpack_require__("KgfS");
// @charset "utf-8";


var qrCode = {
    install: function install(Vue) {
        Vue.component('qrCode', __WEBPACK_IMPORTED_MODULE_0__components_lib_qrcode__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (qrCode);

/***/ }),

/***/ "luhk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mYLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            visible: false,

            title: '',

            smallTitle: '',

            okBtn: true,

            cancelBtn: true,

            okBtnTitle: '确定',

            cancelBtnTitle: '取消',

            okBtnCallback: null,

            cancelBtnCallback: null,

            type: 'error',

            closed: false
        };
    },
    props: {},

    watch: {
        closed: function closed(newVal) {
            if (newVal) {
                this.visible = false;
                this.$el.addEventListener('transitionend', this.destroyElement);
            }
        }
    },

    computed: {
        iconSrc: function iconSrc() {
            /* eslint-disable template-curly-spacing */
            return !(function webpackMissingModule() { var e = new Error("Cannot find module \"@img\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
        }
    },

    methods: {
        okEvent: function okEvent() {
            if (typeof this.okBtnCallback === 'function') {
                this.okBtnCallback(this.close);
            } else {
                this.close();
            }
        },
        cancelEvent: function cancelEvent() {
            if (typeof this.cancelBtnCallback === 'function') {
                this.cancelBtnCallback(this.close);
            } else {
                this.close();
            }
        },

        close: function close() {
            this.closed = true;
            if (typeof this.onClose === 'function') {
                this.onClose(this);
            }
        }
    }
});

/***/ }),

/***/ "mbt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_row_vue__ = __webpack_require__("LN0A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081465a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_item_row_vue__ = __webpack_require__("CeXA");
function injectStyle (ssrContext) {
  __webpack_require__("kGpD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-081465a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081465a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_item_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oMgd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oX69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.listVisible),expression:"listVisible"}]},_vm._l((_vm.listData),function(item,index){return (index < _vm.maxNum)?_c('li',{class:_vm.activeIndex === index ? 'active' : '',attrs:{"title":_vm.valueKey ? (item[_vm.valueKey] || '') : item},on:{"click":function($event){return _vm.clickItem(item, index)}}},[_vm._v(_vm._s(_vm.valueKey ? (item[_vm.valueKey] || '') : item))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ocdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backtest-once"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onceKeyWord),expression:"onceKeyWord"}],attrs:{"type":"text","placeholder":"搜索关键词"},domProps:{"value":(_vm.onceKeyWord)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateSearchOnce.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.onceKeyWord=$event.target.value}}}),_vm._v(" "),_c('span',{on:{"click":_vm.updateSearchOnce}})]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult && !_vm.isFromSearch),expression:"isSearchResult && !isFromSearch"}]},[_c('span',[_vm._v("你还没有创建任何策略哦~")]),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":'/backtest'}},[_c('span',{staticClass:"created"},[_vm._v("立即创建我的策略")])])],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult && _vm.isFromSearch),expression:"isSearchResult && isFromSearch"}]},[_vm._v("暂无查询列表数据")]),_vm._v(" "),_c('vue-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowloading),expression:"isshowloading"}],staticStyle:{"height":"calc(100% - 20px)","border":"none","top":"0","left":"0"}}),_vm._v(" "),_vm._l((_vm.onceDataList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearchResult && !_vm.isshowloading),expression:"!isSearchResult && !isshowloading"}],key:index,staticClass:"list-item"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"item-report_level",class:_vm._f("levelType")(item.report_level)}),_vm._v(" "),_c('div',{staticClass:"item-details"},[_c('router-link',{attrs:{"to":{path: 'backtest', query: _vm.parseQuery(item)}}},[_c('p',{on:{"click":_vm.buriedPoints}},[_vm._v(_vm._s(item.query))])]),_vm._v(" "),_c('span',{staticClass:"start-time"},[_c('b',[_vm._v("开始时间:")]),_vm._v(_vm._s(item.start_time))]),_vm._v(" "),_c('span',[_c('b',[_vm._v("结束时间:")]),_vm._v(_vm._s(item.end_time))]),_vm._v(" "),_c('span',{staticClass:"ctime"},[_vm._v(_vm._s(item.ctime))])],1),_vm._v(" "),_c('div',{staticClass:"item-rate"},[_c('p',{class:_vm._f("riseAndFallClass")(item.average_income)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item.average_income)))]),_vm._v(" "),_c('span',[_vm._v("单次涨跌幅平均值")])]),_vm._v(" "),_c('div',{staticClass:"item-rate"},[_c('p',{class:_vm._f("riseAndFallClass")(item.win_rate)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(item.win_rate)))]),_vm._v(" "),_c('span',[_vm._v("上涨概览")])]),_vm._v(" "),_c('div',{staticClass:"item-hold_period"},[_c('p',[_vm._v(_vm._s(item.hold_period))]),_vm._v(" "),_c('span',[_vm._v("持有期")])])])])})],2),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pFGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
// @charset "utf-8";


for (var key in __WEBPACK_IMPORTED_MODULE_0__filters__) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_0__filters__[key]);
}

/***/ }),

/***/ "pTcW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"item-publish",class:!_vm.strategyIsPublish ? 'no_publish' : 'yes_publish'}),_vm._v(" "),_c('div',{staticClass:"item-left"},[_c('div',{staticClass:"item-logo"},[_c('router-link',{key:_vm.strategyId,attrs:{"to":'/strategysquare/' + _vm.strategyId}},[_c('img',{attrs:{"src":'/svg/' + _vm.strategyId + '.svg'}})])],1)]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"item-right-t"},[_c('div',{staticClass:"item-details"},[_c('router-link',{key:_vm.strategyId,attrs:{"to":'/strategysquare/' + _vm.strategyId}},[_c('h3',{on:{"click":_vm.buriedPoints}},[_vm._v(_vm._s(_vm.strategyName))])]),_vm._v(" "),_c('div',{staticClass:"item-label"},_vm._l((_vm.strategyTags),function(item,index){return (item)?_c('span',{key:index},[_vm._v(_vm._s(item))]):_vm._e()}),0),_vm._v(" "),_c('p',[_c('b',[_vm._v("投资逻辑：")]),_vm._v(_vm._s(_vm.strategyLogic))])],1),_vm._v(" "),(!_vm.strategyIsPublish)?_c('div',{staticClass:"item-subscribe",staticStyle:{"border":"none"}}):_vm._e(),_vm._v(" "),(_vm.isSubscribe && _vm.strategyIsPublish)?_c('div',{staticClass:"item-subscribe",on:{"click":_vm.subscribe}},[_vm._v("订阅")]):_vm._e(),_vm._v(" "),(!_vm.isSubscribe && _vm.strategyIsPublish)?_c('div',{staticClass:"item-subscribe",on:{"click":_vm.cancelSubscribe}},[_vm._v("取消订阅")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-annual-income"},[_c('p',{class:_vm._f("riseAndFallClass")(_vm.strategyAnnualYield)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.strategyAnnualYield)))]),_vm._v(" "),_c('span',[_vm._v("年化收益")])]),_vm._v(" "),_c('div',{staticClass:"item-success-rate"},[_c('p',{class:_vm._f("riseAndFallClass")(_vm.strategyWinRate)},[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.strategyWinRate)))]),_vm._v(" "),_c('span',[_vm._v("成功率")])]),_vm._v(" "),_c('div',{staticClass:"item-user"},[_c('div',{staticClass:"item-user-img right"},[_c('img',{attrs:{"src":_vm.strategyAvatar}})]),_vm._v(" "),_c('p',{staticClass:"right"},[_vm._v(_vm._s(_vm.strategyUser))])])]),_vm._v(" "),_c('div',{staticClass:"item-right-b"},[(!_vm.isshoworder)?_c('div',{staticClass:"item-comment"},[_c('span',[_vm._v("评论("+_vm._s(_vm.strategyCommentNum)+")")])]):_vm._e(),_vm._v(" "),(!_vm.isshoworder)?_c('div',{staticClass:"item-collect"},[_c('div',{staticClass:"item-collect"},[_c('span',[_vm._v("收藏数("+_vm._s(_vm.strategyCollectNum)+")")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-delete",on:{"click":function($event){return _vm.deleteStrategy(_vm.strategyId)}}},[_c('span',[_vm._v("删除")])]),_vm._v(" "),_c('div',{staticClass:"item-set-date"},[_c('span',[_vm._v("创建时间："+_vm._s(_vm.strategyCtime))])])]),_vm._v(" "),(!_vm.isshoworder && _vm.isPickCompleted)?_c('pickstock',{attrs:{"transactiontype":'' + _vm.strategyType,"select-data":_vm.pickData,"classname":'item-stock-list',"buy-position":parseInt(_vm.buyPosition)}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pYGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strategybacktest_strategy_select__ = __webpack_require__("wC/k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-new */


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'strategy-row-item',
    components: {
        pickstock: __WEBPACK_IMPORTED_MODULE_1__strategybacktest_strategy_select__["a" /* default */]
    },
    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.myStrategy.createdStrategy;
        }
    },
    data: function data() {
        return {
            myBarOption: {
                barWidth: 9, // 滚动条宽度
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                horizrailenabled: false // 是否显示水平滚动条
            },
            isshoworder: false,
            isPickCompleted: false,
            pickData: null,
            isSubscribe: false
        };
    },

    filters: {
        closePrices: function closePrices(num) {
            return !num ? '--' : Number(num);
        }
    },
    methods: {
        buriedPoints: function buriedPoints() {
            window.TA.log({ id: this.buriedPoint.inStrategyDetails, targid: this.strategyId });
        },
        deleteStrategy: function deleteStrategy(id) {
            var self = this;
            window.TA.log(this.buriedPoint.delete);
            this.$confirm({
                // 'type': 'warning',
                'title': '您要删除该策略吗？',
                // 'smallTitle': '取消后，我们不再推送给你该机器人的股票操作信息',
                'okBtnTitle': '确定',
                'cancelBtnCallback': function cancelBtnCallback(done) {
                    window.TA.log(self.buriedPoint.deleteCancel);
                    done();
                },
                'okBtnCallback': function okBtnCallback(done) {
                    window.TA.log(self.buriedPoint.deleteOk);
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/strategysquare/delete', {
                        strategyId: id
                    }).then(function (res) {
                        if (!res.data.result) {
                            self.$tip({
                                message: res.data.errormsg ? res.data.errormsg.toString() : '网络异常',
                                duration: 2000,
                                type: 'error'
                            });
                        } else {
                            self.$emit('delete-strategy');
                            done();
                            self.$tip({
                                message: '策略删除成功',
                                duration: 2000,
                                type: 'success'
                            });
                        }
                    }).catch(function (error) {
                        done();
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        });
                    });
                }
            });
        },
        subscribe: function subscribe() {
            var _this = this;

            var self = this;
            window.TA.log({ id: this.buriedPoint.subscribe, targid: this.strategyId });
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/mybacktest/subscribe', { params: {
                    id: this.strategyId
                } }).then(function (res) {
                if (res.data.errorcode) {
                    self.$tip({
                        message: res.data.errormsg ? res.data.errormsg : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                } else {
                    _this.$emit('subscribe');
                    self.$tip({
                        message: '策略订阅成功',
                        duration: 2000,
                        type: 'success'
                    });
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        cancelSubscribe: function cancelSubscribe() {
            var _this2 = this;

            var self = this;
            window.TA.log(this.buriedPoint.cancelSubscribe);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/mybacktest/cancelsubscribe', { params: {
                    id: this.strategyId
                } }).then(function (res) {
                if (!res.data.result) {
                    self.$tip({
                        message: res.data.errormsg ? res.data.errormsg : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                } else {
                    _this2.$emit('cancel-subscribe');
                    self.$tip({
                        message: '策略取消订阅成功',
                        duration: 2000,
                        type: 'success'
                    });
                }
            }).catch(function (error) {
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        },
        showTodayStock: function showTodayStock() {
            var _this3 = this;

            var self = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/strategysquare/pickstock', { params: {
                    strategyId: this.strategyId
                }
            }).then(function (res) {
                return res.data.result;
            }).then(function (data) {
                _this3.isPickCompleted = true;
                if (!data) {
                    self.$tip({
                        message: '获取选股参数有误',
                        duration: 2000,
                        type: 'error'
                    });
                } else {
                    _this3.pickData = data;
                }
            }).catch(function (error) {
                self.isPickCompleted = false;
                self.$tip({
                    message: error ? error.message : '网络异常',
                    duration: 2000,
                    type: 'error'
                });
            });
        }
    },
    mounted: function mounted() {
        if (this.strategyIsSubscribe === 1) {
            this.showTodayStock();
            this.isshoworder = false;
            this.isSubscribe = false;
        } else {
            this.isshoworder = true;
            this.isSubscribe = true;
        }
    },

    watch: {
        strategyIsSubscribe: function strategyIsSubscribe(val) {
            if (val === 1) {
                this.showTodayStock();
                this.isshoworder = false;
                this.isSubscribe = false;
            } else {
                this.isshoworder = true;
                this.isSubscribe = true;
            }
        }
    },
    props: {
        strategyId: {
            type: Number,
            default: ''
        },
        buyPosition: Number,
        strategyType: {
            type: Number,
            default: 0
        },
        strategyName: {
            type: String,
            default: ''
        },
        strategyLogic: {
            type: String,
            default: ''
        },
        strategyCtime: {
            type: String,
            default: ''
        },
        strategyAnnualYield: {
            type: String,
            default: '0.00%'
        },
        strategyWinRate: {
            type: String,
            default: '0.00%'
        },
        strategyTags: {
            type: Array,
            default: []
        },
        strategyUser: {
            type: String,
            default: ''
        },
        strategyAvatar: {
            type: String,
            default: ''
        },
        strategyCollectNum: {
            type: Number,
            default: 0
        },
        strategyCommentNum: {
            type: Number,
            default: 0
        },
        strategyIsSubscribe: {
            type: Number,
            default: 0
        },
        strategyIsPublish: {
            type: Number,
            default: 0
        }
    }
});

/***/ }),

/***/ "qjqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qkPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategy_row_item_vue__ = __webpack_require__("pYGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e06054e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategy_row_item_vue__ = __webpack_require__("pTcW");
function injectStyle (ssrContext) {
  __webpack_require__("qy8p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e06054e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategy_row_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e06054e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategy_row_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qocl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        valueKey: {
            type: String
        },
        maxNum: {
            type: Number,
            default: 10
        },
        listData: {
            type: Array,
            required: true
        },
        listVisible: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            activeIndex: null
        };
    },

    computed: {
        masKey: function masKey() {
            var dataLen = this.listData.length;
            return this.maxNum > dataLen ? dataLen - 1 : this.maxNum - 1;
        }
    },
    methods: {
        clickItem: function clickItem(value, index) {
            this.$emit('update:listVisible', false);
            this.$emit('click-item', value);
        },
        selectItem: function selectItem(value, index) {
            this.$emit('select-item', value);
        },
        downItem: function downItem() {
            if (this.activeIndex === this.masKey) {
                this.activeIndex = null;
                this.$emit('no-checked');
            } else {
                if (this.activeIndex !== null) {
                    this.activeIndex++;
                } else {
                    this.activeIndex = 0;
                }
                this.selectItem(this.listData[this.activeIndex], this.activeIndex);
            }
        },
        upItem: function upItem() {
            if (this.activeIndex === 0) {
                this.activeIndex = null;
                this.$emit('no-checked');
            } else {
                if (this.activeIndex !== null) {
                    this.activeIndex--;
                } else {
                    this.activeIndex = this.masKey;
                }
                this.selectItem(this.listData[this.activeIndex], this.activeIndex);
            }
        }
    },
    mounted: function mounted() {
        var self = this;

        document.onkeydown = function (event) {
            var key = event.keyCode;
            if (self.listVisible) {
                if (key === 38) {
                    // up
                    self.upItem();
                } else if (key === 40) {
                    // down
                    self.downItem();
                } else {}
            }
        };
    },

    watch: {
        listVisible: function listVisible(newVal) {
            if (!newVal) {
                this.activeIndex = null;
            }
        }
    }
});

/***/ }),

/***/ "qy8p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rEFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'qrcode',
    data: function data() {
        return {
            isShow: false
        };
    }
});

/***/ }),

/***/ "rsWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sCmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formValidation_js__ = __webpack_require__("AdV3");
// @charset "utf-8";
/*
 * 点击元素外面触发事件
 * e.g. <input
            ref="question_cycle_input"
            v-validate="{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice'}"
            >

        <input
            ref="question_sentence_input"
            v-validate="{ type: 'string', max: 200, min: 1, errClass: 'question_sentence_input focus', errRef: 'sentenceNotice'}"
            >
 *
 */



var nodeList = [];

var ctx = 'vue_validate'; // 同命名空间的意思

/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function bind(el, binding, vnode) {
        var id = nodeList.push(el) - 1;
        var validateData = binding.value;
        el.oldClassName = el.className;
        el[ctx] = { id: id
            // 保证只验证当前el
        };el.validate = function () {
            nodeList.forEach(function (node) {
                if (node[ctx].id !== el[ctx].id) {
                    node.validateHandle(true);
                }
            });
            return el.validateHandle();
        };
        el.validateHandle = function (skipValidate) {
            if (skipValidate) {
                el.successHandle();
                return true;
            }
            var type = validateData.type;
            var value = el.value ? el.value : el.text ? el.text : '';
            var ret = void 0;
            switch (type) {
                case 'string':
                    // 字符验证
                    ret = Object(__WEBPACK_IMPORTED_MODULE_0__lib_formValidation_js__["d" /* questionVal */])(value, validateData.max, validateData.min);
                    break;

                case 'number':
                    ret = Object(__WEBPACK_IMPORTED_MODULE_0__lib_formValidation_js__["c" /* profitLossVal */])(value);
                    break;

                case 'period':
                    // 持股周期
                    ret = Object(__WEBPACK_IMPORTED_MODULE_0__lib_formValidation_js__["b" /* numberDays */])(value, validateData.isGt1);
                    break;

                case 'default':
                    break;
            }
            if (ret) {
                el.successHandle();
                return true;
            } else {
                el.failHandle();
                return false;
            }
        };

        el.successHandle = function () {
            el.className = el.oldClassName;

            if (validateData.errRef !== undefined) {
                vnode.context.$refs[validateData.errRef].style.display = 'none';
            }
        };

        el.failHandle = function () {
            el.focus();
            // 错误时样式
            if (validateData.errClass !== undefined) {
                el.className = validateData.errClass;
            }

            // 错误时其他dom控制显隐
            if (validateData.errRef !== undefined) {
                vnode.context.$refs[validateData.errRef].style.display = 'block';
            }
        };
    },
    update: function update(el, binding) {},
    unbind: function unbind(el) {
        var len = nodeList.length;

        for (var i = 0; i < len; i++) {
            if (nodeList[i][ctx].id === el[ctx].id) {
                nodeList.splice(i, 1);
                break;
            }
        }
    }
});

/***/ }),

/***/ "sQby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-evaluation"},[_c('div',{staticClass:"event-question"},[_c('div',{staticClass:"question_main"},[_c('div',{staticClass:"question_title fl"},[_c('div',{staticClass:"item-title"},[_c('p',{staticClass:"normal fl"},[_vm._v("请输入您想要回测的事件：  ")]),_vm._v(" "),_c('p',{ref:"sentenceNotice",staticClass:"highlight fl",staticStyle:{"display":"none"}},[_vm._v("事件不能为空!")])]),_vm._v(" "),_c('div',{staticClass:"item-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sentence),expression:"sentence"},{name:"validate",rawName:"v-validate",value:({type: 'string', max: 200, min: 1, errClass:'question_sentence_input focus', errRef: 'sentenceNotice'}),expression:"{type: 'string', max: 200, min: 1, errClass:'question_sentence_input focus', errRef: 'sentenceNotice'}"}],ref:"question_sentence_input",staticClass:"question_sentence_input",attrs:{"type":"text","placeholder":"请输入回测事件"},domProps:{"value":(_vm.sentence)},on:{"keyup":[function($event){return _vm.questionDataValidation($event.target, 1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"blur":function($event){return _vm.questionDataValidation($event.target, 0)},"input":function($event){if($event.target.composing){ return; }_vm.sentence=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"question_sentence fl"},[_c('div',{staticClass:"item-title"},[_c('p',{staticClass:"normal fl"},[_vm._v("对应标的：  ")]),_vm._v(" "),_c('p',{ref:"standardNotice",staticClass:"highlight fl",staticStyle:{"display":"none"}},[_vm._v("标的不能为空！")])]),_vm._v(" "),_c('div',{staticClass:"item-input",staticStyle:{"position":"relative"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.refZhishu),expression:"refZhishu",modifiers:{"trim":true}},{name:"validate",rawName:"v-validate",value:({type: 'string', max: 200, min: 1, errClass:'question_sentence_input standard focus', errRef: 'standardNotice'}),expression:"{type: 'string', max: 200, min: 1, errClass:'question_sentence_input standard focus', errRef: 'standardNotice'}"}],ref:"question_sentence_input_1",staticClass:"question_sentence_input standard",attrs:{"type":"text","placeholder":"请输入对应标的"},domProps:{"value":(_vm.refZhishu)},on:{"keyup":[function($event){return _vm.debounceSearchSharesFlag($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"blur":[_vm.buriedPoints,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.refZhishu=$event.target.value.trim()}}}),_vm._v(" "),(_vm.isshowflaglist)?_c('key-list',{attrs:{"list-visible":_vm.isshowflaglist,"list-data":_vm.sharesFlagList,"parse-item":_vm.parseItem,"value-key":"label"},on:{"update:listVisible":function($event){_vm.isshowflaglist=$event},"update:list-visible":function($event){_vm.isshowflaglist=$event},"click-item":_vm.updateInput,"select-item":_vm.updateInput,"no-checked":_vm.nochecked}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"question_cycle"},[_c('p',{staticClass:"fl"},[_vm._v("您要看历史上事件发生后几天的情况：  ")]),_vm._v(" "),_c('p',{ref:"numberNotice",staticClass:"fl",staticStyle:{"display":"none"}},[_vm._v("请正确输入正数，可用英文状态下 \",\" 分隔天数")])]),_vm._v(" "),_c('div',{staticClass:"question_cycle_number"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"},{name:"validate",rawName:"v-validate",value:({ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice'}),expression:"{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice'}"}],ref:"question_cycle_input",staticClass:"question_cycle_input",attrs:{"type":"text"},domProps:{"value":(_vm.number)},on:{"blur":_vm.questionCyclePoint,"keyup":[_vm.validateInput,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("  天")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sd-toolbar"},[_c('div',{staticClass:"sd-toolbar_operabox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeStartDate),expression:"tradeStartDate"}],staticClass:"trade_detail_startDate",attrs:{"id":"trade_detail_startDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeStartDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, '#F{$dp.$D(\'trade_detail_endDate\')}', '2000-1-1')},"blur":_vm.startDatePoint,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeStartDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"time-split"},[_vm._v(" 至 ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tradeEndDate),expression:"tradeEndDate"}],staticClass:"trade_detail_endDate",attrs:{"id":"trade_detail_endDate","type":"text","readonly":"readonly"},domProps:{"value":(_vm.tradeEndDate)},on:{"click":function($event){_vm.showTradeDateDialog($event, _vm.yesterdayDate, '#F{$dp.$D(\'trade_detail_startDate\')}')},"blur":_vm.endDatePoint,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.startBacktest.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.tradeEndDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"beginbacktest-s"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isbacktestdoneshow),expression:"isbacktestdoneshow"}]},[_vm._v("回测运行完成 !")]),_vm._v(" "),(!_vm.defaultqueryLoading)?_c('div',{staticClass:"beginbacktest",on:{"click":_vm.startBacktest}},[_vm._v(_vm._s(_vm.backtestText ? '启动回测' : '再次回测'))]):_vm._e()])])]),_vm._v(" "),(_vm.isreportgradeshow)?_c('div',{staticClass:"report_grade"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"report_grade_main"},[_c('div',{staticClass:"history_happen"},[_c('p',[_vm._v("历史发生次数")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.historyCount)+" 次")])]),_vm._v(" "),_c('div',{staticClass:"average_rise_fall"},[_c('p',[_vm._v("最优平均涨跌幅")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.averageRiseFall)))])]),_vm._v(" "),_c('div',{staticClass:"max_win_rise"},[_c('p',[_vm._v("最大上涨概率")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("safePercentFixedTwo")(_vm.riseProbability)))])])])]):_vm._e(),_vm._v(" "),(_vm.iseventlistshow)?_c('div',{staticClass:"event-list"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"event-list_main"},[_c('table',{attrs:{"cellspacing":"0"}},[_c('thead',[_c('tr',_vm._l((_vm.eventTitleList),function(item,index){return _c('th',{key:index,style:({width: 100 / Object.keys(_vm.eventTitleList).length + '%'})},[_vm._v(_vm._s(item))])}),0)])]),_vm._v(" "),_c('EasyScrollbar',{attrs:{"barOption":_vm.myBarOption}},[_c('div',{staticClass:"rolltable"},[_c('table',{attrs:{"cellspacing":"0"}},[_c('tbody',_vm._l((_vm.eventDataList),function(event,index){return _c('tr',{key:index,class:(index + 1) % 2 === 0 ? 'gray' : ''},_vm._l((_vm.eventDataList[index]),function(item,key){return _c('td',{key:key,class:_vm._f("eventFallClass")(item),style:({width : 100 / Object.keys(_vm.eventDataList[index]).length + '%'})},[_vm._v(_vm._s(_vm._f("eventNumberFixed")(item)))])}),0)}),0)])])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hotbacktest"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"hotbacktest_main"},[_c('div',{staticClass:"hotbacktest_left"},_vm._l((_vm.leftRecommandBacktest),function(item,key){return _c('div',{key:'er' + key,staticClass:"hotbacktest_name"},[_c('p',{attrs:{"title":item.query}},[_vm._v(_vm._s(item.query))]),_vm._v(" "),_c('a',{attrs:{"href":'#/eventevaluation?query=' + encodeURIComponent(item.query)}},[_c('span',{on:{"click":_vm.hotBacktestPoint}},[_vm._v("回测一下")])])])}),0),_vm._v(" "),_c('div',{staticClass:"hotbacktest_right"},_vm._l((_vm.rightRecommandBacktest),function(item,key){return _c('div',{key:'er' + key,staticClass:"hotbacktest_name"},[_c('p',{attrs:{"title":item.query}},[_vm._v(_vm._s(item.query))]),_vm._v(" "),_c('a',{attrs:{"href":'#/eventevaluation?query=' + encodeURIComponent(item.query)}},[_c('span',{on:{"click":_vm.hotBacktestPoint}},[_vm._v("回测一下")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowtestloading),expression:"isshowtestloading"}],staticClass:"testmain"},[_c('div',{staticClass:"testshadow"}),_vm._v(" "),_vm._m(4)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question_section"},[_c('p',{staticClass:"fl"},[_vm._v("您要看历史上多少时间范围内的情况：  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report_grade_title"},[_c('p',[_vm._v("报告评级")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-list_title"},[_c('p',[_vm._v("事件列表 ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotbacktest_title"},[_c('p',[_vm._v("热门回测")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testparallel"},[_c('div',{staticClass:"test-loading"},[_c('span',{staticClass:"testing-icon"}),_vm._v(" "),_c('span',[_vm._v("正在为您计算，请耐心等待……")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "seP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"745px","height":"346px","margin-left":"33px","float":"left"},attrs:{"id":"cumulative_income_chart"}},[_c('div',{ref:"chartRef",staticStyle:{"width":"100%","height":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t4/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_send_discuss_vue__ = __webpack_require__("YHT4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326ad450_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_send_discuss_vue__ = __webpack_require__("V9Hk");
function injectStyle (ssrContext) {
  __webpack_require__("vwH2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-326ad450"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_send_discuss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326ad450_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_send_discuss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tRtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),

/***/ "tXmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__ = __webpack_require__("RarY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_exportCsv_js__ = __webpack_require__("2Eis");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__("Q0Ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_quoteChartVue_js__ = __webpack_require__("lJCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-new */







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        // 回测id
        backtestId: {
            type: String,
            required: true
        },
        // 周期
        period: {
            type: String,
            required: true
        },
        // 回测日期最大值
        maxDate: {
            type: String,
            required: true
        },
        // 回测日期最小值
        minDate: {
            type: String,
            required: true
        },
        // 滚动条配置
        myBarOption: {
            type: Object,
            required: true
        },
        // 周期可选值
        dayselect: {
            type: Array,
            required: true
        },
        refresh: Boolean
    },
    data: function data() {
        var self = this;
        var debounceShowQuoteChart = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["debounce"])(function () {
            // 鼠标还停留在dom上
            if (arguments[0].target.contains(self.$mousemoveEvent.target)) {
                self.showQuoteChart.apply(self, arguments);
            }
        }, 1000);

        return {
            debounceShowQuoteChart: debounceShowQuoteChart,
            tradeStartDate: '',
            tradeEndDate: '',
            currentday: '',
            historyarr: [],
            inited: false
        };
    },

    computed: {
        historyList: function historyList() {
            return this.filterHistory(this.historyarr.slice(0, 300));
        },
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.backtestOnce.history;
        }
    },
    methods: {
        hideQuoteChart: function hideQuoteChart(item) {
            var code = item.stock_market.toLowerCase() + '_' + item.stock_code;
            __WEBPACK_IMPORTED_MODULE_4__lib_quoteChartVue_js__["a" /* default */].hide(code);
        },
        showQuoteChart: function showQuoteChart(event, item) {
            var DOMRect = event.srcElement.getBoundingClientRect();
            var code = item.stock_market.toLowerCase() + '_' + item.stock_code;
            Object(__WEBPACK_IMPORTED_MODULE_4__lib_quoteChartVue_js__["a" /* default */])({
                code: code,
                top: DOMRect.top,
                left: DOMRect.right - 30
            });
        },
        dataToCsvStr: function dataToCsvStr(historyList) {
            var csvStr = '';
            historyList.forEach(function (item) {
                csvStr += '\'' + item.stock_code + ',' + item.stock_name + ',' + item.start_date + ',' + item.end_date + ',' + item.start_price + ',' + item.end_price + ',' + Object(__WEBPACK_IMPORTED_MODULE_3__filters__["safeFloatPerFixedTwo"])(item.change_rate) + '\n';
            });
            return csvStr;
        },
        getFileName: function getFileName() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            var second = date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds();
            var filename = '' + year + month + day + hour + minute + second;
            return filename;
        },
        filterHistory: function filterHistory(arr) {
            var self = this;
            return arr.filter(function (item) {
                return Number(item.start_date) >= self.dateToNumber(self.tradeStartDate) && item.start_date <= self.dateToNumber(self.tradeEndDate);
            });
        },
        exportHistory: function exportHistory() {
            var tableStr = '';
            var titleStr = '股票代码,股票简称,起始时间,终止时间,起始价,终止价,区间涨跌幅';
            var filename = this.getFileName();

            var historyList = this.filterHistory(this.historyarr);

            tableStr = this.currentday + '天\n' + titleStr + '\n' + this.dataToCsvStr(historyList);
            Object(__WEBPACK_IMPORTED_MODULE_2__lib_exportCsv_js__["a" /* default */])(tableStr, filename);

            window.TA.log(this.buriedPoint.export);
        },
        startDatePoint: function startDatePoint() {
            window.TA.log(this.buriedPoint.startDate);
        },
        endDatePoint: function endDatePoint() {
            window.TA.log(this.buriedPoint.endDate);
        },
        daySelects: function daySelects() {
            window.TA.log(this.buriedPoint.cycleOption);
        },
        dateToNumber: function dateToNumber(date) {
            return Number(date.replace(/-/g, ''));
        },

        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        gethistorydetail: function gethistorydetail() {
            var self = this;
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/backtestonce/historydetail?sort_by=desc', {
                params: {
                    id: this.backtestId,
                    start_date: this.tradeStartDate,
                    end_date: this.tradeEndDate,
                    period: Number(this.currentday)
                }
            }).then(function (res) {
                if (res.data.result instanceof Array) {
                    self.historyarr = res.data.result;
                } else {
                    self.historyarr = [];
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        }
    },
    watch: {
        backtestId: function backtestId() {
            if (!this.inited) {
                return;
            }
            this.gethistorydetail();
        },
        currentday: function currentday() {
            if (!this.inited) {
                return;
            }
            this.gethistorydetail();
        },
        period: function period() {
            this.currentday = this.period;
        },
        maxDate: function maxDate() {
            this.tradeEndDate = this.maxDate;
        },
        minDate: function minDate() {
            this.tradeStartDate = this.minDate;
        },
        refresh: function refresh() {
            this.currentday = this.period;
        }
    },
    created: function created() {
        this.currentday = this.period;
        this.tradeStartDate = this.minDate;
        this.tradeEndDate = this.maxDate;
    },
    mounted: function mounted() {
        var _this = this;

        this.gethistorydetail().finally(function () {
            _this.inited = true;
        });
    }
});

/***/ }),

/***/ "tbC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__ = __webpack_require__("tXmx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a972912_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("7j7f");
function injectStyle (ssrContext) {
  __webpack_require__("B4ZY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a972912"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a972912_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tbID":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ty6Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_wDatePicker_js__ = __webpack_require__("RarY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_key_list__ = __webpack_require__("c71g");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-new */





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'eventevaluation',
    components: {
        'key-list': __WEBPACK_IMPORTED_MODULE_7__lib_key_list__["a" /* default */]
    },
    data: function data() {
        var yesDate = this._getNowDate();
        var self = this;
        var debounceSearchSharesFlag = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["debounce"])(function () {
            self.searchSharesFlag.apply(self, arguments);
        }, 500);
        return {
            debounceSearchSharesFlag: debounceSearchSharesFlag,
            myBarOption: {
                barWidth: 9, // 滚动条宽度
                barMarginRight: 3 // 垂直滚动条距离整个容器右侧距离单位
            },
            backtestText: true,
            recommandBacktest: [],
            defaultQuery: {},
            defaultqueryLoading: true,
            sentence: '',
            defaultRefZhishu: '',
            refZhishu: '',
            number: '',
            tradeStartDate: '',
            tradeEndDate: '',
            yesterdayDate: yesDate,
            eventDataList: [],
            eventTitleList: [],
            sharesFlagList: [],
            historyCount: '',
            averageRiseFall: '',
            riseProbability: '',
            iseventlistshow: false,
            isbacktestdoneshow: false,
            isreportgradeshow: false,
            isshowflaglist: false,
            isshowtestloading: false,
            filterKey: [37, 38, 39, 40, 13],
            paramKeys: {
                'query': 'sentence',
                'refZhishu': 'refZhishu',
                'daysForSaleStrategy': 'number',
                'endDate': 'tradeEndDate',
                'startDate': 'tradeStartDate'
            }
        };
    },

    computed: {
        buriedPoint: function buriedPoint() {
            return this.$buriedPoint.eventEvaluation;
        },
        totalPoint: function totalPoint() {
            return this.$buriedPoint.totalPlatformAccess;
        },
        leftRecommandBacktest: function leftRecommandBacktest() {
            var data = [];
            this.recommandBacktest.forEach(function (item, key) {
                if (key % 2 === 0) {
                    data.push(item);
                }
            });
            return data;
        },
        rightRecommandBacktest: function rightRecommandBacktest() {
            var data = [];
            this.recommandBacktest.forEach(function (item, key) {
                if (key % 2 === 1) {
                    data.push(item);
                }
            });
            return data;
        }
    },
    methods: {
        validateInput: function validateInput() {
            this.number = this.number.replace(/，/, ',');
        },
        parseItem: function parseItem(item) {
            return item.code + ' ' + item.name;
        },
        hotBacktestPoint: function hotBacktestPoint() {
            window.TA.log({ id: this.buriedPoint.hotBacktest, _sid: '__ths_003' });
        },
        startDatePoint: function startDatePoint() {
            window.TA.log(this.buriedPoint.startDate);
        },
        endDatePoint: function endDatePoint() {
            window.TA.log(this.buriedPoint.endDate);
        },
        questionCyclePoint: function questionCyclePoint() {
            window.TA.log(this.buriedPoint.holdingCycle);
        },
        buriedPoints: function buriedPoints() {
            window.TA.log(this.buriedPoint.modifySubject);
        },

        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_4__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        questionDataValidation: function questionDataValidation(even, num) {
            var val = even.value;
            if (this.sentence.length > 200) {
                this.sentence = val.substr(0, 200);
            }
            if (num === 0) {
                window.TA.log(this.buriedPoint.modifyQuestion);
            }
        },
        _getNowDate: function _getNowDate() {
            var now = new Date();
            now.setDate(now.getDate() - 1); // 获取昨天时间
            var month = now.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
            var nowDate = now.getFullYear() + '-' + month + '-' + date;
            return nowDate;
        },
        requestSpellSearch: function requestSpellSearch() {
            var spell = this.refZhishu.split(' ')[0];
            return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/eventbacktest/spellsearch?query=' + spell).then(function (res) {
                return res.data.result;
            });
        },
        searchSharesFlag: function searchSharesFlag(event) {
            var _this = this;

            var self = this;
            if (!this.refZhishu) {
                return false;
            } else {
                if (this.filterKey.indexOf(event.keyCode) > -1) {
                    return;
                }

                this.requestSpellSearch().then(function (data) {
                    _this.sharesFlagList = data.map(function (item) {
                        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item, { label: _this.parseItem(item) });
                    });
                    if (_this.sharesFlagList.length === 0) {
                        _this.isshowflaglist = false;
                    } else {
                        _this.isshowflaglist = true;
                    }

                    _this.defaultRefZhishu = _this.refZhishu;
                }).catch(function (error) {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            }
        },
        updateInput: function updateInput(item) {
            this.refZhishu = this.parseItem(item);
        },
        nochecked: function nochecked() {
            this.refZhishu = this.defaultRefZhishu;
        },
        sortNumber: function sortNumber(a, b) {
            return a - b;
        },
        startBacktest: function startBacktest() {
            var _this2 = this;

            if (this.isshowflaglist) {
                this.isshowflaglist = false;
                return;
            }
            window.TA.log(this.buriedPoint.startUpBacktest);
            var self = this;
            this.$nextTick(function () {
                if (!_this2.$refs.question_sentence_input.validate() || !_this2.$refs.question_sentence_input_1.validate() || !_this2.$refs.question_cycle_input.validate()) {
                    return;
                }
                _this2.isshowtestloading = true;

                _this2.requestSpellSearch().then(function (data) {
                    if (data.length === 0) {
                        self.$tip({
                            message: '对应标的错误',
                            duration: 2000,
                            type: 'error'
                        });
                        _this2.isshowtestloading = false;
                    } else {
                        _this2.defaultRefZhishu = _this2.parseItem(data[0]);
                        _this2.refZhishu = _this2.defaultRefZhishu;
                        var indexCode = data[0]['code'];

                        var numberArry = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(self.number.split(',').sort(_this2.sortNumber)));
                        self.number = numberArry.join(',');
                        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/eventbacktest/backtest', {
                            query: _this2.sentence,
                            period: self.number,
                            start_date: _this2.tradeStartDate,
                            end_date: _this2.tradeEndDate,
                            index_code: indexCode
                        }).then(function (res) {
                            return res.data;
                        }).then(function (data) {
                            if (data.errorcode) {
                                throw Error(data.errormsg);
                            } else {
                                _this2.iseventlistshow = true;
                                _this2.isbacktestdoneshow = true;
                                _this2.isreportgradeshow = true;
                                _this2.backtestText = false;
                                _this2.isshowtestloading = false;
                                _this2.eventTitleList = data.result.title;
                                _this2.eventDataList = data.result.data;
                                _this2.historyCount = data.result.reportData.maxTotalCount;
                                _this2.averageRiseFall = data.result.reportData.maxChangeRate;
                                _this2.riseProbability = data.result.reportData.maxWinRate;

                                location.hash = '#/eventevaluation?query=' + encodeURIComponent(_this2.sentence) + '&refZhishu=' + encodeURIComponent(_this2.refZhishu) + '&daysForSaleStrategy=' + _this2.number + '&startDate=' + _this2.tradeStartDate + '&endDate=' + _this2.tradeEndDate;
                            }
                        }).catch(function (error) {
                            self.iseventlistshow = false;
                            self.isbacktestdoneshow = false;
                            self.isreportgradeshow = false;
                            self.backtestText = true;
                            self.isshowtestloading = false;
                            self.$tip({
                                message: error ? error.message : '网络异常',
                                duration: 2000,
                                type: 'error'
                            });
                        });
                    }
                }).catch(function (error) {
                    this.isshowtestloading = false;
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    });
                });
            });
        },
        startBacktestByRoute: function startBacktestByRoute(routeParam) {
            var self = this;
            var hasChanged = false;
            for (var key in this.paramKeys) {
                if (routeParam.hasOwnProperty(key) && routeParam[key] !== '' && self[self.paramKeys[key]] !== routeParam[key]) {
                    self[self.paramKeys[key]] = routeParam[key];
                    hasChanged = true;
                }
            }

            if (!self.isreportgradeshow || hasChanged) {
                this.startBacktest();
            }
        },

        // __scrollBar__ () {
        //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
        //         window.TA.log(this.buriedPoint.scrollBar)
        //     }
        // },
        initParams: function initParams() {
            if (this.defaultQuery) {
                this.number = this.defaultQuery.daysForSaleStrategy;
                this.sentence = this.defaultQuery.query;
                this.refZhishu = this.defaultQuery.refZhishu;
                this.tradeStartDate = this.defaultQuery.startDate;
                this.tradeEndDate = this.defaultQuery.endDate;
            } else {
                this.number = '';
                this.sentence = '';
                this.refZhishu = '';
                this.tradeStartDate = '';
                this.tradeEndDate = '';
            }
        }
    },
    // beforeDestroy () {
    //     window.removeEventListener('scroll', this.__scrollBar__)
    // },
    activated: function activated() {
        var self = this;
        // window.addEventListener('scroll', self.__scrollBar__)
        window.TA.log({ id: self.buriedPoint.pageAccess, _sid: '__ths_001' });
        window.TA.log({ id: self.totalPoint, _sid: '__ths_002' });
    },
    deactivated: function deactivated() {
        // 重置初始化状态
        this.initParams();
        this.backtestText = true;
        this.eventDataList = [];
        this.eventTitleList = [];
        this.sharesFlagList = [];
        this.historyCount = '';
        this.averageRiseFall = '';
        this.riseProbability = '';
        this.iseventlistshow = false;
        this.isbacktestdoneshow = false;
        this.isreportgradeshow = false;
        this.isshowflaglist = false;
        this.isshowtestloading = false;

        this.$refs.question_sentence_input.className = 'question_sentence_input';
        this.$refs.question_sentence_input_1.className = 'question_sentence_input standard';
        this.$refs.question_cycle_input.className = 'question_cycle_input';
        this.$refs.sentenceNotice.style.display = 'none';
        this.$refs.standardNotice.style.display = 'none';
        this.$refs.numberNotice.style.display = 'none';
    },
    mounted: function mounted() {
        var self = this;
        document.body.addEventListener('click', function () {
            self.isshowflaglist = false;
        });
        this.defaultqueryLoading = true;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/backtestonce/defaultquery?type=3').then(function (res) {
            if (res.data.result) {
                self.defaultQuery = res.data.result;
                self.initParams();
            }

            self.defaultqueryLoading = false;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.$route.query) !== '{}') {
                self.startBacktestByRoute(self.$route.query);
            }
        }).catch(function (error) {
            self.defaultqueryLoading = false;
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });

        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/backtestonce/backtestexample?num=10&type=eventbacktest').then(function (res) {
            self.recommandBacktest = res.data.result;
        }).catch(function (error) {
            self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
        });
    },

    watch: {
        '$route': function $route(newRoute, oldRoute) {
            if (this.defaultqueryLoading) {
                return;
            }

            if (newRoute.name === 'eventevaluation') {
                var params = newRoute.query;
                if (newRoute.name === oldRoute.name) {
                    this.startBacktestByRoute(params);
                } else {
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params) !== '{}') {
                        this.startBacktestByRoute(params);
                    }
                }
            }
        }
    }
});

/***/ }),

/***/ "uhBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Pager',
    data: function data() {
        return {
            current: null,
            showPrevMore: false,
            showNextMore: false,
            quicknextIconClass: 'el-icon-more',
            quickprevIconClass: 'el-icon-more'
        };
    },
    props: {
        currentPage: Number,
        pageCount: Number
    },

    watch: {
        showPrevMore: function showPrevMore(val) {
            if (!val) this.quickprevIconClass = 'el-icon-more';
        },

        showNextMore: function showNextMore(val) {
            if (!val) this.quicknextIconClass = 'el-icon-more';
        }
    },

    computed: {
        pagers: function pagers() {
            var pagerCount = 7;

            var currentPage = Number(this.currentPage);
            var pageCount = Number(this.pageCount);

            var showPrevMore = false;
            var showNextMore = false;

            if (pageCount > pagerCount) {
                if (currentPage > pagerCount - 3) {
                    showPrevMore = true;
                }

                if (currentPage < pageCount - 3) {
                    showNextMore = true;
                }
            }

            var array = [];
            var i;
            if (showPrevMore && !showNextMore) {
                var startPage = pageCount - (pagerCount - 2);
                for (i = startPage; i < pageCount; i++) {
                    array.push(i);
                }
            } else if (!showPrevMore && showNextMore) {
                for (i = 2; i < pagerCount; i++) {
                    array.push(i);
                }
            } else if (showPrevMore && showNextMore) {
                var offset = Math.floor(pagerCount / 2) - 1;
                for (i = currentPage - offset; i <= currentPage + offset; i++) {
                    array.push(i);
                }
            } else {
                for (i = 2; i < pageCount; i++) {
                    array.push(i);
                }
            }

            this.showPrevMore = showPrevMore;
            this.showNextMore = showNextMore;

            return array;
        }
    },

    methods: {
        onPagerClick: function onPagerClick(event) {
            var target = event.target;
            if (target.tagName === 'UL') {
                return;
            }

            var newPage = Number(event.target.textContent);
            var pageCount = this.pageCount;
            var currentPage = this.currentPage;

            if (target.className.indexOf('more') !== -1) {
                if (target.className.indexOf('quickprev') !== -1) {
                    newPage = currentPage - 5;
                } else if (target.className.indexOf('quicknext') !== -1) {
                    newPage = currentPage + 5;
                }
            }

            /* istanbul ignore if */
            if (!isNaN(newPage)) {
                if (newPage < 1) {
                    newPage = 1;
                }

                if (newPage > pageCount) {
                    newPage = pageCount;
                }
            }

            if (newPage !== currentPage) {
                this.$emit('change', newPage);
            }
        }
    }
});

/***/ }),

/***/ "vEzN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vFYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__ = __webpack_require__("RarY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_quoteChartVue_js__ = __webpack_require__("lJCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var self = this;
        var debounceShowQuoteChart = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["debounce"])(function () {
            // 鼠标还停留在dom上
            if (arguments[0].target.contains(self.$mousemoveEvent.target)) {
                self.showQuoteChart.apply(self, arguments);
            }
        }, 1000);
        return {
            debounceShowQuoteChart: debounceShowQuoteChart,
            myBarOption: {
                // barColor: '#f60', // 滚动条颜色
                barWidth: 9, // 滚动条宽度
                // railColor: '#f5f5f5', // 导航颜色
                barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                // zIndex: 'auto', // 滚动条的z-index
                // autohidemode: true, // 自动隐藏模式
                horizrailenabled: false // 是否显示水平滚动条
            },
            pickDate: null,
            pickStock: null,
            detailContent: '',
            backtestContent: ''
        };
    },

    computed: {
        maxDate: function maxDate() {
            return this.pickStock ? this.pickStock.maxDate : null;
        },
        position: function position() {
            if (this.pickStock === null) {
                return '';
            }
            if (Number(this.transactiontype) !== 2) {
                return '满仓';
            } else if (this.pickStock.market === null) {
                return '--';
            } else if (this.pickStock.market > 0) {
                return '满仓';
            } else if (this.buyPosition === 100) {
                return '满仓';
            } else if (this.buyPosition === 0) {
                return '空仓';
            } else {
                return this.buyPosition + '%仓位';
            }
        },
        classComputedName: function classComputedName() {
            var className = {};
            className[this.classname] = true;
            return className;
        }
    },
    props: {
        strategyId: String,
        showPick: {
            type: Boolean,
            default: false
        },
        selectData: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        transactiontype: String,
        buyPosition: {
            type: Number,
            default: function _default() {
                return null;
            }
        },
        classname: {
            type: String,
            default: function _default() {
                return 'strategy_select';
            }
        },
        query: String,
        hold: String
    },
    methods: {
        hideQuoteChart: function hideQuoteChart(item) {
            __WEBPACK_IMPORTED_MODULE_2__lib_quoteChartVue_js__["a" /* default */].hide(item.stock_market.toLowerCase() + '_' + item.stock_code);
        },
        showQuoteChart: function showQuoteChart(event, item) {
            var DOMRect = event.srcElement.getBoundingClientRect();
            Object(__WEBPACK_IMPORTED_MODULE_2__lib_quoteChartVue_js__["a" /* default */])({
                code: item.stock_market.toLowerCase() + '_' + item.stock_code,
                top: DOMRect.top,
                left: DOMRect.right - 10
            });
        },

        showTradeDateDialog: __WEBPACK_IMPORTED_MODULE_1__lib_wDatePicker_js__["a" /* showTradeDateDialog */],
        requestHistoryPick: function requestHistoryPick() {
            var params = {
                query: this.query,
                hold_num: this.hold,
                trade_date: this.pickDate,
                menv: this.pickStock.menv
            };
            var self = this;
            if (document.getElementsByClassName('strategydetailmain')[0]) {
                window.TA.log(this.$buriedPoint.strategyDetails.pickStockDate.replace('_square', '_square_' + this.strategyId));
            } else {
                window.TA.log(this.$buriedPoint.strategyBacktest.pickStockDate);
            }
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/tradebacktest/historypick', { params: params }).then(function (res) {
                if (res.data.errorcode === 0) {
                    self.pickStock = res.data.result;
                }
            }).catch(function (error) {
                self.$tip({ message: error ? error.message : '网络异常', duration: 2000, type: 'error' });
            });
        }
    },
    created: function created() {
        this.pickDate = this.selectData !== null ? this.selectData.date : null;
        this.pickStock = this.selectData;
    },

    watch: {
        selectData: function selectData() {
            this.pickDate = this.selectData !== null ? this.selectData.date : null;
            this.pickStock = this.selectData;
        },
        pickDate: function pickDate(newVal, oldVal) {
            if (oldVal !== null) {
                this.requestHistoryPick();
            }
        }
    }
});

/***/ }),

/***/ "vIEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: {
            type: String,
            default: 'default' // default blue orange
        },
        size: {
            type: String,
            default: 'medium' // large medium small
        },
        loading: Boolean,
        disabled: Boolean
    },
    data: function data() {
        return {};
    },
    methods: {
        handleClick: function handleClick(evt) {
            if (!this.loading) {
                this.$emit('click', evt);
            }
        }
    }
});

/***/ }),

/***/ "vwH2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wC/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategy_select_vue__ = __webpack_require__("vFYq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca09ec6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategy_select_vue__ = __webpack_require__("ksvH");
function injectStyle (ssrContext) {
  __webpack_require__("qjqP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ca09ec6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategy_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca09ec6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategy_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wP0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feedback_vue__ = __webpack_require__("53yQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf6e84bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feedback_vue__ = __webpack_require__("cvfg");
function injectStyle (ssrContext) {
  __webpack_require__("czPP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf6e84bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf6e84bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wYTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wn+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("WTOt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66b31c86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FdYl");
function injectStyle (ssrContext) {
  __webpack_require__("HY8Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66b31c86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66b31c86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wy+K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x5JV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"quotechart-fade"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"},{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"modal-mask quotechart-main",style:({ top: _vm.top - _vm.arrowTop + 'px', left: _vm.left + 'px' }),on:{"mouseleave":_vm.mouseleave,"mouseenter":_vm.mouseenter}},[_c('div',{staticClass:"arrow",style:({ top: _vm.arrowTop + 'px' })}),_vm._v(" "),_c('div',{staticStyle:{"height":"90px","font-size":"12px"},attrs:{"id":_vm.realheadId}}),_vm._v(" "),_c('div',{staticClass:"chart-type"},[_c('a',{staticClass:"chart-type-item",class:_vm.type === 'fs' ? 'active' : '',on:{"click":function($event){_vm.type = 'fs'}}},[_vm._v("分时")]),_vm._v(" "),_c('a',{staticClass:"chart-type-item",class:_vm.type === 'daykline' ? 'active' : '',on:{"click":function($event){_vm.type = 'daykline'}}},[_vm._v("日线")]),_vm._v(" "),_c('a',{staticClass:"chart-type-item",class:_vm.type === 'weekkline' ? 'active' : '',on:{"click":function($event){_vm.type = 'weekkline'}}},[_vm._v("周线")]),_vm._v(" "),_c('a',{staticClass:"chart-type-item",class:_vm.type === 'monthkline' ? 'active' : '',on:{"click":function($event){_vm.type = 'monthkline'}}},[_vm._v("月线")])]),_vm._v(" "),_c('div',{staticClass:"chart-main",attrs:{"id":_vm.elementId}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_header__ = __webpack_require__("Mitt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_footer__ = __webpack_require__("SKcX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */


// import io from 'socket.io-client'

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            topActiveStyle: {
                color: '#0a5db0'
            }
        };
    },

    components: {
        'header-nav': __WEBPACK_IMPORTED_MODULE_0__components_common_header__["a" /* default */],
        'footer-nav': __WEBPACK_IMPORTED_MODULE_1__components_common_footer__["a" /* default */]
    },
    // created () {
    //     const socket = io('/', {
    //         transports: [ 'websocket' ]
    //     })
    //     socket.emit('xxx', {xxx: 'xxx'})
    //     socket.on('news', function (data) {
    //         console.log(data)
    //     })
    // },
    computed: {
        userId: function userId() {
            return this.$store.getters['userInfo/userId'];
        },
        userName: function userName() {
            return this.$store.getters['userInfo/userName'];
        }
    },
    methods: {
        logout: function logout() {
            document.location.href = '//upass.10jqka.com.cn/logout?redir=' + document.location.href;
        },
        login: function login() {
            // ThsLogin.showLoginBox('//' + document.domain + '/reload.html')
            window.LoginInstance.show();
        }
    }
});

/***/ }),

/***/ "xoWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pager_vue__ = __webpack_require__("uhBV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cc5a88f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pager_vue__ = __webpack_require__("+qU3");
function injectStyle (ssrContext) {
  __webpack_require__("Z8My")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cc5a88f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cc5a88f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xpcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategydetail_vue__ = __webpack_require__("L8SC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26846f00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategydetail_vue__ = __webpack_require__("9n7l");
function injectStyle (ssrContext) {
  __webpack_require__("UBWs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26846f00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_strategydetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26846f00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_strategydetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yUH/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yxDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__("EGgr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfb59aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__ = __webpack_require__("8TXV");
function injectStyle (ssrContext) {
  __webpack_require__("A7Ym")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dfb59aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfb59aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zOTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receive-discuss"},[_c('div',{staticClass:"discuss-list"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchResult),expression:"isSearchResult"}]},[_vm._v("你还没有收到任何评论")]),_vm._v(" "),_c('vue-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshowloading),expression:"isshowloading"}],staticStyle:{"height":"calc(100% - 20px)","border":"none","top":"0","left":"0"}}),_vm._v(" "),_vm._l((_vm.discussDataList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSearchResult && !_vm.isshowloading),expression:"!isSearchResult && !isshowloading"}],key:index,staticClass:"list-item"},[_c('div',{staticClass:"item-left"},[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('div',{staticClass:"item-right"},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(item.content)}}),_vm._v(" "),_c('div',{staticClass:"item-mix"},[_c('div',{staticClass:"mix-left"},[_c('span',{staticStyle:{}},[_vm._v(_vm._s(item.ctime))]),_vm._v(" "),_c('span',{staticClass:"item-report",on:{"click":function($event){return _vm.commentReport(item.pid, item.cid, item.userid)}}},[_vm._v("举报")])]),_vm._v(" "),_c('div',{staticClass:"mix-right"},[_c('span',{staticClass:"item-like",on:{"click":function($event){return _vm.commentLikes(item.pid, item.cid, item)}}},[_vm._v("赞同("+_vm._s(item.likes)+")")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.isShowInputDiscuss(index)}}},[_vm._v(_vm._s(_vm.clickIndex !== index ? '回复' : '收起回复'))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.clickIndex === index && _vm.isshowinputdiscuss),expression:"clickIndex === index && isshowinputdiscuss"}],staticClass:"input-discuss"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputDiscuss),expression:"inputDiscuss"}],domProps:{"value":(_vm.inputDiscuss)},on:{"keyup":_vm.changeInput,"input":function($event){if($event.target.composing){ return; }_vm.inputDiscuss=$event.target.value}}}),_vm._v(" "),_c('button',{class:_vm.isdiscusscontent ? 'active' : '',on:{"click":function($event){return _vm.submitDiscuss(item.pid, item.userid, item.cid, item)}}},[_vm._v("回复")])])])})],2),_vm._v(" "),_c('div',{staticClass:"pagination-heart"},[_c('vue-pagination',{staticClass:"square-page",attrs:{"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.goPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.4b5e14e8b81738f99431.js